export const fr = {
  app: {
    home: 'Accueil',
    playerScout: 'Recherche de joueurs',
    playerComparison: 'Comparaison des joueurs',
    playerRecruitment: 'Radar',
    collections: 'Collections',
    favoritePlayers: 'Joueurs préférés',
    teamAnalytics: 'Analyse des équipes',
    gameAnalysis: 'Analyse des matchs',
    seasonStats: 'Saisons',
    leagueTable: 'Classement',
    scoresAndFixtures: 'Résultats',
    notifications: 'Notifications',
    administration: 'Administration',
    inbox: 'Boîte de réception ',
    teamStats: 'Statistiques de l\'équipe',
    blog: 'Blog',
    leagues: 'Leagues',
    squadBuilder: 'Squad Builder',
    playerAlerts: 'Player Alerts',
    searchAlerts: 'Search Alerts',
    videoUploadTool: 'Video Upload Tool',
    videoPlaylists: 'Playlists',
    uploadedGames: 'Uploaded games',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
    validateEvents: 'Valider les événements'
  },
  playerRecruitment: {
    title: 'Fiche du joueur',
    subtitle: 'Approfondir les caractéristiques et les statistiques du joueur',
    league: 'Ligue',
    selectedSeason: 'Saison sélectionnée',
    year: 'Année',
    radar: 'Radar',
    positions: 'Positions',
    numberOfPlayers: 'Nombre de joueurs',
    template: 'Modèle',
    compareWith: 'Comparer avec',
    previousPerformance: 'Performance précédente',
    xGames: '{0} matchs',
    average: 'Moyenne',
    leagueAverage: 'Moyenne de la ligue',
    selectSeason: 'Sélectionnez une saison',
    positionsPlayed: 'Postes occupés',
    minMax: 'Min & Max',
    top5Leagues: '5 grandes ligues',
    infoMessage: 'Ne sélectionner qu\'une seule saison pour permettre les Min & Max',
    infoMessage2: 'Sélectionnez la même saison pour les deux',
    dataPer90MinText: 'Données pour 90 minutes',
    adjustToPossessionText: '* Ajusté à la possession',
    text: 'Texte',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: 'Aucun match trouvé entre les dates sélectionnées',
    radarTemplates: {
      Goalkeeper: 'Gardien',
      GoalkeeperCustom: 'Gardien de but personnalisé',
      GoalkeeperCustom1: 'Gardien Personnalisé 1',
      GoalkeeperCustom2: 'Gardien Personnalisé 2',
      GoalkeeperCustom3: 'Gardien Personnalisé 3',
      GoalkeeperCustom4: 'Gardien Personnalisé 4',
      GoalkeeperCustom5: 'Gardien Personnalisé 5',
      GoalkeeperCustom6: 'Gardien Personnalisé 6',
      Defender: 'Défenseur',
      DefenderCustom: 'Défenseur personnalisé',
      DefenderCustom1: 'Défenseur Personnalisé 1',
      DefenderCustom2: 'Défenseur Personnalisé 2',
      DefenderCustom3: 'Défenseur Personnalisé 3',
      DefenderCustom4: 'Défenseur Personnalisé 4',
      DefenderCustom5: 'Défenseur Personnalisé 5',
      DefenderCustom6: 'Défenseur Personnalisé 6',
      FullBack: 'Arrière',
      FullBackCustom: 'Dos complet personnalisé',
      FullBackCustom1: 'Arrière Personnalisé 1',
      FullBackCustom2: 'Arrière Personnalisé 2',
      FullBackCustom3: 'Arrière Personnalisé 3',
      FullBackCustom4: 'Arrière Personnalisé 4',
      FullBackCustom5: 'Arrière Personnalisé 5',
      FullBackCustom6: 'Arrière Personnalisé 6',
      FullBackPredictive: 'Arrière',
      Midfielder: 'Milieu',
      MidfielderCustom: 'Milieu de terrain personnalisé',
      MidfielderCustom1: 'Milieu Personnalisé 1',
      MidfielderCustom2: 'Milieu Personnalisé 2',
      MidfielderCustom3: 'Milieu Personnalisé 3',
      MidfielderCustom4: 'Milieu Personnalisé 4',
      MidfielderCustom5: 'Milieu Personnalisé 5',
      MidfielderCustom6: 'Milieu Personnalisé 6',
      MidfielderPredictive: 'Milieu',
      MidfielderDefensive: 'Milieu Défensif',
      MidfielderOffensive: 'Milieu Offensif',
      AttackingMidfielder: 'Deuxième attaquant',
      MidfielderWing: 'Milieu Intérieur',
      Winger: 'Ailier',
      WingerCustom: 'Ailier personnalisé',
      WingerCustom1: 'Ailier Personnalisé 1',
      WingerCustom2: 'Ailier Personnalisé 2',
      WingerCustom3: 'Ailier Personnalisé 3',
      WingerCustom4: 'Ailier Personnalisé 4',
      WingerCustom5: 'Ailier Personnalisé 5',
      WingerCustom6: 'Ailier Personnalisé 6',
      WingerOffensive: 'Ailier Offensif',
      Forward: 'Avant-centre',
      ForwardCustom: 'Transférer personnalisé',
      ForwardCustom1: 'Avant-centre Personnalisé 1',
      ForwardCustom2: 'Avant-centre Personnalisé 2',
      ForwardCustom3: 'Avant-centre Personnalisé 3',
      ForwardCustom4: 'Avant-centre Personnalisé 4',
      ForwardCustom5: 'Avant-centre Personnalisé 5',
      ForwardCustom6: 'Avant-centre Personnalisé 6',
      ForwardPredictive: 'Avant-centre',
      WingBack: 'Arrière Latéral',
      WingBackCustom: 'WingBack personnalisé',
      WingBackCustom1: 'Arrière Latéral Personnalisé 1',
      WingBackCustom2: 'Arrière Latéral Personnalisé 2',
      WingBackCustom3: 'Arrière Latéral Personnalisé 3',
      WingBackCustom4: 'Arrière Latéral Personnalisé 4',
      WingBackCustom5: 'Arrière Latéral Personnalisé 5',
      WingBackCustom6: 'Arrière Latéral Personnalisé 6',
      WingBackMedia: 'Arrière Latéral (RéseauxSociaux)',
      FullBackMedia: 'Arrière (RéseauxSociaux)',
      MidfielderMedia: 'Milieu (RéseauxSociaux)',
      WingerMedia: 'Ailier (RéseauxSociaux)',
      ForwardMedia: 'Avant-centre (RéseauxSociaux)',
      PhysicalWingBack: 'Physique Arrière Latéral',
      PhysicalForward: 'Physique Avant-centre',
      PhysicalWinger: 'Physique Ailier',
      PhysicalMidfielder: 'Physique Milieu',
      PhysicalFullBack: 'Physique Arrière',
      PhysicalDefender: 'Physique Défenseur',
      PhysicalWingBackLMO: 'Physique Arrière Latéral',
      PhysicalForwardLMO: 'Physique Avant-centre',
      PhysicalWingerLMO: 'Physique Ailier',
      PhysicalMidfielderLMO: 'Physique Milieu',
      PhysicalFullBackLMO: 'Physique Arrière',
      PhysicalDefenderLMO: 'Physique Défenseur'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Gardien',
      Defender: 'Défenseur',
      FullBack: 'Arrière Latéral',
      FullBackPredictive: 'Arrière Latéral',
      Midfielder: 'Milieu',
      MidfielderPredictive: 'Milieu',
      MidfielderDefensive: 'Milieu Défensif',
      MidfielderOffensive: 'Milieu Offensif',
      AttackingMidfielder: 'Deuxième attaquant',
      MidfielderWing: 'Milieu Intérieur',
      Winger: 'Ailier',
      WingerOffensive: 'Ailier Offensif',
      Forward: 'Avant-centre',
      ForwardPredictive: 'Avant-centre',
      WingBack: 'Arrière Latéral',
      WingBackMedia: 'WingBack (RéseauxSociaux)',
      FullBackMedia: 'Arrière Latéral (RéseauxSociaux)',
      MidfielderMedia: 'Milieu (RéseauxSociaux)',
      WingerMedia: 'Ailier (RéseauxSociaux)',
      ForwardMedia: 'Avant-centre (RéseauxSociaux)',
      PhysicalWingBack: 'Physique Arrière Latéral',
      PhysicalForward: 'Physique Avant-centre',
      PhysicalWinger: 'Physique Ailier',
      PhysicalMidfielder: 'Physique Milieu',
      PhysicalFullBack: 'Physique Arrière',
      PhysicalDefender: 'Physique Défenseur',
      PhysicalWingBackLMO: 'Physique Arrière Latéral',
      PhysicalForwardLMO: 'Physique Avant-centre',
      PhysicalWingerLMO: 'Physique Ailier',
      PhysicalMidfielderLMO: 'Physique Milieu',
      PhysicalFullBackLMO: 'Physique Arrière',
      PhysicalDefenderLMO: 'Physique Défenseur'
    },
    radarDescription: {
      basicStatistics: {
        title: 'STATISTIQUES DE BASE',
        minutes: 'minutes',
        goals: 'buts',
        assists: 'passes décisives',
        redCards: 'cartons rouges',
        yellowCards: 'cartons jaunes',
        games: 'matchs',
        goalsReceived: 'buts sans penalty concédés',
        xGFaced: 'xG concédé'
      },
      profiles: {
        3: {
          1: 'Gardien habile avec le ballon aux pieds, à la fois sur les passes courtes et longues.',
          2: 'Gardien capable de jouer avec les pieds et d’être important dans l’initiation du jeu, avec de bons pourcentages de passes courtes et longues.',
          3: 'Gardien avec un bon jeu de pieds, dont les métriques de passe en font un profil intéressant.',
          4: 'Gardien qui se distingue par ses passes, aussi bien dans son propre camp que dans le camp adverse.',
          5: 'Gardien très sûr avec le ballon aux pieds et doté d’une grande qualité de passe.',
          6: 'Gardien solide dans le jeu au pied, sécurisant la première relance avec un pourcentage élevé de passes courtes et longues.',
          7: 'Gardien très à l’aise avec le ballon, complétant un pourcentage élevé de passes courtes et longues.'
        },
        5: {
          1: 'Défenseur performant en un contre un et réalisant un grand nombre de tacles et d’interceptions.',
          2: 'Défenseur central très efficace dans les duels individuels, aussi bien dans le jeu aérien que dans le tacle, avec une bonne lecture pour anticiper.',
          3: 'Défenseur central performant dans les duels défensifs individuels, ce qui se traduit par un grand volume de récupérations.',
          4: 'Profil défensif de haut niveau, capable de récupérer un grand nombre de ballons grâce aux tacles et interceptions.',
          5: 'Défenseur très efficace au tacle et générant un volume important d’interceptions, se distinguant dans les duels individuels.',
          6: 'Défenseur central avec un nombre élevé de récupérations par match, capable de lire le jeu adverse et de couper les passes, avec précision et fréquence dans les tacles.',
          7: 'Défenseur caractérisé par un volume élevé de récupérations grâce à l’efficacité et la fréquence des tacles et à une bonne lecture des passes adverses.'
        },
        6: {
          1: 'Défenseur apportant beaucoup à la création d’occasions, avec une bonne vision du jeu.'
        },
        7: {
          1: 'Joueur avec un rendement équilibré entre le jeu offensif (grande contribution à la construction du xG) et le jeu défensif (fort volume de récupérations).'
        },
        8: {
          1: 'Défenseur solide dans les duels et avec un grand nombre de récupérations, aussi bien par tacles que par interceptions.'
        },
        9: {
          1: 'Joueur avec une grande contribution offensive en générant des actions dangereuses, mais avec davantage de difficultés sur le plan défensif.'
        },
        10: {
          1: 'Joueur couvrant beaucoup de terrain, capable de récupérer des ballons et de participer fortement à la construction du xG de l’équipe.'
        },
        11: {
          1: 'Milieu central à haut rendement défensif et très efficace à la passe, malgré une influence limitée dans le dernier tiers.'
        },
        12: {
          1: 'Milieu central complet, influent dans la création d’occasions dangereuses, performant dans le jeu aérien, et enregistrant de nombreux tacles et interceptions par match.'
        },
        15: {
          1: 'Ailier à l’aise en un contre un, avec un bon taux de centres réussis et générant plus de passes décisives attendues que de tirs.'
        },
        16: {
          1: 'Joueur réalisant de nombreuses passes entre les lignes et progressions balle au pied, générant des occasions et ayant plus d’influence dans les zones intermédiaires qu’un ailier classique.'
        },
        17: {
          1: 'Joueur doté d’un bon dribble, cherchant à rentrer vers l’intérieur pour générer davantage de tirs (xG) que de passes clés (xA).'
        },
        18: {
          1: 'Avant-centre très impliqué sans ballon, avec un niveau élevé de pression individuelle se traduisant par des interceptions.'
        },
        22: {
          1: 'Avant-centre très mobile pour recevoir entre les lignes, décrocher sur les côtés et générer des occasions. Pourcentage élevé de touches en dehors de la surface par rapport au total des touches par match.'
        }
      },
      description: 'DESCRIPTION',
      conjuction: ' et ',
      conjuction2: ' et ',
      over: 'au-dessus',
      under: 'en-dessous',
      respectively: ', respectivement ',
      Defending1: {
        1: 'Performance défensive située parmi les plus faibles des 5 grandes ligues'
      },
      Defending2: {
        1: 'Sur le plan défensif, la performance est inférieure à la moyenne et le travail n’est pas satisfaisant'
      },
      Defending3: {
        1: 'Sur le plan défensif, le travail est correct, avec un niveau un peu over_under_average de la moyenne'
      },
      Defending4: {
        1: 'Travail défensif remarquable avec une performance supérieure à la moyenne'
      },
      Defending5: {
        1: 'Rendement défensif de très haut niveau, supérieur à 80% des player_positions des 5 grandes ligues'
      },
      Saving1: {
        1: 'Gardien avec une performance très basse, montrant de grandes difficultés à arrêter le ballon'
      },
      Saving2: {
        1: 'Performance en tant que gardien de but insuffisante, avec un niveau inférieur à la moyenne'
      },
      Saving3: {
        1: 'Gardien avec une performance acceptable, légèrement over_under_average de la moyenne, avec une marge de progression sur metric_name'
      },
      Saving4: {
        1: 'Gardien avec un bon niveau, au-dessus de la moyenne des 5 grandes ligues, se distinguant notamment sur metric_name'
      },
      Saving5: {
        1: 'Profil très complet dans le domaine des arrêts, avec des métriques le plaçant dans le Top 20% par rapport aux gardiens des 5 grandes ligues européennes.'
      },
      Passing1: {
        1: 'Avec le ballon aux pieds, niveau situé parmi les plus faibles'
      },
      Passing2: {
        1: 'En ce qui concerne les passes, les performances sont inférieures à la moyenne'
      },
      Passing3: {
        1: 'Niveau de passe acceptable, légèrement over_under_average de la moyenne'
      },
      Passing4: {
        1: 'Très bon passeur avec un niveau nettement au-dessus de la moyenne'
      },
      Passing5: {
        1: 'Grande efficacité à la passe, avec une performance supérieure à celle de la plupart des joueurs'
      },
      Aerial1: {
        1: 'Profil très faible dans le jeu aérien, parmi les pires à son poste dans cet aspect'
      },
      Aerial2: {
        1: 'Rendement limité dans les duels aériens, en dessous de la moyenne'
      },
      Aerial3: {
        1: 'Niveau acceptable dans le jeu aérien, un peu over_under_average de la moyenne'
      },
      Aerial4: {
        1: 'Très bonnes performances dans le jeu aérien, avec une haute efficacité'
      },
      Aerial5: {
        1: 'Les métriques dans le jeu aérien le placent parmi les meilleurs profils'
      },
      Shooting1: {
        1: 'Statistiques très faibles devant le but, parmi les pires profils dans ce domaine'
      },
      Shooting2: {
        1: 'Niveau devant le but largement perfectible, en dessous de la moyenne'
      },
      Shooting3: {
        1: 'Performance offensive acceptable, légèrement over_under_average de la moyenne'
      },
      Shooting4: {
        1: 'Très bon rendement dans la surface adverse, avec des chiffres supérieurs à 60% des joueurs'
      },
      Shooting5: {
        1: 'Grande efficacité dans les tâches offensives, avec une performance spectaculaire le plaçant parmi les meilleurs dans ce domaine'
      },
      Association1: {
        1: 'Performance en association très faible, parmi les plus mauvaises des cinq grandes ligues'
      },
      Association2: {
        1: 'Large marge de progression avec le ballon aux pieds, avec un niveau inférieur à la moyenne dans cet aspect'
      },
      Association3: {
        1: 'Bonne capacité à s’associer, légèrement over_under_average de la moyenne'
      },
      Association4: {
        1: 'Très bonne association avec le ballon, montrant un niveau très solide'
      },
      Association5: {
        1: 'Capacité associative exceptionnelle avec le ballon aux pieds, parmi les meilleurs joueurs dans ce domaine'
      },
      BallHandling1: {
        1: 'Rendement très faible dans le maniement du ballon, parmi les pires par rapport aux cinq grandes ligues'
      },
      BallHandling2: {
        1: 'En ce qui concerne le maniement du ballon, les niveaux sont inférieurs à la moyenne'
      },
      BallHandling3: {
        1: 'Maniement du ballon acceptable, légèrement over_under_average de la moyenne'
      },
      BallHandling4: {
        1: 'Niveau élevé dans le maniement du ballon, avec des chiffres proches des meilleurs dans cet aspect'
      },
      BallHandling5: {
        1: 'Capacité exceptionnelle à manier le ballon, parmi les meilleurs profils des 5 grandes ligues'
      },
      Crosses1: {
        1: 'Faible performance sur les centres dans la surface. Parmi les pires joueurs selon les métriques de centres'
      },
      Crosses2: {
        1: 'Performance inférieure à la moyenne pour ce qui est de créer du danger avec les centres'
      },
      Crosses3: {
        1: 'Niveau acceptable, mais perfectible, sur les centres dans la surface, un peu over_under_average de la moyenne'
      },
      Crosses4: {
        1: 'Bonnes statistiques sur les centres, clairement au-dessus de la moyenne'
      },
      Crosses5: {
        1: 'Parmi les meilleurs joueurs au centre dans la surface, en particulier dans le Top 20% des profils les plus efficaces'
      },
      Carries1: {
        1: 'Parmi les 20 % de joueurs présentant les plus faibles chiffres en conduite de balle'
      },
      Carries2: {
        1: 'Performance en conduite de balle nettement en dessous de la moyenne des joueurs à ce poste'
      },
      Carries3: {
        1: 'Rendement proche de la moyenne, légèrement over_under_average, en termes de conduite de balle'
      },
      Carries4: {
        1: 'Joueur notable avec de très bons chiffres en profondeur et en conduites de balle'
      },
      Carries5: {
        1: 'Profil très talentueux en conduite de balle, avec un niveau élevé dans les métriques de la catégorie Conduites'
      },
      Turnovers1: {
        1: 'Performance très négative avec un volume élevé de pertes favorisant les situations dangereuses pour l’adversaire. Parmi les profils les plus faibles dans cette métrique'
      },
      Turnovers2: {
        1: 'Les nombreuses pertes dangereuses profitent aux adversaires, et une nette réduction de ces pertes est nécessaire'
      },
      Turnovers3: {
        1: 'Niveau légèrement over_under_average de la moyenne en termes de pertes de balle, avec une marge d’amélioration évidente'
      },
      Turnovers4: {
        1: 'Rendement remarquable en matière de pertes de balle, au-dessus des 60% de joueurs qui perdent le moins de ballons'
      },
      Turnovers5: {
        1: 'Nombre de pertes très réduit, ce qui place ce profil parmi les meilleurs pour la conservation de la possession'
      },
      SequenceInvolvement1: {
        1: 'En termes de possession, les chiffres ne sont pas favorables, les actions se terminant très rarement par un tir'
      },
      SequenceInvolvement2: {
        1: 'Finalisation des possessions largement perfectible, celles-ci se terminant rarement par un tir, ce qui place la performance bien en dessous de la moyenne'
      },
      SequenceInvolvement3: {
        1: 'Niveau acceptable dans la finalisation des possessions devant le but, avec un percentile un peu over_under_average de la moyenne et une grande marge d’amélioration'
      },
      SequenceInvolvement4: {
        1: 'Bonne capacité à terminer les possessions de l’équipe par des tirs, certains se concluant par un but, ce qui constitue un rendement notable dans cette catégorie'
      },
      SequenceInvolvement5: {
        1: 'Profil situé parmi ceux qui convertissent le mieux les possessions de l’équipe en tirs générateurs de danger'
      },
      OutPlay1: {
        1: 'Impact minimal lorsqu’il s’agit de désorganiser les structures défensives'
      },
      OutPlay2: {
        1: 'Contribution à la progression et à la rupture des défenses inférieure aux standards du poste'
      },
      OutPlay3: {
        1: 'Capacité à générer des avantages de manière occasionnelle, avec des performances proches de la moyenne pour le poste'
      },
      OutPlay4: {
        1: 'Contribution fréquente à la rupture des lignes défensives et à la création de déséquilibres'
      },
      OutPlay5: {
        1: 'Profil parmi les plus efficaces pour éliminer des adversaires et générer des progressions à ce poste'
      },
      LineBreakingPasses1: {
        1: 'Tentatives ou passes cassant les lignes défensives très rares, avec une contribution très faible dans ce type d’actions'
      },
      LineBreakingPasses2: {
        1: 'Difficultés à trouver régulièrement des coéquipiers entre les lignes ou derrière la pression, avec une contribution en dessous des standards du poste'
      },
      LineBreakingPasses3: {
        1: 'Passes cassant les lignes effectuées de manière occasionnelle, avec un niveau autour de la moyenne pour le poste'
      },
      LineBreakingPasses4: {
        1: 'Passes cassant les lignes réalisées fréquemment, contribuant à déséquilibrer les blocs adverses'
      },
      LineBreakingPasses5: {
        1: 'Parmi les passeurs les plus efficaces du championnat pour casser les lignes et libérer la pression. Il s’agit d’un de ses principaux points forts'
      },
      PassUnderPressure1: {
        1: 'Maintenir calme et efficacité devient difficile lorsque la pression adverse augmente'
      },
      PassUnderPressure2: {
        1: 'Difficultés à conserver une bonne précision de passe dans les situations de forte pression'
      },
      PassUnderPressure3: {
        1: 'Niveau autour de la moyenne sur les passes sous pression, avec une gestion globalement correcte mais une exécution pas toujours propre'
      },
      PassUnderPressure4: {
        1: 'Capacité fréquente à trouver des coéquipiers malgré la pression, avec un rendement supérieur à la moyenne dans ce type de passes'
      },
      PassUnderPressure5: {
        1: 'Sang-froid et précision remarquables sur les passes sous forte pression, avec un niveau situé parmi les meilleurs du poste dans cet aspect'
      },
      BallReceived1: {
        1: 'Très peu de passes reçues dans des zones avancées ; profil n’évoluant pas régulièrement entre les lignes'
      },
      BallReceived2: {
        1: 'Quelques réceptions démarquées dans le camp adverse, mais sans grande régularité'
      },
      BallReceived3: {
        1: 'Volume moyen de réceptions sans opposition dans les zones offensives'
      },
      BallReceived4: {
        1: 'Nombre fréquent de réceptions entre les lignes et dans des zones libres de pression'
      },
      BallReceived5: {
        1: 'Grand nombre de réceptions entre les lignes, sans pression défensive et dans des zones potentiellement clés'
      },
      OnBallPressure1: {
        1: 'Pression exercée rarement et presque jamais près du porteur du ballon. Profil peu intense'
      },
      OnBallPressure2: {
        1: 'Quelques pressions fortes, mais pas souvent. Intensité globale plutôt faible'
      },
      OnBallPressure3: {
        1: 'Volume moyen de pressions à proximité de l’adversaire en possession'
      },
      OnBallPressure4: {
        1: 'Presseur discipliné, se rapprochant régulièrement du porteur du ballon'
      },
      OnBallPressure5: {
        1: 'Profil très intense sans ballon, hautement discipliné et travaillant beaucoup pour presser l’adversaire'
      },
      SpatialCoverage1: {
        1: 'Contribution très limitée à l’occupation et au contrôle de l’espace, avec une implication minimale dans la formation et la structure tactique de l’équipe. Couverture spatiale faible en possession comme hors possession, avec une influence réduite sur l’organisation et la compacité collective'
      },
      SpatialCoverage2: {
        1: 'Couverture spatiale inférieure à la moyenne, avec une participation partielle à l’occupation du terrain mais des lacunes dans la continuité positionnelle et la cohésion avec le reste de l’équipe. Influence tactique intermittente et moins régulière que celle des profils mieux classés'
      },
      SpatialCoverage3: {
        1: 'Couverture spatiale moyenne, contribuant régulièrement à l’occupation et au contrôle des espaces. Positionnement généralement correct et fonctionnel, avec un impact modéré en phases offensive et défensive'
      },
      SpatialCoverage4: {
        1: 'Couverture spatiale supérieure à la moyenne, avec une grande implication dans l’occupation du terrain et la structure positionnelle. Capacité à maintenir la forme et à s’adapter aux transitions, contribuant fortement à la compacité et au contrôle des zones clés'
      },
      SpatialCoverage5: {
        1: 'Excellent niveau de couverture spatiale, optimisant le positionnement pour influencer de manière décisive la formation et la structure tactique. Compréhension du jeu et synchronisation avec le bloc permettant de maximiser l’occupation des espaces stratégiques, en attaque comme en défense'
      },
      OffBallPressure1: {
        1: 'Pression défensive très limitée sans ballon, avec peu d’actions de perturbation des adversaires ou de provocation d’erreurs. Contribution minimale au pressing et à la structure défensive'
      },
      OffBallPressure2: {
        1: 'Pression défensive sans ballon inférieure à la moyenne, avec des interventions ponctuelles mais un timing et un positionnement irréguliers. Impact limité sur la récupération du ballon ou la perturbation de la construction adverse'
      },
      OffBallPressure3: {
        1: 'Niveau moyen de pression sans ballon, contribuant régulièrement aux efforts défensifs de l’équipe. Positionnement et timing généralement efficaces pour ralentir ou limiter les options de l’adversaire'
      },
      OffBallPressure4: {
        1: 'Pression défensive sans ballon supérieure à la moyenne, perturbant fréquemment les actions adverses et réduisant temps et espace disponibles. Efforts bien coordonnés aidant à maintenir une structure défensive solide'
      },
      OffBallPressure5: {
        1: 'Excellente capacité à appliquer la pression défensive sans ballon, avec un harcèlement constant, des pertes de balle provoquées et des lignes de passe fortement limitées. Intensité, positionnement et anticipation améliorent considérablement l’efficacité défensive collective'
      },
      Distance1: {
        1: 'Parcourt nettement moins de terrain que la moyenne (déplacements très limités)'
      },
      Distance2: {
        1: 'Distance parcourue par match inférieure aux standards du plus haut niveau (activité moindre que la moyenne)'
      },
      Distance3: {
        1: 'Couvre une quantité raisonnable de terrain, avec des chiffres proches de la moyenne du championnat (engagement physique équilibré)'
      },
      Distance4: {
        1: 'Parcourt régulièrement de longues distances, avec des chiffres reflétant une bonne endurance (solide rendement physique)'
      },
      Distance5: {
        1: 'Volume physique exceptionnel, parmi les profils les plus actifs des 5 grands championnats en termes de distance parcourue'
      },
      Sprint1: {
        1: 'Effectue très peu de courses à haute vitesse par rapport à la moyenne (effort de sprint minimal au fil des matchs)'
      },
      Sprint2: {
        1: 'Fréquence de sprints inférieure à la moyenne pour le poste (explosivité limitée dans les déplacements rapides)'
      },
      Sprint3: {
        1: 'Réalise un nombre modéré de sprints par match, dans une fourchette attendue (valeurs proches de la moyenne du championnat)'
      },
      Sprint4: {
        1: 'Se distingue par une fréquence de sprints nettement supérieure à la moyenne. Explosivité constante, avec de nombreuses courses à haute vitesse au cours du match'
      },
      Sprint5: {
        1: 'Profil situé parmi les 20% de joueurs présentant le volume de sprints par 90 minutes le plus élevé. Performance physique maximale sur les efforts répétés à haute intensité'
      },
      Acceleration1: {
        1: 'Capacité à changer de rythme nettement inférieure à la moyenne, avec très peu d’accélérations explosives pendant le match'
      },
      Acceleration2: {
        1: 'Volume d’accélérations inférieur à la moyenne par rapport à des profils similaires, avec une fréquence réduite de départs à courte distance'
      },
      Acceleration3: {
        1: 'Nombre d’accélérations correct, proche de la moyenne du championnat. Les changements de rythme ne se distinguent pas, mais les chiffres restent acceptables dans cette métrique'
      },
      Acceleration4: {
        1: 'Forte capacité à accélérer rapidement et de manière répétée, avec un taux d’accélérations nettement supérieur à la moyenne et des départs fréquents'
      },
      Acceleration5: {
        1: 'Parmi les 20% de joueurs les plus explosifs en termes d’accélérations répétées, avec des valeurs très au-dessus de la moyenne sur les départs rapides et changements de rythme'
      },
      Speed1: {
        1: 'Profil physiquement plutôt lent ou gérant les efforts de haute intensité avec parcimonie pendant les matchs'
      },
      Speed2: {
        1: 'Vitesses maximales légèrement inférieures à la moyenne compétitive'
      },
      Speed3: {
        1: 'Vitesses maximales proches de la moyenne tout au long du match'
      },
      Speed4: {
        1: 'Atteint fréquemment des vitesses élevées, ce qui indique une bonne vitesse et puissance'
      },
      Speed5: {
        1: 'Enregistre des vitesses maximales très élevées, pouvant devenir un facteur décisif en termes de vitesse'
      },
      LineBreakingCarries1: {
        1: 'Casse rarement les lignes par des conduites de balle. Initiative limitée pour avancer balle au pied'
      },
      LineBreakingCarries2: {
        1: 'Réalise quelques conduites qui cassent les lignes, mais sans grande régularité'
      },
      LineBreakingCarries3: {
        1: 'Moyenne un nombre modéré de conduites réussies cassant les lignes'
      },
      LineBreakingCarries4: {
        1: 'Contribue à la construction du jeu en franchissant fréquemment les lignes balle au pied et en soutenant la progression'
      },
      LineBreakingCarries5: {
        1: 'Véritable spécialiste de la conduite de balle, cassant les lignes de manière constante et à haut volume'
      },
      LineBreakingActions1: {
        1: 'Enregistre très peu d’actions cassant les lignes (passes et conduites). Prise de risque très limitée'
      },
      LineBreakingActions2: {
        1: 'Produit parfois des actions progressives (passes et conduites), mais rarement, avec une tendance à jouer plutôt horizontalement'
      },
      LineBreakingActions3: {
        1: 'Combine régulièrement passes et conduites cassant les lignes, contribuant ainsi à la progression du jeu'
      },
      LineBreakingActions4: {
        1: 'Profil techniquement solide et intelligent, produisant de nombreuses actions (passes et conduites) qui cassent les lignes adverses'
      },
      LineBreakingActions5: {
        1: 'Spécialiste de la progression, avec un impact majeur sur l’équipe en cassant constamment les lignes par passes et conduites'
      },
      OffBallRuns1: {
        1: 'Le joueur effectue très peu de déplacements intentionnels sans ballon, offrant un soutien limité à la phase offensive. Les appels de balle contribuent rarement à créer des espaces, perturber les lignes défensives ou améliorer la coordination de l’équipe en possession'
      },
      OffBallRuns2: {
        1: 'Le joueur propose un mouvement sans ballon inférieur à la moyenne, soutenant occasionnellement l’attaque mais sans constance dans le timing, la direction ou l’intention tactique. Les courses ont un impact limité sur l’ouverture des espaces ou l’amélioration de la structure offensive'
      },
      OffBallRuns3: {
        1: 'Le joueur affiche un niveau moyen de courses intentionnelles sans ballon, contribuant régulièrement à la phase offensive. Les déplacements sont généralement bien chronométrés et fonctionnels, créant des espaces et soutenant le jeu collectif avec un impact modéré'
      },
      OffBallRuns4: {
        1: 'Le joueur présente une activité sans ballon supérieure à la moyenne, effectuant fréquemment des courses intentionnelles qui perturbent les structures défensives, créent des options de passe et ouvrent des espaces offensifs. Les schémas de déplacement contribuent fortement à la coordination de l’équipe en possession'
      },
      OffBallRuns5: {
        1: 'Le joueur excelle dans les courses intentionnelles sans ballon, anticipant constamment le jeu et effectuant des appels intelligents qui maximisent les opportunités offensives. Timing, positionnement et conscience spatiale génèrent des menaces constantes et améliorent la fluidité collective en possession'
      },
      OverMaxValue: {
        1: 'Capacité extrême en over_max_metric_name, avec une performance au-dessus de la valeur maximale, ce qui place ce profil dans le top 10% des 5 grandes ligues sur cet aspect'
      },
      OverAverageSeason: {
        1: 'En ce qui concerne over_average_metric_name, la performance est supérieure à la moyenne de la ligue league_name (over_average_metric_value face à average_metric_value)',
        2: 'En comparant les chiffres avec ceux de la ligue league_name, sur over_average_metric_name la performance se situe au-dessus de la moyenne (over_average_metric_value face à average_metric_value)'
      },
      UnderMinValue: {
        1: 'Concernant under_min_metric_name, une nette amélioration est nécessaire, le niveau se situant dans le percent_metric_name le plus bas des 5 grandes ligues'
      },
      Over70Percent: {
        1: ', se distinguant particulièrement sur over_70_metric_name avec over_70_metric_value par 90 minutes, respectivement',
        2: ', au-dessus de 70% sur over_70_metric_name avec over_70_metric_value par 90 minutes, respectivement',
        3: ', réalisant un travail plus que remarquable sur over_70_metric_name avec over_70_metric_value par 90 minutes, respectivement'
      },
      Under30Percent: {
        1: ', nécessitant davantage d’efforts sur under_30_metric_name car avec under_30_metric_value par 90 minutes, respectivement, la performance reste faible',
        2: ', demandant une amélioration notable sur under_30_metric_name puisque, avec under_30_metric_value par 90 minutes, la performance est en dessous des attentes',
        3: ', en ce qui concerne under_30_metric_name avec under_30_metric_value par 90 minutes, respectivement, un effort supplémentaire est nécessaire pour obtenir de meilleurs chiffres'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Il convient de souligner un rendement supérieur à la moyenne de la ligue league_name en '
      },
      OverAverageStats: {
        1: ' over_average_metric_name (over_average_metric_value face à average_metric_value en moyenne)'
      },
      Over70PercentIndividualPressure: {
        1: ', en exerçant une très bonne pression pour récupérer le ballon',
        2: ', en appliquant une forte pression sur l’adversaire afin de récupérer le ballon'
      },
      Under30PercentIndividualPressure: {
        1: ', avec la nécessité d’intensifier la pression pour récupérer le ballon',
        2: ', nécessitant davantage d’efforts en termes de pression sur l’adversaire'
      }
    },
    himSelf: 'lui-même',
    ownSeason: 'Saison du joueur',
    minMaxTooltip: 'Ajuster les valeurs minimales et maximales du radar',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Connexion',
    latestBlogPosts: 'Derniers articles',
    signIn: 'S\'identifier',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    passwordForgotten: 'Mot de passe oublié?',
    signUp: 'Créer un compte',
    enter: 'Entrer',
    forceTitle: 'Compte en cours d\'utilisation',
    forceMessage: 'Le compte est utilisé sur un autre appareil, voulez-vous le déconnecter et le connecter sur cet appareil?',
    forgotMyPassword: 'J\'ai oublié le mot de passe',
    firstLogin: 'Première connexion',
    firstLoginMessage: 'Pour des raisons de sécurité, vous devez attribuer un nouveau mot de passe lors de votre première connexion et une langue préférée pour visualiser driblabPRO',
    firstLoginOverview: 'Voici un aperçu de votre compte, des ligues et des produits auxquels vous avez accès.',
    passwordConfirmation: 'Confirmer le mot de passe',
    forgotPasswordMessage: 'Indiquez votre adresse électronique, si un compte valide y est associé, vous recevrez dans votre mail les étapes suivantes pour récupérer votre mot de passe',
    resetPassword: 'Rétablir le mot de passe',
    resetPasswordLinkInvalid: 'Ce lien est invalide ou a expiré. Demandez une nouvelle réinitialisation du mot de passe depuis la page de connexion.',
    skipSettings: 'Sauter les paramètres',
    contact: 'Contact',
    cookiesText: 'Ce site utilise des cookies Google pour fournir ses services et analyser votre trafic afin d\'assurer la qualité du service, générer des statistiques d\'utilisation et détecter et résoudre les abus.',
    contactUs: 'Contactez-nous',
    newsTitle: 'Nouveau : scores physiques!',
    newsText: 'Nous avons ajouté deux nouveaux scores de performance physique à notre score original basé sur les données d’événements : <b>Score d’Endurance</b> et <b>Score de Vitesse et Puissance</b>.<br> L’Endurance met en avant les joueurs qui couvrent régulièrement du terrain et maintiennent de fortes charges de travail, tandis que Vitesse et Puissance se concentre sur la vitesse maximale, les sprints et les accélérations explosives.'
  },
  settings: {
    pageSubtitle: 'Configurez votre expérience dans l\'application',
    language: 'Langue',
    availableLeagues: 'Ligues Disponibles',
    availableSeasons: 'Saisons Disponibles',
    availableProducts: 'Produits Disponibles',
    organization: 'Organisation',
    changePassword: 'Changer le mot de passe',
    seasonTemplates: 'Modèle de Saison',
    seasonTemplatesSubtitle: 'Créez vos propres modèles de saison qui seront ensuite disponibles pour être sélectionnés dans le classement des joueurs et la recherche de joueurs.',
    templateName: 'Nom de modèle',
    selectTemplate: 'Sélectionner un modèle à modifier',
    radarDefault: 'Défaut Radar',
    default: 'Défaut',
    tabs: {
      options: 'Options',
      templates: 'Templates',
      availableLeagues: 'Ligues disponibles',
      contactData: 'Données de contact du GBE'
    },
    contactData: {
      userDetails: 'Donnés de l\'útilisateur ',
      firstName: 'Prénom',
      lastName: 'Nom',
      contactDetails: 'Donnés de contact',
      name: 'Prénom',
      phone: 'Téléphone',
      mobile: 'Portable',
      email: 'E-mail',
      representativeDetails: 'Donnés du representative'
    },
    currency: 'Monnaie',
    fieldPreferences: 'Préférences de Terrain',
    visualizationsPreferences: 'Préférences de Visualisation',
    fieldColor: 'Couleur du Terrain',
    fieldColors: {
      green: 'Vert',
      blue: 'Bleu',
      white: 'Blanc',
      black: 'Noir',
      grey: 'Grey'
    },
    defaultPlayerVisualization: 'Visualisation du joueur par défaut',
    appPreferences: 'Préférences d\'application',
    darkMode: 'Dark Mode',
    showTour: 'Montrer la visite guidée',
    customStats: 'Custom Stats',
    radarTemplates: 'Radar Templates',
    radarTemplatesSubtitle: 'Créez vos propres modèles de métriques qui seront ensuite disponibles pour être sélectionnées dans les performances et le classement des joueurs',
    radarCategories: {
      Custom1: 'Personnalisé 1',
      Custom2: 'Personnalisé 2',
      Custom3: 'Personnalisé 3',
      Custom4: 'Personnalisé 4',
      Custom5: 'Personnalisé 5',
      Custom6: 'Personnalisé 6',
      Physical: 'Physical',
      CustomPhysical1: 'Personnalisé Physical 1',
      CustomPhysical2: 'Personnalisé Physical 2',
      CustomPhysical3: 'Personnalisé Physical 3',
      CustomPhysical4: 'Personnalisé Physical 4',
      CustomPhysical5: 'Personnalisé Physical 5',
      CustomPhysical6: 'Personnalisé Physical 6'
    },
    templateRemoveTitle: 'Remove Template',
    templateRemoveMsg: 'Do you want to remove this template?',
    templateEditTitle: 'Sauvegarder le modèle',
    templateEditMsg: 'Il y a un modèle non enregistré, voulez-vous l\'enregistrer avant de charger un autre modèle?',
    category: 'Catégorie',
    playerRadar: 'Radar du Joueur',
    teamRadar: 'Radar d\'équipe',
    statsAlert: 'Insérer au moins une stat pour sauver',
    recommended: 'Recommandé',
    warning: 'Il y a des positions qui ont atteint le nombre maximum de radars autorisés. Veuillez supprimer ou modifier tout modèle',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Espagnol',
      numeric: 'Numérique'
    },
    showMediaMode: 'Afficher le mode média',
    statTemplates: 'Modèles de Statistiques de Jeu',
    statTemplatesSubtitle: 'Créez vos propres modèles en choisissant parmi une multitude de mesures',
    ratingFormat: {
      ratingFormat: 'Format de notation',
      numbers: 'Nombres',
      letters: 'Lettres A à F'
    }
  },
  playerDetail: {
    passport: 'Passeporte ',
    secondPassport: 'Deuxième Passeporte',
    age: 'Age',
    dateOfBirth: 'Date de naissance',
    height: 'Hauteur',
    weight: 'Poids',
    wage: 'Salaire',
    history: 'Historique',
    positions: 'Postes',
    injuries: 'Blessures',
    transfers: 'Transferts',
    nationalTeam: 'Sélection',
    addFavorite: 'Ajouter aux favoris',
    removeFavorite: 'Enlever les favoris',
    contractEnd: 'Fin du contrat',
    yearsOld: 'ans',
    playerAvailability: 'Disponibilité',
    playerUsage: 'Minutes jouées',
    usage: 'Usage',
    addToCollection: 'Ajouter à la collection',
    performance: ' Performance',
    info: 'Info',
    career: 'Carrière',
    playerStyle: 'Styles',
    radar: 'Radar',
    finishingMap: 'Finition',
    threatMap: 'Dangerosité',
    keyPassMap: 'Passes Clé',
    beeswarm: 'Classement',
    allGames: 'Matchs',
    eventsMap: 'Événement',
    lbpMap: 'Passes de rupture de ligne',
    obpMap: 'Sur la pression de la balle',
    pupMap: 'Passe sous pression',
    obrMap: 'Reçus de balle',
    fullName: 'Nom complet',
    academy: 'Academie',
    name: 'Prénom',
    lastName: 'Nom',
    playerAvailabilityLong: '% de la saison sans blessures ou suspensions',
    playerUsageLong: 'Minutes jouées',
    playerAvailability1: 'matchs sans blessures ou suspensions',
    playerAvailability2: 'matches cette saison',
    playerUsage1: 'Minutes jouées',
    playerUsage2: 'minutes totales de l\'équipe',
    notMinutesThisSeason: 'N\'a pas joué de minutes cette saison',
    seasonPlaceholder: 'Pas de saison active',
    inactivePlayer: 'Joueur inactif',
    inactivePlayerMessage: 'Si vous avez besoin de plus d\'informations, vous pouvez demander un rapport!',
    goRequest: 'Aller à la demande ',
    warningMinutes: 'Attention: moins de 450 minutes jouées, l\'analyse peut ne pas être représentative',
    scoreWarningMinutes: 'Joueurs avec au moins 450 minutes jouées au total',
    pdScoreWarningMinutes: 'Joueurs avec au moins 450 minutes jouées au total (minimum 60 minutes par match)',
    warningSeasonGames: 'Saison avec moins de 5 matchs joués, Min & Max des 5 grandes ligues',
    warningStatsRemoved: 'Certaines statistiques ne sont pas affichées car elles ne sont pas disponibles pour la saison sélectionnée',
    warningBeeswarm: 'Joueur non affiché car aucune donnée n\'est disponible pour la saison sélectionnée',
    warningPlayersZeroValue: 'Ne pas afficher {x} joueurs avec 0 ',
    onlyPlayersThatFit: 'Seulement les joueurs qui s\'intègrent dans le radar modèle',
    gamesPlayedNotEnough: 'Options désactivées en raison d\'un nombre insuffisant de matchs joués',
    gbe: 'GBE',
    analysis: 'Analyse',
    documents: 'Documents',
    rankDefensive: 'Défensive',
    rankBallHandling: 'Maniement du ballon',
    rankGoal: 'Contribution au But',
    rankXt: 'Danger',
    rankIndex: 'Index',
    visitHistory: 'Aller à l\'historique de recherche',
    placer: 'Terrain',
    touchesMap: 'Carte des Touches',
    heatMap: 'Carte de Chaleur',
    ageProfile: 'Age Profile',
    strongFoot: 'Strong foot',
    player: 'Joueur',
    outOf: 'sur',
    in: 'en',
    radius: 'Rayon',
    blur: 'Flou',
    careerTable: {
      nationalTeamCareer: 'Carrière en Équipe Nationale',
      nationalTeamCompetitions: 'Compétitions de l\'Équipe Nationale'
    },
    physicalProgression: 'Physical Progression',
    gpi: 'Indice Global des Joueurs',
    warningGPI: 'Disponible uniquement pour les joueurs actifs dans les ligues ELO au cours des 30 derniers jours',
    diffGPI: 'Variation depuis le dernier match',
    rankingInTheWorld: '#{0} dans le monde',
    rankingInTheLeague: '#{0} dans {1}',
    max: 'Max',
    gpiChart: 'Graphique basé sur la valeur de l\'Indice Global des Joueurs des {0} derniers matchs',
    percentileRange: 'Centiles {0} à {1}',
    months: 'mois',
    month: 'mois',
    contractExpOver4Years: 'Le contrat expire dans',
    contractExpSoon: 'Le contrat expirera bientôt',
    contractFinalYear: 'Dernière année du contrat',
    freeAgent: 'Agent libre',
    gpiDescription: 'Le Global Player Index (GPI) est un système standardisé d\'évaluation des joueurs qui évalue les footballeurs en fonction de la force de leur équipe, de la force de leur adversaire, de leurs performances en match et de leur disponibilité. Inspiré du système de notation Elo, il garantit que les notes des joueurs reflètent les environnements compétitifs réels plutôt que des références arbitraires.',
    turnoversMap: 'Carte des chiffres d’affaires et des récupérations',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Touches réussies',
    unsuccessfulTouch: 'Touches infructueuses',
    showLegend: 'Afficher la légende'
  },
  finishingMap: {
    typesOfShot: 'Types de tirs',
    shotStrategy: 'Stratégie',
    strategiesCount: '{count} stratégies',
    areas: 'Zones',
    bodyPart: 'Parties du corps',
    more: 'plus',
    selectAll: 'Sélectionner tout',
    minutes: 'Minutes',
    circles: 'Cercles',
    boxes: 'Carte Thermique de la Surface',
    lines: 'Lignes',
    games: 'Matchs',
    perShot: 'par Tir',
    goal: 'But',
    missedShot: 'Tir Raté',
    savedShot: 'Tir Arrête',
    shotOnPost: 'Tir au Barre',
    missedChance: 'Opportunité manquée',
    openPlay: 'Jeu libre',
    regularPlay: 'En Jeu',
    fastBreak: 'Contre-attaque',
    individualPlay: 'Jeu Individuel',
    setPiece: 'Coup de Pied',
    fromCorner: 'Corner',
    freeKick: 'Coup Franc',
    indirectFreeKick: 'Coup Franc Indirect',
    throwInSetPiece: 'Remise en jeu',
    inBox: 'Dans la surface',
    goalArea: 'Surface de but',
    boxLeft: 'Dans la surface - Gauche',
    boxCenter: 'Dans la surface - Milieu',
    boxRight: 'Dans la surface - Droite',
    outOfBox: 'En dehors la surface de réparation',
    outBoxDeepLeft: 'En dehors la surface de réparation - En bas à gauche',
    outBoxDeepRight: 'En dehors la surface de réparation - En bas à droite',
    outBoxLeft: 'En dehors la surface - Gauche',
    outBoxCentreLeft: 'En dehors la surface - Centre gauche',
    outBoxCentre: 'En dehors la surface - Centre',
    outBoxCentreRight: 'En dehors la surface - Centre droit',
    outBoxRight: 'En dehors la surface - Droit',
    left35: 'Gauche +35',
    centreLeft35: 'Centre Gauche +35',
    centre35: 'Centre +35',
    centreRight35: 'Centre Droit +35',
    right35: 'Droit +35',
    head: 'Tête',
    rightFooted: 'Pied Droit',
    leftFooted: 'Pie Gauche',
    otherBodyPart: 'Un Autre',
    chart: {
      shots: 'Tirs',
      xGPerShot: 'xG par tir',
      exceptionTextPenaltyGoals: '* Pénalités = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Pénalités = 0.765 xGOT',
      exceptionTextOwnGoals: '* Les buts propres ne sont pas comptés',
      og: 'OG',
      penaltiesExcluded: 'Pénalités Exclues',
      ownGoalsExcluded: 'Buts Propres Exclues',
      sumOfxG: 'Somme de xG',
      exceptionShotsOutOfRange: '* Ne montre pas les tirs hors de portée'
    },
    inGoal: 'Au But',
    outOfGoal: 'Hors du But',
    highLeft: 'Haut à Gauche',
    highCenter: 'Haut Centre',
    highRight: 'Haut à Droit',
    lowLeft: 'Bas gauche',
    lowCenter: 'Centre Bas',
    lowRight: 'Bas droite',
    outHighLeft: 'Hors Haut Gauche',
    high: 'Hors Haut Centre',
    outHighRight: 'Hors Haut Droit',
    closeHighLeft: 'Près Haut Gauche',
    closeHigh: 'Près Haut Centre',
    closeHighRight: 'Près Haut Droit',
    closeLeft: 'Près Bas Gauche',
    closeRight: 'Près Bas Droit',
    finishingTable: 'Finition Table',
    onGoal: 'On Goal',
    distributionFilters: 'Filtres de distribution',
    penalty: 'Penalty',
    penaltyShootout: 'Séance de tirs au but',
    onlyPercentage: 'Afficher le pourcentage',
    showAll: 'Afficher tout',
    chanceMissed: 'Chance manquée'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Passes clé',
      xAPerPass: 'xA par Passe',
      xAOpenPlay: 'xA Open Play',
      xASetPiece: 'xA Set Piece'
    }
  },
  beeswarm: {
    template: 'Équipe',
    templates: {
      Goalkeeper: 'Gardien de but',
      Defender: 'Défenseur',
      'Full-Back': 'Arrière',
      FullBack: 'Arrière',
      'Wing-Back': 'Ailier',
      WingBack: 'Ailier',
      Midfielder: 'Milieu',
      AttackingMidfielder: 'Milieu offensif',
      Winger: 'Ailier',
      Forward: 'Avant-centre',
      Physical: 'Physical'
    },
    compareWith: 'Comparer avec',
    highlightPlayersOf: 'Mettre en avant les joueurs de',
    highlightPlayers: 'Mettre en avant les joueurs',
    per90: 'Données par 90 mins',
    highlightTeams: 'Mettre en avant les équipes',
    filterTeams: 'Filtrer les équipes',
    warningZeros: 'Uniquement pour les stats non inversées'
  },
  collections: {
    newCollection: 'Nouvelle collection',
    editCollection: 'Modifier la collection',
    name: 'Nom',
    visibility: 'Visibilité',
    privacity: {
      publicTitle: 'Publique',
      publicDescription: 'Visible pour vous et votre club',
      privateTitle: 'Privée',
      privateDescription: 'Seulement visible pour vous',
      supervisedTitle: 'Supervisé',
      supervisedDescription: 'Uniquement visible par vous et votre superviseur'
    },
    addSuccess: 'Ajouté avec succès',
    createAddSuccess: 'Créé et ajouté avec succès',
    editSuccess: 'Correctement actualisé',
    deleteSuccess: 'Correctement supprimé',
    title: 'Collections de joueurs',
    publics: 'Publiques',
    privates: 'Privés',
    supervised: 'Supervisé',
    totalMarketValue: 'Valeur marchande totale',
    avgMarketValue: 'Valeur marchande moyenne',
    avgAge: 'Âge moyen',
    searchBarPlaceholder: 'Rechercher et sélectionner un joueur à ajouter',
    deleteCollection: 'Supprimer la collection',
    deleteCollectionMessage: 'La collection sera éliminée, vous en êtes sûr?',
    removePlayer: 'Supprimer le joueur',
    removePlayerMessage: 'Le joueur sera supprimé de la collection. Êtes-vous sûr?',
    subtitle: 'Organisez vos recherches',
    notExitingTemplate: 'Il n\'y a pas encore de modèles'
  },
  searchbar: {
    placeholder: 'Tapez quelque chose à rechercher (Ex: Neymar PSG)',
    players: 'Joueurs',
    teams: 'Équipes',
    games: 'Matchs',
    leagues: 'Ligues',
    explore: 'Explorez d\'autres résultats',
    placeholderNoResults: 'Il n\'y a pas de résultats pour le effectif',
    teamPlaceholder: 'Pour comparer une équipe, recherchez-la et sélectionnez-la'
  },
  favorites: {
    showOnly: 'Montrer seulement',
    selfFavorites: 'Mes favoris',
    clubFavorites: 'Favoris du club',
    contractExpiration: 'Contrat jusqu\'a',
    groupBy: 'Séparés par groupes',
    noGrouped: 'Non groupé',
    maxSelection: 'Maximum',
    selectAtleastOne: 'Sélectionnez au moins un',
    comparePlayers: 'Comparer les joueurs',
    selectedPlayers: 'Sélectionnés',
    subtitle: 'Gérez vos favoris',
    generateXlsx: 'Generate XLSX',
    generating: 'Generating...',
    subscribed: 'Subscribed',
    subscribedTooltip: 'Subscribe to recieve a mail when a game have been played',
    deleteSelected: 'Supprimer la sélection'
  },
  expiration: {
    summer: 'Été',
    winter: 'Hiver'
  },
  positions: {
    noposition: 'Pas de poste',
    goalkeeper: 'Gardien de but',
    goalkeepers: 'Gardiens de but',
    defender: 'Défenseur',
    defenders: 'Défenseurs',
    defenses: 'Défenseurs',
    fullback: 'Arrière',
    fullbacks: 'Arrières',
    midfielder: 'Milieu',
    midfielders: 'Milieux',
    winger: 'Ailier',
    wingers: 'Ailiers',
    forward: 'Avant-centre',
    forwards: 'Avant-centres',
    wingback: 'Ailier',
    wingbacks: 'Ailiers'
  },
  dPos: {
    1: {
      name: 'Goalkeeper',
      alias: ''
    },
    2: {
      name: 'Right Full Back',
      alias: 'RFB'
    },
    3: {
      name: 'Right Center Back',
      alias: 'RCB'
    },
    4: {
      name: 'Left Center Back',
      alias: 'LCB'
    },
    5: {
      name: 'Left Full Back',
      alias: 'LFB'
    },
    6: {
      name: 'Defensive Midfielder',
      alias: 'DM'
    },
    7: {
      name: 'Right Winger',
      alias: 'RW'
    },
    8: {
      name: 'Center Midfielder',
      alias: 'CM'
    },
    9: {
      name: 'Striker',
      alias: 'ST'
    },
    10: {
      name: 'Attacking Midfielder',
      alias: 'AM'
    },
    11: {
      name: 'Left Winger',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Comparer avec',
    lastSeasonSelectText: 'Saison dernière',
    lastAndCurrentSeasonSelectText: 'Dernière + Saison actuelle',
    currentSeasonSelectText: 'Saison actuelle',
    lastNgamesSelectText: 'Les {x} derniers matchs',
    npgVsXGTitle: 'Buts sans penalty VS xG',
    totalXGLabel: 'xG total',
    xGLabel: 'xG',
    totalNPGLabel: 'Buts sans penalty total',
    xGAgainstvsNPGAgainstTitle: 'xG Concédé VS Buts sans penalty concédé',
    totalXGAgainstLabel: 'xG Concédé total',
    xGAgainstLabel: 'xG Concédé',
    totalNPGAgainstLabel: 'Buts sans penalty concédé au total',
    xGvsxGAgainstTitle: 'xG VS xG Concédé',
    pointsVsXPointsTitle: 'Points Obtenus VS Points Attendus',
    xTTitle: 'Contrôle du Match',
    totalXPoints: 'Total des Points Attendus',
    totalPoints: 'Total des Points',
    requestedReports: 'Rapports Demandés',
    playersScouted: 'Joueurs Recherchés',
    performanceVSAverageChart: 'Performance VS Moyenne',
    perPositions: 'Par Postes',
    perLeagues: 'Par Ligues',
    perMonths: 'Por Mois',
    perClients: 'Par Client',
    ofPreposition: 'de',
    idJChartTitle: 'Initiative de Jeu',
    idJChartLabel: 'Indice IdJ',
    vJOChartTitle: 'Volume de Jeu Offensif',
    vJOChartLabel: 'Indice VJO',
    preJOChartTitle: 'Précision du Jeu Offensif',
    preJOChartLabel: 'Indice PreJO',
    proJOChartTitle: 'Progression du Jeu Offensif',
    proJOChartLabel: 'Indice ProJO',
    chart: 'Graphique',
    table: 'Tableau',
    showLeaguesWithAtLeast: 'Afficher les ligues avec au moins',
    playersScoutedSuffix: 'joueurs recherchés'
  },
  table: {
    history: {
      season: 'Saison',
      team: 'Équipe',
      position: 'Position',
      side: 'Côté',
      games: 'Matchs',
      minutes: 'Minutes',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Matchs Absents',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Saison',
      team: 'Équipe',
      injury: 'Blessure',
      dateFrom: 'Date de Début',
      dateTo: 'Date de Fin',
      daysLost: 'Jours perdus',
      gamesLost: 'Matchs ratés',
      allInjuries: 'All Injuries'
    },
    transfers: {
      season: 'Saison',
      date: 'Date',
      teamFrom: 'Équipe précédent',
      teamTo: 'Destination ',
      marketValue: 'Valeur Marchande',
      fee: 'Coût',
      type: 'Taper'
    },
    caps: {
      team: 'Équipe',
      debut: 'Début',
      games: 'Matchs',
      goals: 'Buts',
      coachDuringDebut: 'Entraîneur lors des Débuts',
      debutAge: 'Âge de début'
    },
    roster: {
      country: 'Pays',
      player: 'Joueur',
      positions: 'Postes',
      minutes: 'Minutes',
      games: 'Matchs',
      goals: 'Buts',
      assists: 'Passes Décisives',
      cards: 'Cartons',
      gamesExplicit: 'Matchs'
    },
    league: {
      title: 'Fiche de la ligue',
      subtitle: 'Approfondir le classement et les statistiques de la ligue',
      team: 'Équipe',
      games: 'M',
      gamesExplicit: 'Matchs',
      gamesRanking: 'M',
      gamesRankingExplicit: 'Matchs',
      points: 'Pts',
      pointsExplicit: 'Points',
      expectedPoints: 'PA',
      expectedPointsExplicit: 'Points Attendus',
      goalsScored: 'BNP',
      goalsScoredExplicit: 'Buts sans penaltis',
      xG: 'GE',
      xGExplicit: 'Buts Attendus',
      goalsAgainst: 'BC',
      goalsAgainstExplicit: 'Buts concédés',
      xGAgainst: 'BCC',
      xGAgainstExplicit: 'Buts Attendus Contre',
      xGAgainstDiff: 'GCE Dif.',
      xGAgainstDiffExplicit: 'Différence de buts attendue contre',
      form: 'Forme',
      sos: 'SoS',
      sosExplicit: 'Strength of Schedule',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Home Field Advantage',
      difficultyAboveAvg: 'Difficulty above average',
      differentGames: '* Nombre Différent de Matches Joués',
      berth: 'Note'
    },
    usersOfClient: {
      userName: 'Nom',
      userRole: 'Utilisateur',
      devRole: 'Développeur',
      adminRole: 'Administrateur',
      servicesRole: 'Services',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elevens',
      similarityRole: 'Similarite',
      gameAnalysisRole: 'Analyse du jeu',
      clientStatsRole: 'Stats des clients',
      created: 'Date de Création ',
      type: 'Type',
      logins: 'Accès',
      lastLogin: 'Dernière Connexion',
      trialDate: 'Date Limite'
    },
    clientLeagues: {
      league: 'Ligue',
      area: 'Domaine',
      tier: 'Niveau',
      seasons: 'Saison',
      currentMatchDay: 'Jour du match',
      regular: 'Régulier',
      youthLeague: 'Ligues des Jeunes',
      clientActive: 'Actif',
      visibleLeagues: 'Ligues visibles',
      male: 'Ligue masculine',
      female: 'Ligue féminine'
    },
    connections: {
      title: 'Combinaisons les plus Courantes',
      playerFrom: 'Passeur',
      playerTo: 'Receveur',
      passes: 'Passes',
      passesTooltip: 'Passes Réussies',
      passesFinalThird: 'PD ⅓',
      passesFinalThirdTooltip: 'Passes Dernier Tiers'
    },
    playerPassMapData: {
      title: 'Statistiques de passe',
      player: 'Joueur',
      passes: 'Passes',
      passesPct: '% Passes',
      xA: 'xA',
      xG: 'xG',
      xT: 'xT',
      playerTooltip: 'Nom du jouer',
      passesTooltip: 'Nombre total de passes effectuées',
      passesPctTooltip: 'Pourcentage de passes réussies',
      xATooltip: 'Asists Attendus',
      xGTooltip: 'Buts Attendus',
      xTTooltip: 'Danger Attendu'
    },
    playerAllGames: {
      gameDate: 'Date',
      game: 'Match',
      team: 'Équipe',
      positionsPlayed: 'Postes',
      minsPlayed: 'Minutes',
      gameActions: 'Actions',
      gameDateTooltip: 'Date du Match',
      gameTooltip: 'Match',
      positionsPlayedTooltip: 'Postes Occupés',
      minsPlayedTooltip: 'Minutes Jouées',
      gameActionsTooltip: 'Buts, Passes décisives, Cartons',
      from: 'Début',
      to: 'Fin',
      goalText: 'But à la',
      assistText: 'Assist à la',
      penaltyText: 'Penalty à la',
      ownGoalText: 'Propre but à la',
      yellowCardText: 'Carton jaune à la',
      secondYellowCardText: 'Deuxième Carton Jaune à la',
      redCardText: 'Carton Rouge à la',
      substitutionIN: 'Entre à la',
      substitutionOUT: 'Sort à la',
      suspendedText: 'Sanctionné',
      Team: 'Équipement'
    },
    gameFlow: {
      phase: 'Phase ',
      mins: 'Minutes',
      team: 'Équipe',
      period: 'Période',
      possession: 'Poss',
      possessionTooltip: 'Possession',
      xT: 'xT',
      xTTooltip: 'Danger attendu',
      pft: 'PDT',
      pftTooltip: 'Passes Dans le Dernier Tiers',
      xG: 'xG',
      xGTooltip: 'Buts Attendus'
    }
  },
  game: {
    title: 'Fiche de jeu',
    subtitle: 'Approfondir les caractéristiques et les statistiques du jeu',
    header: {
      gameDetails: 'Détails du Match',
      gameStats: 'Stats',
      gameFinishingMap: 'Carte des Tirs',
      gameKeyPassMap: 'Carte des passes décisives',
      gamePassMap: 'Carte des Passes',
      gameThreat: 'Carte de Danger',
      gameFlow: 'Contrôle du Match',
      gameAnalysis: 'Analyse du Match',
      gamePhysicalStats: 'Statistiques physiques',
      possessions: 'Possessions',
      bench: 'Banc',
      video: 'Video highlights',
      preGame: 'Avant-match',
      postGame: 'Après-match',
      areaCoverage: 'Couverture de la zone'
    },
    passMap: {
      typeOfPlay: 'Type de jeu:',
      passes: 'Passes:',
      team: 'Équipe',
      minutes: 'Minutes:',
      select: 'Sélectionnez',
      all: 'Tous',
      attacking: 'Attaque',
      defending: 'Défense',
      forwards: 'En avant',
      backwards: 'Derrière',
      sideways: 'Sur le côté',
      longBall: 'Passe Longue',
      successfullPasses: 'Passes Réussies',
      homeTeam: 'Domicile',
      awayTeam: 'Extérieur',
      passingMatrix: 'Matrice de Passage',
      passer: 'Passeur',
      receiver: 'Récepteur',
      passOutcome: 'Résultat de la Passe',
      passDirection: 'Direction de la Passe',
      half: 'Moitié',
      offensive: 'Offensive',
      defensive: 'Défensive',
      passingConnections: 'Connexions de passes',
      pitchView: 'Terrain',
      passSingular: 'Passe',
      passPlural: 'Passes',
      playerLocation: 'Emplacement du joueur',
      passLegend: 'Position tactile moyenne',
      minuteRange: 'Plage des minutes'
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: 'Possession',
      expectedPoints: 'Points Attendus',
      directness: 'Verticalité',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG a Coup de Pied',
      xA: 'xA',
      xASetPiece: 'xA a Coup de Pied',
      xT: 'xT',
      xTSetPiece: 'xT a Coup de Pied',
      touchesInOppBox: 'Touches Surface Adverse',
      passesFinalThird: 'Passes Dernier Tiers',
      interceptions: 'Interceptions',
      recoveries: 'Récupérations',
      recoveriesOppHalf: 'Récupérations Terrain Adverse',
      tackles: 'Tacles',
      tacklesWasDribbled: 'Duels défensifs 1 contre 1 gagnés',
      fouls: 'Fautes',
      yellowCards: 'Carton Jaune',
      redCards: 'Carton Jaune',
      passes: 'Passes Rouges',
      passing: 'Passes %',
      crosses: 'Centres',
      crossing: 'Centres %',
      shots: 'Tirs',
      shotsOnTarget: 'Tirs Cadrés',
      ppdaExplicit: 'Passes par action défensive',
      xgExplicit: 'Buts Attendus',
      xp: 'xP',
      ExpectedPassing: 'xP%',
      seasonAvg: 'Moyenne de la concurrence',
      winChanceTooltip: 'Probabilité de victoire basée sur les xG générés et concédés',
      drawChance: 'Match Nul',
      xgAgainst: 'xG Concédé',
      averagePossession: 'Possession',
      averageShots: 'Tirs',
      averagexG: 'Buts Attendus',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      recoveriesRate: 'Taux de récupération',
      turnoversRate: 'Taux de roulement'
    },
    detail: {
      halfTime: 'Mi-temps',
      overTime: 'Prolongation',
      showStats: 'Voir les statistiques',
      hideStats: 'Cacher les statistiques',
      bench: 'Banc',
      showShotOptions: 'Montrer les options de tir',
      hideShotOptions: 'Cacher les options de tir',
      showPassOptions: 'Montrer les options de passe',
      hidePassOptions: 'Cacher opciones de passe',
      endGame: 'Fin du match',
      penalties: 'Penalties'
    },
    timeline: {
      events: {
        goal: 'But',
        goal_ownGoal: 'But contre son camp',
        goal_penalty: 'But sur penalty',
        card: 'Carton',
        card_yellowCard: 'Carton Jaune',
        card_secondYellowCard: 'Deuxième Carton Jaune',
        card_redCard: 'Carton Rouge',
        formationChange: 'Changement de formation',
        substitution: 'Remplacement',
        saveShot: 'Tir',
        saveShot_penalty: 'Penalty arrêtés',
        missedShot: 'Tir raté',
        missedShot_penalty: 'Penalty raté',
        shotOnPost: 'Tir sur le Poteau',
        shotOnPost_penalty: 'Penalty sur Poteau',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'But de',
      redCardTo: 'Carton rouge pour',
      missedPenalty: 'Pénalité manquée'
    },
    gameThreat: {
      typeOfPlay: 'Type d\'action',
      regularPlay: 'Regular Play',
      setPiece: 'Coup de Pied',
      setPiecePlay: 'Coup de Pied',
      throwInSetPiecePlay: 'Throw In Play',
      throwInPlay: 'Throw In Play',
      gkThrow: 'Coup de pied du gardien',
      gkKick: 'But de coup de pied',
      kickOff: 'Démarrer',
      actionEnding: 'Fin de l\'action',
      pass: 'Passe',
      shot: 'Tir',
      foul: 'Faute',
      other: 'Autre',
      threat: 'Danger',
      legendSumOfXT: 'Somme xT',
      legendPass: 'Passe',
      legendShot: 'Tir',
      legendCarryAndAction: 'Portage et action',
      legendCarryAndPass: 'Portage et Passe',
      legendOnlyShowing: '· Afficher uniquement les actions avec xT > ',
      legendOnlyShowingPart1: 'Afficher uniquement',
      legendOnlyShowingPart2: 'actions avec xT > ',
      legendOnlyShowingSetPiece: '· Montrer les actions de Coup de Pied avec xT > ',
      legendOnlyShowingOpenPlay: '· Afficher uniquement les actions en jeu avec xT > ',
      legendPlays: 'Actions',
      legendPerPlay: 'par Action',
      legendCarry: 'Portage',
      penaltyPlay: 'Penalty',
      freeKickTakenPlay: 'Coup Franc',
      cornerTakenPlay: 'Corner Réalisé',
      fromCornerPlay: 'Corner',
      keeperThrowPlay: 'Coup de Pied de but',
      fastBreakPlay: 'Jeu de contre-attaque',
      indirectPlay: 'Jeu indirect',
      minutes: 'Minutes',
      games: 'Matchs',
      xT: 'xT',
      xTPer90: 'xT par 90\''
    },
    gameAnalysis: {
      next: 'Prochain',
      previous: 'Précédente',
      phaseLabel: 'Phase',
      phasesLabel: 'Phases',
      dot: '. ',
      comma: ', ',
      from: 'De',
      to: 'À',
      and: ' et ',
      steps: {
        finishingMapFullGame: 'Carte de Tirs',
        keyPassMapFullGame: 'Carte de Passe Décisive',
        gameFlow: 'Flux du jeu',
        finishingMapPerPhases: 'Carte de Tirs par Phases',
        keyPassMapPerPhases: 'Carte de Passe Décisive par Phases',
        passMapPerPhases: 'Carte de Passes par Phases'
      },
      step1: {
        table: {
          draw: 'Match nul',
          win: 'Victoire',
          lose: 'Lose',
          possession: 'Possession',
          xP: 'Points Attendus',
          directness: 'Verticalité',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG en Jeu',
          xGSetPiece: 'xG a Coup de Pied',
          xA: 'xA',
          xAOpenPlay: 'xA en Jeu'
        },
        text: {
          firstParagraph: {
            1: 'La carte de droite montre les buts attendus générés par le nom de home_team_name et le away_team_name. Les cercles remplis sont les tirs qui ont terminé par un but. La taille des cercles dépend de la valeur xG de chaque tir.'
          },
          lastParagraph: {
            1: 'La probabilité de victoire et le nombre de points attendus sont calculés à partir des tirs (100 000 simulations de chaque tir en prenant sa probabilité de marquer).'
          },
          targetHighTeamXG: {
            1: 'target_team_name, ainsi que rival_team_name, ont généré un volume élevé de buts attendus'
          },
          targetHighTeamOpenPlayXG: {
            1: 'Dans ce match, la majorité des occasions de target_team_name proviennent des actions en jeu'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'Dans ce match, la plupart des occasions de target_team_name proviennent des actions en jeu (contrairement à celles de rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'Dans ce match, la plupart des occasions de target_team_name ont été obtenues sur des coups de pied'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'Dans ce match, la plupart des occasions de target_team_name ont été obtenues sur des coups de pied (contrairement à celles de rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'Dans ce match, la plupart des occasions de target_team_name proviennent de corners'
          },
          targetLowTeamGoalConversion: {
            1: ' mais la conversion des buts était faible'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name a créé un volume élevé de buts attendus, tant sur les actions en jeu que sur les coups de pied '
          },
          targetHighTeamGoalConversion: {
            1: ' ayant également une grande capacité à convertir ces occasions en buts. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', sans pouvoir marquer sur aucune des occasions créées'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' mais a créé un danger pour marquer plus de buts'
          },
          targetHighTeamXGvsGameRival: {
            1: 'Dans cette rencontre, target_team_name a généré plus de danger que rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' et aurait pu marquer plus de buts. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' mais n\'a pas pu profiter des occasions créées pour marquer un but. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' avec une chance de gagner de team_winning_chance selon notre simulation d\'après-match. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' La plupart des opportunités de target_team_name proviennent de jeux. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' La plupart des occasions créées par target_team_name proviennent de coups de pied. '
          },
          startTargetHighTeamCornerXG: {
            1: ' La plupart des occasions ont été générées par des corners. '
          },
          targetSimilarTeamXG: {
            1: 'Pendant ce match, en termes de buts attendus, les deux équipes ont généré un xG similaire à celui de leurs adversaires., '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'mais target_team_name a fait mieux quand il s\'est agi de terminer ces occasions. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Quel que soit le résultat, target_team_name n\'a pas généré beaucoup de danger pour le rival en termes d\'espérance de buts. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name n\'a pas généré suffisamment de danger pour l\'adversaire en termes de buts attendus pour gagner le match'
          },
          rivalHighTeamXG: {
            1: 'et a permis à l\'équipe de générer trop de danger. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' C\'est un match que target_team_name ne gagnerait qu\'une team_winning_chance des fois selon notre simulation d\'après-match. '
          },
          targetHighTeamGoalConversion2: {
            1: ' ayant un taux de conversion des buts élevé'
          },
          winningChance: {
            1: ' Compte tenu du nombre de tirs et du nombre de xG des deux équipes, target_team_name urait dû gagner ce match team_winning_chance des cas. '
          },
          highPlayerXGManyShots: {
            1: ' Il est intéressant de noter que player_name a généré xg_value xG sur les shots_value tirs'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' ayant besoin de xg_value xG pour marquer un but. '
          },
          highPlayerXGOneGoal: {
            1: ' pour marquer le but. '
          },
          highPlayerXGAnyGoal: {
            1: ', bien qu\'il n\'ait pas réussi à marquer un but. '
          },
          highPlayerXGNotManyShots: {
            1: 'Il est intéressant de noter que player_name a généré xg_value xG dans quelques tirs'
          },
          highManyPlayerXG: {
            1: 'Il est intéressant de noter que le player_name et le player_name2 ont généré xg_value et xg_value2 <b>xG</b> respectivement. '
          },
          highTeamXGPerShot: {
            1: 'Quant à la sélection des tirs effectués par target_team_name, ils ont été très bons en termes de probabilité de devenir un but, avec une moyenne de xG par tir de xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'La sélection des tirs de target_team_name était bien meilleure que celle de rival_team_name, avec une moyenne de xg_per_shot_value xG par tir. '
          },
          xGTimesNotAfter70xG: {
            1: 'Malgré le nombre élevé de XG générés, target_team_name a eu du mal à créer le danger en fin de match. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name a créé beaucoup de danger, surtout au début des deux mi-temps. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name l\'équipe a créé beaucoup de danger, surtout à la fin des deux mi-temps. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name a créé la plupart des dangers au début de la première mi-temps. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name a créé la plupart des dangers à la fin de la première mi-temps. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name a créé la plupart des dangers au début de la deuxième mi-temps. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name a créé la plupart des dangers à la fin de la deuxième mi-temps. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name a démarré le match très fort avec des occasions qui ont générées xg_value <b>goles esperados</b>. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name a terminé la première moitié du match avec des occasions qui ont généré xg_value buts attendus. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name est sortie de la pause avec des occasions qui ont généré  xg_value buts attendus. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name a terminé la deuxième mi-temps avec des occasions qui ont généré xg_value buts attendus. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name a créé beaucoup de danger à la fin de la deuxième mi-temps. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name a créé beaucoup de danger au début de la deuxième mi-temps. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name a créé beaucoup de danger à la fin de la première mi-temps. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name a créé beaucoup de danger au début de la première mi-temps. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name a généré la plupart de ses dangers en première mi-temps, tandis que son rival_team_name a fait de même en seconde période. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name a généré la plupart de ses dangers en seconde période alors que sonrival_team_name a fait de même en première période. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'C\'est un match dans lequel la plupart des dangers en termes de buts attendus ont été générés en première mi-temps. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'EC\'est un match dans lequel la plupart des dangers en termes de buts attendus ont été générés en deuxième mi-temps. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name a réussi à créer la plupart des dangers en première mi-temps. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name a réussi à créer la plupart des dangers pendant la deuxième mi-temps. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name a concédé la plupart des dangers en termes de buts attendus en première mi-temps. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name a concédé la plus grande partie du danger en termes de buts attendus au cours de la deuxième mi-temps. '
          },
          highInBoxXG: {
            1: ' Nous pouvons voir sur la carte des tirs que la plupart des dangers provenaient de tirs à l\'intérieur de la zone. '
          },
          highOutOfBoxXG: {
            1: 'Nous pouvons voir sur la carte des tirs que, dans ce match, target_team_name a généré beaucoup de danger depuis l\'extérieur de la surface. '
          },
          highInBoxXGRival: {
            1: 'Nous tenons à souligner que la plupart des dangers concédés par target_team_name proviennent de tirs dans la surface de réparation. '
          },
          highInBoxXGRival2: {
            1: ' Il est également intéressant de noter que la plupart des dangers concédés par target_team_name provenaient de tirs dans la surface de réparation. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name a bien fait d\'éviter le danger à l\'intérieur de la surface de réparation. '
          },
          highTeamChancesHighPPDARival: {
            1: 'Le manque de pression de target_team_name, qui autorise ppda_value passes par action défensive, a été l\'une des clés pour que rival_team_name crée un grand nombre d\'occasions. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name l\'équipe n\'a autorisé que ppda_value Passes par action défensive étant l\'une des clés de la victoire. '
          },
          lowPPDA: {
            1: 'target_team_name a fait un excellent travail en perturbant le jeu de rival_team_name ne permettant qu\'une moyenne de ppda_value Passes par action défensive. '
          },
          highPossession: {
            1: 'target_team_name avait le contrôle du ballon avec une possession_value de possession'
          },
          highPPDARival: {
            1: ' ainsi qu\'une distribution fluide de la balle'
          },
          chancesCreated: {
            1: ', ce qui leur a permis d\'avoir un nombre élevé d\'opportunités de jeu ouvert(chances_value). '
          },
          chancesCreatedRival: {
            1: ', bien que rival_team_name ait été capable de créer un grand nombre d\'occasions de jeu ouvert (chances_value). '
          },
          xGPerShotRival: {
            1: ', bien que rival_team_name ait été capable de créer plus de chances de danger avec une valeur de xg_per_shot_value <b>xG por tiro</b>. '
          },
          winGame: {
            1: ' étant l\'une des clés pour gagner le match. '
          },
          notEnoughWinGame: {
            1: ' ne pas être suffisant pour gagner le match. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Le premier but est venu d\'un player_error_name profité par player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Le premier et unique but a été marqué par une erreur de player_error_name profité par player_name'
          },
          lastPhaseOfGame: {
            1: ' dans la dernière phase du jeu. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Le but final pour gagner le match est venu d\'une erreur du player_error_name qui a conduit au but du player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Le dernier but pour égaliser le match est venu d\'une erreur de la part de player_error_name qui a conduit au but du player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Une erreur du player_error_name a permis à target_team_name d\'égaliser le score'
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name s\'est avancé, profitant d\'une erreur de la part de player_error_name'
          },
          xGChance: {
            1: ' avec une possibilité de xg_value <b>xG</b>. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'Le but final de rival_team_name pour gagner le match est venu d\'une erreur de player_error_name qui a conduit au but du player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Une erreur du player_error_name a conduit à une opportunité d\'égaliser le match pour rival_team_name'
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name a pris l\'avantage en profitant d\'une erreur du player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name a marqué la seule grosse occasion créée pendant le match, c\'est-à-dire le but de player_name que nous voyons dans la carte des buts attendus avec une valeur de <b>xG</b> de xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name a marqué toutes les occasions qu\'il a créées pendant le match'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name a eu la seule chance de marquer un but pour target_team_name avec un <b>xG</b> de xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name n\'a pu marquer aucune des chances_value chances supérieures à 40% de chances de devenir un but. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name a eu l\'occasion de xg_value <b>xG</b> pour prendre la tête. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name a eu chances_value chances avec <b>xG</b> plus de 40% pour prendre l\'avantage dans le match. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name tuvo chances_value des occasions avec une grande <b>xG</b> pour prende l\'avantage dans le match. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name a eu l\'occasion de prendre l\'avantage de xg_value <b>xG</b> qui a frappé le poteau. '
          },
          beforeEndOfGame: {
            1: 'Avant la fin du match, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name avait une chance de xg_value <b>xG</b> pour gagner le match. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name a eu chances_value ocasiones avec une probabilité de but de plus de 40% pour prendre les 3 points.. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name tuvo chances_value ocasiones avec un <b>xG</b> élevé pour gagner le match. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name a profité d\'une grande opportunité avec une valeur de xg_value <b>xG</b> pour prendre l\'avantage. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name a eu chances_value chances avec un <b>xG</b> supérieur à <b>40%</b> pour prendre l\'avantage. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name a apprécié chances_value des chances avec un xG élevé pour prendre l\'avantage. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name a apprécié une chanche avec une xg_value <b>xG</b> pour prendre l\'avantage mais la balle a frappé le poteau. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name a eu une chance de xg_value <b>xG</b> pour égaliser le match mais n\'a pas eu de chance. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name a eu chances_value des chances pour égaliser le match avec une probabilité de but de plus de 40%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name a eu une chance de xg_value <b>xG</b> pour égaliser le match mais il a frappé le poteau. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Match Nul',
          win: 'Victoire',
          possession: 'Possession',
          xP: 'Points Attendus',
          directness: 'Verticalité',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA en Jeu',
          xASetPiece: 'xA Coups de Pied',
          chancesCreated: 'Opportunités Créées',
          shotsOnTarget: 'Tirs Cadrés'
        },
        text: {
          firstParagraph: {
            1: 'L\'image montre\' les <b>Passes décisives Attendus</b> de <b>home_team_name</b> y <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA pour chaque passe clé. '
          },
          keyPassesGeneratedFrom: {
            1: ', notamment les passes clés générées par '
          },
          highTeamXAvsXG: {
            1: 'Comme nous pouvons le voir sur la carte xA, la plupart des dangers créés par target_team_name proviennent de jeux combinés plutôt que d\'actions individuelles'
          },
          openPlay: {
            1: 'en jeu'
          },
          setPiece: {
            1: 'Coup de pied'
          },
          cornerKicks: {
            1: 'aux corners'
          },
          combinationPlays: {
            1: 'jeux combinés'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'Dans ce match, target_team_name a créé le danger dans les deux jeux combinés'
          },
          individualActions: {
            1: ' comme dans les actions individuelles.'
          },
          dangerFromIndividualActions: {
            1: 'Dans ce match, la plupart des dangers générés par  target_team_name provenaient du jeu individuel.'
          },
          highTeamXAvsXGRival: {
            1: ' Les chances  que target_team_name a concédées pendant le match proviennent de jeux combinés, comme on peut le voir sur la carte de xA.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name a été fort sur les passes clés générées'
          },
          manyPlayerKeyPasses: {
            1: 'Il est intéressant de noter que <b>player_name</b> a généré <b>xa_value xA</b> dans <b>key_passes pases clave</b>'
          },
          playerAssists: {
            1: ' En besoin de <b>xa_per_assist xA par assist</b>.'
          },
          giveAssist: {
            1: ' pour faire la passe décisive.'
          },
          noAssists: {
            1: ', même si aucune de ses passes ne s\'est terminée par être une passe décisive.'
          },
          highXANotManyShots: {
            1: 'Il est intéressant de noter que <b>player_name</b> a créé <b>xa_value xA</b> en quelques passes seulement'
          },
          manyPlayersHighXA: {
            1: 'Il est intéressant de noter que <b>player_name</b> y <b>player_name2</b> ont généré <b>xa_value</b> et <b>xa_value2 xA</b> respectivement.'
          },
          xATimes: {
            1: 'target_team_name a créé la plupart de ses dangers en première mi-temps, tandis que rival_team_name a fait de même en '
          },
          firstHalf: {
            1: ' première mi-temps.'
          },
          secondHalf: {
            1: ' deuxième mi-temps.'
          },
          left: {
            1: 'côté gauche '
          },
          center: {
            1: 'centre '
          },
          right: {
            1: 'côté droit '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'C\'est un match où la plupart des dangers, en termes des buts attendus, ont été générés pendant la '
          },
          xAFirstHalf: {
            1: 'target_team_name l\'équipe a causé la plupart de ses dangers dans le'
          },
          xATimesXARival: {
            1: 'target_team_name  a concédé trop de danger en termes des buts dans les '
          },
          xASides: {
            1: ' La plupart des dangers générés par target_team_name a été produit à partir du side_name (<b>xa_value xA</b>)'
          },
          xASidesRival: {
            1: 'tandis que le rival_team_name est celui qui a généré le plus de (<b>xa_value xA</b>)'
          },
          dangerCreationRival: {
            1: 'La création de danger de rival_team_name viene, d\'autant plus que le side_name (<b>xa_value xA</b>).'
          },
          speciallyEffective: {
            1: 'target_team_name a été particulièrement efficace dans '
          },
          xAPerChanceCreated: {
            1: ' avec une moyenne de <b>xa_value xA</b>'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name a été particulièrement efficace dans '
          }
        }
      },
      step3: {
        text: {
          chance: ' Chance',
          chances: ' Chances',
          goal: ' But',
          goals: ' Buts',
          home: 'À domicile',
          away: 'À l\'exterieur',
          last: 'dernier',
          first: 'premier',
          goalScorer: 'buteur',
          goalScorers: 'buteurs',
          lastPhase: 'Dans la dernière portion du match, ',
          phase: {
            1: 'A ce phase_position stade du match, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> a généré plus de danger (<b style=\'color:more_color\'>more_xt_team_value xT</b>) que <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'et l\'a fait pendant plus de minutes de jeu (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> face à <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> de son adversaire)'
          },
          rivalTeamMoreMinutes: {
            1: 'Cependant, c\'est son rival qui a généré le danger pendant plus longtemps. (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> of the rival) dans cette période du jeu'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> est l\'équipe qui a créé le plus de danger (<b style=\'color:max_color\'>max_xt_team_value xT</b>) au <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', tandis que le <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> ont généré la plupart de leurs dangers(<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) au <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Les deux équipes ont réussi à battre le gardien de but adverse en <b>number_of_goals_each_team</b> chacun. L\'équipe locale à travers <b style=\'color:#3366FF\'>home_player_name_goals</b> et l\'équipe à l\'extérieur par <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'En termes d\'objectifs, <b style=\'color:replace_color\'>goal_scored_team_name</b> battre son rival par <b style=\'color:replace_color\'>difference_number_of_goals</b> de différence en battant leur gardien de but avec <b style=\'color:replace_color\'>home_player_name_goals</b> comme goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: 'Équipe',
          period: 'Mi-temps',
          possession: 'Pos.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG EJ',
          tooltip: {
            team: 'Équipe',
            period: 'Mi-temps',
            possession: 'Possession',
            ppda: 'Passes Par Action Défensive',
            xGOpenPlay: 'xG en Jeu'
          }
        },
        text: {
          clearly: 'clairement',
          very: 'très ',
          haveGotText1: 'Seulement obtenu',
          haveGotText2: 'aurait dû obtenir plus que',
          gaveUpPoss: 'a cédé la possession',
          lostPoss: 'a perdu la possession du ballon',
          too: 'aussi ',
          possession: {
            1: 'Pendant cette phase du jeu team_name clearly_text a contrôlé la possession du ballon.'
          },
          equalPossession: {
            1: 'Aucune des deux équipes n\'a dominé l\'autre dans cette partie du match car le maniement du ballon était assez équilibré, même si en regardant les chiffres, <b style=\'color:team_color\'>team_name</b> a légèrement surclassé ses adversaires avec une <b style=\'color:team_color\'>possession_value%</b> de possession'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> avec une mauvaise pression autorisée <b style=\'color:rival_team_color\'>rival_team_name</b> de donner <b style=\'color:target_team_color\'>ppda_value Passes per Defensive Action</b>'
          },
          lowPossessionLowPPDA: {
            1: ', mais <b style=\'color:target_team_color\'>target_team_name</b> a bien pressé le ballon quand rival_team_name était en possession du ballon, avec un <b>PPDA</b> de <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' et a pu jouer grâce à une very_textlow intensité de pression de rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ' bien que l\'intensité de pression de rival_team_name était very_texthigh'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> a saisi une possession élevée donnant <b>pft_value</b> <b>Passes dans le dernier tiers</b> du terrain. '
          },
          highPossessionMidLowPFT: {
            1: 'Indépendamment d\'une possession élevée, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passes dans le dernier tiers</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Même si <b style=\'color:target_team_color\'>target_team_name</b> possession_text pendant cette phase, il a pu donner <b>pft_value</b> <b>Passes in the Final Third</b>. '
          },
          midPossessionHighPFT: {
            1: 'Une possession assez égale pendant cette phase n\'a pas empêché  <b style=\'color:target_team_color\'>target_team_name</b> de donner <b>pft_value</b> <b>Passes dans le dernier tiers</b>. '
          },
          highPFTHighTouchesIOB: {
            1: ' En plus de contrôler le jeu dans le dernier tiers, <b style=\'color:target_team_color\'>target_team_name</b> a également eu beaucoup de présence dans la boîte des rivaux.'
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> ont contrôlé le ballon dans le dernier tiers, mais n\'ont pas réussi à faire entrer beaucoup de ballons dans la surface adverse'
          },
          highPFTMidTouchesIOB: {
            1: 'Compte tenu du nombre de <b>Passes dans le dernier tiers</b>, <b style=\'color:target_team_color\'>target_team_name</b> aurait dû créer plus de danger dans la surface de réparation adverse'
          },
          lowPFTHighTouchesIOB: {
            1: 'Bien que <b style=\'color:target_team_color\'>target_team_name</b> n\'ait pas effectué beaucoup de passes dans le dernier tiers, elle a pu atteindre la surface adverse à plusieurs reprises. '
          },
          midPFTHighTouchesIOB: {
            1: 'Compte tenu du nombre de passes effectuées dans le dernier tiers, <b style=\'color:target_team_color\'>target_team_name</b> a réussi à atteindre la surface de réparation de l\'équipe adverse à plusieurs reprises. '
          },
          maxDirectness: {
            1: 'Il est utile de souligner que c\'est la phase du jeu pendant laquelle<b style=\'color:max_dir_color\'>target_team_name</b> l\'équipe a joué de manière plus offensive avec un <b>Directness</b> de <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> a été capable de générer plus de xG que dans les autres phases du jeu. '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> a réussi à générer un volume élevé de Buts Attendus'
          },
          highXG: {
            1: 'a généré un bon volume de Buts Attendus'
          },
          highXGLowPossession: {
            1: ' malgré le fait de ne pas avoir le contrôle de la balle.'
          },
          highXGLowShots: {
            1: ' seulement dans quelques plans, ayant un <b>xG per Shot</b> de <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' bien que le xG par tir était too_textlow. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> n\'a pas été en mesure de générer du danger pour l\'équipe rivale'
          },
          lowXGMinXG: {
            1: 'En termes de génération d\'objectifs attendus, c\'était une mauvaise étape pour <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> généré un très faible volume de Buts Attendus'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> n\'a pas été en mesure de générer un bon volume de Buts Attendus'
          },
          lowXGHighPossession: {
            1: ' même s\'ils avaient le contrôle de la balle. '
          },
          lowXGHighShots: {
            1: ' malgré les nombreux tirs'
          },
          lowXGHighPFT: {
            1: ' malgré l\'achèvement de <b>pft_value</b> <b>Passes dans le Dernier Tiers</b> du terrain. '
          },
          midXGQuintileMinXG: {
            1: 'Bien que la génération de xG n\'ait pas été mauvaise, c\'était la phase la plus faible du jeu pour <b style=\'color:target_team_color\'>target_team_name</b> à cet égard'
          },
          midXGQuintileMaxXG: {
            1: 'C\'est la phase pendant laquelle <b style=\'color:target_team_color\'>target_team_name</b> a été capable de générer le plus grand <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Équipe',
          period: 'Mi-temps',
          possession: 'Poss.',
          directness: 'Vert.',
          passesFinalThird: 'PD ⅓',
          tooltip: {
            team: 'Équipe',
            period: 'Mi-temps',
            possession: 'Possession',
            directness: 'Verticalidad',
            passesFinalThird: 'Passing Dernier Tiers'
          }
        },
        text: {
          last: 'dernier',
          goal: 'but',
          goals: 'buts',
          chance: 'chance',
          chances: 'chances',
          first: 'premier',
          homeTeam: 'Les locaux',
          awayTeam: 'Les visiteurs',
          home: 'locale',
          away: 'visiteur',
          clearly: 'clairement',
          slightly: 'légèrement',
          firstOrLastPhase: {
            1: 'Dans cette phase_position de la rencontre, ',
            2: 'En ce qui concerne la phase_position du match, '
          },
          phase: {
            1: 'Pendant cette partie du match, '
          },
          bothZeroGoalsScored: {
            1: 'aucune des deux équipes n\'a réussi à changer le score du match.'
          },
          equalGoalsScored: {
            1: 'arriver à marquer <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'arriver à marquer'
          },
          equalPossesion: {
            1: 'les deux équipes ont eu le ballon pendant exactement un <b>poss_value%</b> del tiempo'
          },
          morePossesion: {
            1: '<b>more_poss_team_name</b> a eu le ballon pendant plus de minutes (<b>more_poss_team_value%</b> del tiempo) que leur adversaire (<b>less_poss_team_value%</b> del tiempo)'
          },
          equalDirectness: {
            1: 'les deux équipes ont développé un jeu avec la même verticalité (<b>directness_value</b> cada uno)'
          },
          moreDirectnessSameTeam: {
            1: 'Ils ont également été plus verticaux que leurs adversaires, développant un jeu avec une verticalité de <b>more_dir_team_value</b> par rapport à <b>less_dir_team_value</b>.'
          },
          moreDirectnessDifferentTeam: {
            1: 'Cependant, ce sont ces derniers qui ont joué le plus verticalement(<b>more_dir_team_value</b>) par rapport à <b>less_dir_team_value</b>.'
          },
          equalChancesCreated: {
            1: 'Les deux équipes, à domicile et à l\'extérieur, ont créé le même nombre d\'occasions, spécifiquement <b>chances_created_value</b> chances.'
          },
          moreChancesCreated: {
            1: '<b>less_cc_team_name</b> n\'a créé que <b>less_cc_team_value ocasiones</b> il a donc été surpassé adverb_text par son adversaire (<b>more_cc_team_value ocasiones creadas</b>). '
          },
          equalXA: {
            1: 'Les locaux et les visiteurs ont eu les mêmes opportunités, ce qui se reflète dans le <b>xa_value de Asistencias Esperadas</b>, '
          },
          moreXA: {
            1: 'home_away a généré <b>diff_xa_team_value Asistencias Esperadas</b> (<b>more_xa_team_value</b> par rapport à <b>less_xa_team_value</b>) plus que des rival, '
          },
          xAOpenPlay: {
            1: 'générant, respectivement, <b>more_xa_op_value</b> et <b>less_xa_op_value</b> avec le ballon en jeu.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' chacun ',
          respectively: ', respectivement',
          with: ' (ensemble avec <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'joueur était',
          playerWere: 'joueur était',
          firstPhase: {
            1: 'Dans cette première partie du match, soulignez ',
            2: 'En ce qui concerne la première partie du match, il convient de souligner '
          },
          otherPhase: {
            1: 'Entre les <b style=\'color:replace_color\'>min_from\'</b> et le <b style=\'color:replace_color\'>min_to\'</b> il convient de mentionner  '
          },
          lastPhase: {
            1: 'Dans la dernière partie du match, il convient de mentionner ',
            2: 'En ce qui concerne la dernière phase du match, citez '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b> avec le plus grand nombre de passes réussies de son équipe, précisément <b style=\'color:replace_color\'>successfull_passes_value pases</b> '
          },
          playerMaxTotalPasses: {
            1: 'qui prend encore plus de valeur quand on voit qu\'il a aussi été'
          },
          playerMaxTotalPasses2: {
            1: 'with_text le joueur qui a tenté le plus de passes (<b style=\'color:replace_color\'>total_passes_value pases</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'bien qu\'il n\'ait pas été celui qui a tenté le plus de passes (<b style=\'color:replace_color\'>player_name</b> con <b style=\'color:replace_color\'>total_passes_value pases</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'essayant pendant cette période <b style=\'color:replace_color\'>total_passes_value pases</b> chacun. '
          },
          playerMaxPctPasses: {
            1: 'En ce qui concerne le <b style=\'color:replace_color\'>% de Pases Completados</b> souligner <b style=\'color:replace_color\'>player_name</b> avec un grand <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'En ce qui concerne le taux de réussite des passes, il convient de mentionner <b style=\'color:replace_color\'>player_name</b> con un <b style=\'color:replace_color\'>max_pct_passes_value%</b> d\'efficacité dans ses passes. '
          },
          playerSumTotalXG: {
            1: 'Pendant cette période, l\'équipe a généré un total de <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Pendant cette période, le <b style=\'color:replace_color\'>team_name</b> a créé un <b style=\'color:replace_color\'>xG</b> de <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Malgré un total de <b style=\'color:replace_color\'>all_team_total_passes pases</b> l\'ensemble de l\'équipe, a été vaine puisqu\'ils n\'ont pas réussi à se créer la moindre occasion. ',
            2: 'Les <b style=\'color:replace_color\'>all_team_total_passes pases</b> marqués au cours de cette période ont été inutiles car ils n\'ont pas généré la moindre occasion de but. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'en étant <b style=\'color:replace_color\'>player_xg_name</b> avec <b style=\'color:replace_color\'>xg_value xG</b> et <b style=\'color:replace_color\'>player_xa_name</b> avec <b style=\'color:replace_color\'>xa_value xA</b> les joueurs les plus remarquables en termes de création d\'opportunités. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'en étant <b style=\'color:replace_color\'>player_name</b> avec <b style=\'color:replace_color\'>xg_value xG</b> et <b style=\'color:replace_color\'>xa_value xA</b> le créateur d\'un grand nombre d\'occasions créées par son équipe. '
          },
          playersMaxXGMaxXA: {
            1: 'grâce, entre autres, à <b style=\'color:replace_color\'>players_name</b> qui ont causé <b style=\'color:replace_color\'>xa_value xA</b> chacun avec ses passes-clés. '
          },
          playerMaxXGZeroXA: {
            1: 'en étant <b style=\'color:replace_color\'>player_xg_name</b> avec <b style=\'color:replace_color\'>xg_value xG</b> qui s\'est taillé la plus grande part des occasions, devant les créer lui-même car il n\'a pas reçu de passes clés. '
          },
          playersMaxXGZeroXA: {
            1: 'en étant <b style=\'color:replace_color\'>player_xg_name</b> avec <b style=\'color:replace_color\'>xg_value xG</b> qui ont eu le plus d\'occasions, devant les créer eux-mêmes car ils n\'ont pas reçu de passes clés. '
          },
          oneMaxConnections: {
            1: 'La paire qui a fait le plus de passes entre elles pendant cette partie du match est la paire formée par <b style=\'color:replace_color\'>couple_name</b>, avec un total de <b style=\'color:replace_color\'>connections_value pases</b>. ',
            2: 'Le duo formé par<b style=\'color:replace_color\'>couple_name</b> ont été échangés <b style=\'color:replace_color\'>connections_value</b> fois la balle. ',
            3: 'Le duo <b style=\'color:replace_color\'>couple_name</b>  étaient ceux qui passaient le plus le ballon dans cette partie du match, le faisant même en <b style=\'color:replace_color\'>connections_value</b> chances. '
          },
          twoMaxConnections: {
            1: 'Les deux couples formés par <b style=\'color:replace_color\'>couple_name</b> et <b style=\'color:replace_color\'>couple_name2</b> ont été les connexions les plus répétées pour cette période, se passant le ballon <b style=\'color:replace_color\'>connections_value</b> chances. '
          },
          moreThanTwoMaxConnections: {
            1: 'Plusieurs paires de joueurs, telles que <b style=\'color:replace_color\'>couple_name</b>, ont fait jusqu\'à <b style=\'color:replace_color\'>connections_value pases</b> entre eux. '
          },
          oneMinConnections: {
            1: 'Au contraire, ils ont été <b style=\'color:replace_color\'>couple_name</b> qui se sont le moins passé le ballon, seulement <b style=\'color:replace_color\'>connections_value pases</b>. ',
            2: 'A l\'autre extrême, nous avons le tandem composé par <b style=\'color:replace_color\'>couple_name</b> qui ont seulement connecté <b style=\'color:replace_color\'>connections_value</b> fois. '
          },
          twoMinConnections: {
            1: 'D\'un autre côté, dire que <b style=\'color:replace_color\'>couple_name</b> et <b style=\'color:replace_color\'>couple_name2</b> ils ont à peine échangé des passes entre eux (<b style=\'color:replace_color\'>connections_value pases</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Il y a eu plusieurs combinaisons qui n\'ont pas assez bien fonctionné, comme c\'est le cas du duo <b style=\'color:replace_color\'>couple_name</b> que avec <b style=\'color:replace_color\'>connections_value pases</b> sont parmi les combinaisons les moins fréquentes.'
          }
        }
      },
      step7: {
        ballPossession: 'Possession du ballon',
        gamePossessionDist: 'Répartition des possessions de balle'
      }
    },
    gamePossessionMap: {
      of: 'de',
      to: 'à',
      and: 'et',
      endsWith: 'Se termine avec',
      time: 'Temps',
      touches: 'Touches',
      passes: 'Passes',
      threat: 'Danger',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minutes',
      duration: 'Durée',
      endsGoal: 'Termine à Gol',
      endsInBox: 'Termine dans la Région',
      withShot: 'Avec Tir',
      withCross: 'Avec Centre',
      possession: 'Possession',
      events: 'Événement',
      filters: 'Filtres',
      filtersWarning: 'Le danger ne s\'applique qu\'aux possessions sans tirs',
      sumWarning: 'Le filtre s\'applique à la somme des xG de tous les tirs de la séquence, c\'est pourquoi elle peut dépasser 1',
      show: 'Afficher',
      sequenceNumbers: 'Numéros de Séquence',
      jerseyNumbers: 'Dossiers',
      pass: 'Passe',
      carryAndPass: 'Portage et Passe',
      carryAndAction: 'Portage et Action',
      carryAndShot: 'Portage et Tir',
      shotFailed: 'Tir Raté',
      goal: 'But',
      savedShot: 'Tir Arrête',
      missedShot: 'Tir Raté',
      shotOnPost: 'Tir au Barre',
      headerGoal: 'But de la Tête',
      headerFailed: 'Tête Manquée',
      failed: 'raté',
      with: 'avec'
    },
    report: {
      title: 'Game Report',
      maps: 'Maps',
      xGRace: 'xG Race',
      lineups: 'Lineups',
      button: 'Générer un rapport PDF complet du jeu',
      mobileButton: 'Rapport PDF',
      most: 'La plupart',
      topXPlayers: 'Meilleurs {x} joueurs',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Rapport sur les données physiques du jeu'
    },
    avgScoreTooltip: 'Score moyen par minute',
    status: {
      scheduled: 'Programmé',
      postponed: 'Reporté',
      cancelled: 'Annulé',
      inPlay: 'En direct',
      finished: 'Fini',
      awarded: 'Récompensé',
      dataAvailable: 'Les données seront disponibles dans les prochaines heures'
    },
    preGameAnalysis: {
      showExpectations: 'Afficher les attentes',
      hideExpectations: 'Masquer les attentes',
      goalsPeriods: 'Périodes d\'objectifs',
      synergyIndex: 'Indice de synergie',
      synergyIndexSubtitle: 'Force globale de la connexion passeur-finisseur'
    }
  },
  general: {
    1: 'Un',
    2: 'Deux',
    3: 'Trois',
    4: 'Quatre',
    5: 'Cinq',
    8: 'Gauche',
    9: 'Le Deux',
    10: 'Droit',
    create: 'Créer',
    save: 'Sauver',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Éditer',
    reset: 'Réinitialiser',
    go: 'Aller à',
    formErrors: {
      required: 'Champ Obligatoire',
      passwordMatch: 'Le mot de passe ne correspond pas',
      minLength: 'N\'atteint pas le nombre minimum de caractères',
      maxLength: 'Longueur maximale',
      emailValid: 'Doit être une adresse électronique valide',
      youthAge: 'L\'âge doit être compris entre 10 et 23 ans',
      seasonYear: 'L\'année doit être comprise entre 2016 et 2050',
      integer: 'Les nombres décimaux ne sont pas autorisés'
    },
    confirmationTitle: '¿Êtes-vous sûr?',
    confirmationMessage: 'Confirmez si vous souhaitez effectuer l\'action',
    yes: 'Oui',
    no: 'Non',
    search: 'Rechercher',
    clearFilters: 'Rétablir les filtres',
    minimum: 'Minimum',
    maximum: 'Máximum',
    minimumPercent: 'Pourcentage (%) minimal',
    period: '`Période',
    exclude: 'Exclure',
    team: 'Équipe',
    clear: 'Effacer',
    all: 'Tous',
    ground1: 'Toutes',
    ground2: 'Domicile',
    ground3: 'Extérieur',
    filter: 'Filtrez',
    noData: 'Aucun résultat trouvé',
    noDataGivenFilters: 'No results found with given filters',
    similarityMinutesWarning: 'Pas de données en raison de moins de 450 minutes jouées',
    templateOnlyEditable: 'Modèle uniquement modifiable par ',
    close: 'Fermer',
    load: 'Charger',
    filters: 'Filtres',
    players: 'Joueurs',
    teams: 'teams',
    compare: 'Comparer',
    seeMore: 'Voir plus',
    seeLess: 'Cacher',
    request: 'Demander',
    notes: 'Notes',
    closeSession: 'Déconnexion',
    settings: 'Configuration',
    player: 'Joueur',
    state: 'Statut',
    updated: 'Actualisé',
    file: 'Dossier',
    uploadFile: 'Télécharger le dossier',
    reports: 'Rapport',
    download: 'Télécharger',
    new: 'Nouveau',
    comparison: 'Comparaison',
    scout: 'Recherche',
    favorites: 'Favoris',
    moreOptions: 'Plus d\'options',
    lessOptions: 'Moins d\'options',
    today: 'Aujourd\'hui',
    home: 'Domicile',
    away: 'À l\'extérieur',
    until: 'Jusqu\'a',
    firstHalf: '1º mi-temps',
    secondHalf: '2º mi-temps',
    firstPeriodOT: 'Prolongation 1º mi-temps',
    secondPeriodOT: 'Prolongation 2º mi-temps',
    postponed: 'Reporté',
    stats: 'Statistiques',
    yesterday: 'Hier',
    last: 'Dernier',
    startDate: 'Date de début',
    active: 'Actif',
    playerLimit: 'Limite des Joueurs',
    type: 'Type',
    successMessage: 'Opération réussie',
    failMessage: 'L\'opération a été un échec',
    by: 'Par',
    checkYourInbox: 'Consultez votre e-mail',
    faq: 'Documentation',
    globalSearch: 'Recherche globale',
    gamesLost: 'Matchs manqués',
    outOf: 'de',
    avgSeason: 'Moyenne de la saison',
    leftDays: 'Jours restants',
    notifyError: 'Rapport d\'erreur',
    notify: 'Notifier',
    comments: 'Commentaires',
    searches: 'Recherches',
    now: 'Maintenant',
    twoHoursAgo: 'Il y a deux heures',
    incomings: 'Achats',
    departures: 'Ventes',
    transferLoans: 'Joueurs Prêtés',
    transfers: 'Trasferts',
    movements: 'Mouvements',
    incomes: 'Revenus',
    expenditures: 'Dépenses',
    action: 'Action',
    target: 'Cible',
    uses: 'Utilisation',
    users: 'Utilisateurs',
    since: 'since',
    mediaMode: 'Media Mode',
    white: 'blanc',
    enabled: 'Activé',
    disabled: 'Désactivé',
    left: 'Gauche',
    right: 'Droit',
    both: 'Le Deux',
    'left-both': 'Gauche Le Deux',
    'right-both': 'Droit Le Deux',
    'left foot': 'Gauche',
    'right foot': 'Droit',
    files: 'Fichiers',
    confirm: 'Confirmer',
    currentStep: 'Étape actuelle',
    phases: 'Phases',
    entries: 'Entrées',
    none: 'Aucun',
    times: 'Temps',
    darkMode: 'Mode Sombre',
    client: 'Client',
    visits: 'Visits',
    lastVisit: 'Last Visit',
    strong: 'Strong',
    medium: 'Medium',
    weak: 'Weak',
    goal: 'Goal',
    list: 'List',
    map: 'Map',
    copiedToClipboard: 'Copied to clipboard',
    division: 'Division',
    many: 'Beaucoup de',
    few: 'Peu de',
    median: 'Median',
    topRight: 'Top Right',
    topLeft: 'Top Left',
    bottomRight: 'Bottom Right',
    bottomLeft: 'Bottom Left',
    library: 'Library',
    mediaLibrary: 'Médiathèque',
    for: 'For',
    stat: 'Stat',
    position: 'Position',
    order: 'Order',
    add: 'Add',
    visualization: 'Visualization',
    basic: 'Basic',
    selectAll: 'Sélectionner tout',
    unselectAll: 'Désélectionner tout',
    distribution: 'Distribution',
    end: 'End',
    accuracy: 'accuracy',
    opponent: 'Rival',
    ownTeam: 'Équipe Propre',
    center: 'Center',
    line: 'Line',
    live: 'Live',
    unavailable: 'unavailable',
    calendar: 'Calendar',
    activeLeague: 'League in Progress',
    similarity: 'Similarity',
    emptyForSelectAll: 'Empty select all',
    size: 'Size',
    selectPlayersRestriction: 'Choisissez entre 1 et {x} joueurs',
    group: 'Group',
    alerts: 'Alerts',
    shortcuts: 'Shortcuts',
    share: 'Share',
    dataAvailable: 'Les données seront bientôt disponibles',
    someStatsAvailableSoon: 'Certaines statistiques seront bientôt disponibles',
    monthGamesWarning: 'Les jeux du mois sélectionné seront bientôt disponibles',
    metrics: 'Métriques',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: 'Jamais',
    unlimited: 'Illimité',
    user: 'Utilisateur',
    warning: 'Avertissement',
    requests: 'Demandes',
    contactSales: 'Contacter les ventes',
    comingSoon: 'Bientôt disponible!',
    firstPost: '1er message',
    secondPost: '2ème message',
    dZone: 'Zone D',
    penaltySpot: 'Point de pénalité',
    secondPlay: '2ème pièce',
    otherZone: 'Autre zone',
    baseline: 'Référence',
    youth: 'Youth',
    male: 'Male',
    direct: 'Direct',
    indirect: 'Indirect',
    processing: 'Processing',
    addNew: 'Ajouter Nouveau',
    createdBy: 'Créé par',
    downloading: 'Downloading',
    displayType: 'Type de présentation',
    alreadyExists: 'existe déjà',
    aggregation: 'Aggregation',
    unavailableLeagues: 'Vous n\'avez accès à aucune des ligues dans lesquelles le joueur a joué',
    meters: 'Meters',
    quantity: 'Quantity',
    allTime: 'All Times',
    games: 'Games',
    unit: 'Unité',
    categories: 'Catégories',
    maintenanceWarning: 'Maintenance en cours',
    maintenanceMessage: 'Nous effectuons des mises à jour. Les modifications que vous faites maintenant ne seront pas enregistrées. Merci de votre patience !',
    seeAll: 'Voir tout',
    from: 'De',
    to: 'à',
    showFilters: 'Afficher les filtres',
    hideFilters: 'Masquer les filtres',
    horizontal: 'Horizontal',
    vertical: 'Verticale',
    drop: 'Baisse',
    orientation: 'Orientation',
    goalProbability: 'Probabilité d\'objectif',
    assistProbability: 'Probabilité d\'assistance',
    attackingDirection: 'Direction d\'attaque',
    currentTeam: 'Équipe actuelle',
    expectations: 'Attentes',
    sideBySide: 'Côte à côte',
    teamValue: 'Valeur d\'équipe',
    fieldLayout: 'Disposition du champ',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Crêtes',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: 'Base de données Driblab',
    league: 'Ligue',
    top5: 'Top 5',
    topCountries: 'Pays',
    tier: 'Niveau',
    division1: 'Première division',
    division2: 'Deuxième division',
    division3: 'Troisième division',
    division4: 'Quatrième division',
    division5: 'Cinquième division',
    division6: 'Sixième division',
    summary: 'Résumé',
    offensive: 'Off',
    defensive: 'Déf',
    gk: 'GK',
    all: 'Tous',
    physical: 'Phys',
    arrigo: 'Arrigo',
    yearTooltip: 'Une seule année est autorisée',
    expectedThreat: 'Danger attendu',
    expectedThreatTooltip: 'Threat added to all possessions',
    expectedThreatOP: 'xThreat OP',
    expectedThreatOPTooltip: 'Threat added to Open Play possessions',
    expectedThreatInTeam: 'Danger attendue de l\'équipe %',
    expectedThreatInTeamTooltip: 'Pct. of Threat added by player to the team',
    ballProgression: 'Progression de la balle',
    ballProgressionTooltip: 'Progressions of +10 meters',
    deepProgression: 'Profondeur',
    deepProgressionTooltip: 'Ball Progressions to Last Fifth',
    ballRetention: '% Rétention du Ballon',
    ballRetentionTooltip: 'Pct. of Actions where Ball was Successfully Retained',
    ballRetentionOppHalf: '% Rétention du Ballon OH',
    ballRetentionOppHalfExplicit: 'Pct. of Actions where Ball was Successfully Retained in Opponent Half',
    finishing: 'Finition',
    finishingTooltip: 'Pct. of Shots Ending in a Goal',
    scoringContribution: 'Contribution aux buts',
    scoringContributionTooltip: 'Assists + Goals',
    xgPerShot: 'xG par Tir',
    xgPerGoal: 'xG par But',
    headerPerCross: 'Tir de la tête par centre',
    completedCrosses: 'Centres réussies',
    crossingPct: 'Centres %',
    crossingEfficiency: 'Efficacité des centres',
    crossingEfficiencyTooltip: 'Crossing Efficiency (Measures Quality and Quantity)',
    longBalls: 'Passes Longues',
    longPassing: 'Passes Longues %',
    dribblingPct: 'Dribles %',
    throughBalls: 'Passes en profondeur',
    oppBoxTouches: 'Touches dans la surface de réparation adverse',
    oppBoxTouchesTooltip: 'Touches in Opponent Box',
    openPlayKeyPasses: 'Passes clé en jeu',
    openPlayKeyPassesTooltip: 'Open Play Passes ending in Shot',
    xGBuildup: 'Construction xG',
    xGBuildupTooltip: 'xG des séquences se terminant par un tir dans lesquelles le joueur a été impliqué (à l\'exclusion des xG des tirs et des passes clés)',
    Assists: 'Passes décisives',
    passPercentage: '% de Passe',
    passPerLongBall: 'Pass per LB',
    passPerLongBallExplicit: 'Pass per Long Ball',
    nonPenaltyGoals: 'Buts sans penalty',
    xG: 'xG',
    xGExplicit: 'Buts Attendus',
    shots: 'Tirs',
    xGShot: 'xG par Tir',
    xGChain: 'Participation xG',
    xGChainTooltip: 'xG des séquences se terminant par un tir dans lesquelles le joueur a été impliqué',
    chancesCreated: 'Opportunités Créées',
    chances: 'Opportunités',
    dribbles: 'Dribles',
    dribblesSuccessfull: 'Dribles Accomplis',
    touches: 'Touches dans la surface de réparation adverse',
    xA: 'xA',
    xAExplicit: 'Passes décisives attendus',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Expected Assists Open Play',
    passesOpponentBox: 'Passes dans la surface de réparation adverse',
    passesOB: 'Passes dans la SA',
    passesFinalThirdTooltip: 'Passes Dernier Tiers',
    passesSuccessful: 'Passes Réussies',
    passesSuccessfulTooltip: 'Passes Réussies',
    ballProgressionPassing: 'PB les Passes',
    ballProgressionPassingTooltip: 'Progression de la balle à travers les passes',
    ballProgressionDribbling: 'PB en Dribblant',
    ballProgressionDribblingTooltip: 'Progression de la balle en dribblant',
    passesTotal: 'Passes',
    passesTotalTooltip: 'Total des passes',
    shortPassesSuccessful: 'PC Réussies',
    shortPassesSuccessfulTooltip: 'Passes courtes réussies',
    shortPassesTotal: 'Passes Courtes',
    shortPassesTotalTooltip: 'Total passes courtes',
    tackles: 'Tacles *',
    adjustedTackles: 'Tacles ajustées',
    interceptions: 'Interceptions *',
    adjustedInterceptions: 'Interceptions ajustées',
    aerials: 'Aériens',
    aerialsPercent: '% aériens',
    aerialEfficiency: 'Efficacité Aérienne',
    aerialEfficiencyTooltip: 'Efficacité Aérienne (Mide Calidad y Cantidad)',
    twd: 'Duels défensifs 1 contre 1 gagnés',
    tacklesWasDribbled: 'Duels défensifs 1 contre 1 gagnés',
    fouls: 'Fautes',
    indPressure: 'Pression individuelle',
    pressure: 'Pression',
    dispossessed: 'Dépossédé',
    recoveries: 'Récupérations',
    primary: 'Primaire',
    secondary: 'Secondaire',
    position: 'Poste',
    nationality: 'Nationalité',
    height: 'Hauteur (cm)',
    minHeight: 'Hauteur min.',
    maxHeight: 'Hauteur max.',
    age: 'Âge',
    minAge: 'Âge min.',
    maxAge: 'Âge max.',
    games: 'Matchs',
    minGames: 'Matchs min.',
    maxGames: 'Matchs max.',
    minutes: 'Minutes',
    minMinutes: 'Minutes min.',
    maxMinutes: 'Minutes max.',
    minPercentMinutes: 'Pourcentage de minutes min.',
    dates: 'Dates',
    marketValue: 'Valeur (€)',
    teams: 'Équipes',
    contractEnd: 'Expiration du contrat',
    minValue: 'Valeur min.',
    maxValue: 'Valeur max.',
    excludeTeams: 'Exclure des équipes',
    recentSearches: 'Recherches récentes',
    saveSearch: 'Sauvegarder la recherche',
    loadSearch: 'Chargement de la recherche',
    loadCollection: 'Charger la collection',
    collection: 'Collection',
    search: 'Recherche',
    searchesList: 'Liste des recherches',
    mySearches: 'Mes recherches',
    mySearchesDescription: 'Ceux que vous avez déjà sauvés',
    recentSearchesDescription: 'Les 10 dernières recherches que vous avez effectuées',
    searchToLoad: 'Recherche à chargergar',
    recentSearch: 'Recherche récente',
    saveSearchSuccess: 'Recherche sauvegardée avec succès',
    removeSearch: 'Supprimer la recherche',
    removeSearchMessage: 'Êtes-vous sûr de vouloir supprimer la recherche?',
    updateSearch: 'Mettre à jour la recherche',
    updateSearchMessage: 'Êtes-vous sûr de vouloir mettre à jour la recherche ?',
    deleteSearchSuccess: 'Recherche supprimée avec succès',
    playersFound: 'trouvés',
    addToCollection: 'Ajouter à la collection',
    npg: 'BNP',
    goals: 'Buts',
    value: 'Valeur',
    nationalTeams: 'Équipes Nationales',
    gbeScore: 'GBE',
    dlIndex: 'Score',
    minGbe: 'Min. GBE',
    goalsConceded: 'Buts Concédés',
    npgConceded: 'BSP Concédés',
    npgConcededTooltip: 'Buts Sans Penalty Concedés',
    xGOTConceded: 'xG Cadrés Concedés',
    xGOTConcededTooltip: 'xG de Tirs Cadrés Reçus',
    goalsPrevented: 'Buts Évités',
    xGFacedPerShotOnTarget: 'xGOT per Shot',
    xGFacedPerShotOnTargetTooltip: 'xG on Target per Shot conceded',
    xGSavedPerxGFacedOnTarget: 'xG Arrêtes',
    xGSavedPerxGFacedOnTargetTooltip: 'Pourcentage d\'arrêts tenant compte de xG',
    savesPct: '% Arrêts',
    savesOutOfBoxPct: '% Arrêts',
    savesInBoxPct: '% Arrêts surface de réparation',
    xGFacedPerGoal: 'xG xG Reçu par but',
    xGFacedPerGoalTooltip: 'xG xG requis pour marquer un but',
    catchingPct: '% D\'attrapage',
    catchingTooltip: 'Pourcentage d\'arrêts rattrapés',
    passingOwnHalfPct: '% Passes sur terrain propre',
    passingOwnHalfPctTooltip: 'Pourcentage des passes sur terrain propre',
    passingOppHalfPct: '% Passes au terrain rival',
    passingOppHalfPctTooltip: 'Pourcentage des passes au terrain rival',
    passingContribution: '% Passing Cont.',
    passingContributionTooltip: 'Percentage of Passing Contribution',
    shotsPerGoal: 'Tirs par but',
    passesFinalThird: 'Passes Dernier ⅓',
    passingFinalThird: '% des passes dernier tiers',
    claimAccuracy: 'Précision des attrapages',
    claimAccuracyTooltip: 'Balles attrapées au-dessus de la moyenne',
    highTurnovers: 'Pertes haute',
    highTurnoversTooltip: 'Pertes à moins de 40 mètres du but',
    shotEndingHighTurnovers: 'Tir se terminant par une PH',
    shotEndingHighTurnoversTooltip: 'Tir se terminant par une perte haute.',
    goalEndingHighTurnovers: 'But se terminant par une PH',
    goalEndingHighTurnoversTooltip: 'But se terminant par une perte haute',
    avgCarriesProgress: 'Progrès moyen',
    avgCarriesProgressTooltip: 'Distance moyenne sur laquelle un joueur déplace le ballon verticalement par portée (mètres)',
    carriesChance: 'Opportunité se terminant',
    carriesChanceTooltip: 'Portés suivis d\'une passe clé',
    carriesAssist: 'Passe décisive se terminant',
    carriesAssistTooltip: 'Portés suivis d\'un passe décisive',
    carriesShot: 'Tir se terminant',
    carriesShotTooltip: 'Portés suivis d\'un tir',
    carriesGoal: 'But se terminant',
    carriesGoalTooltip: 'Portés suivis d\'un but',
    shotEndingSequence: 'Tir se terminant',
    shotEndingSequenceTooltip: 'Séquences se terminant par un tir où le joueur a été impliqué',
    goalEndingSequence: 'Tir se terminant',
    goalEndingSequenceTooltip: 'Séquences se terminant par un but où le joueur a été impliqué',
    gbeScoreTooltip: 'FA Football\'s Governing Body Endorsement',
    goalsPreventedTooltip: 'Buts non-penalty arrêtés par le gardien (xG affrontés - BNP concédés)',
    freePlayers: 'Joueurs Libres',
    index: 'Indice',
    playerName: 'Nom',
    teamName: 'Équipe',
    secondPos: 'Deuxième pos.',
    side: 'Côté',
    onlyOnLoan: 'Seulement en prêt',
    dob: 'Naissance',
    countryName: 'Pays',
    secondCountryName: 'Deuxième Pays',
    seasonYear: 'Saison',
    assists: 'Passe décisive',
    placeholder: 'Vous pouvez commencer à ajouter des filtres',
    placeholder2: 'Cliquez sur le bouton de recherche pour afficher les résultats',
    passesPct: 'Passes %',
    passingPct: 'Passes %',
    oppBoxPasses: 'Passes in Opp. Box',
    adjustedClearances: 'Dégagements Ajustés',
    aerialsPct: 'Aériens %',
    leagueCountryCode: 'Code Pays de la ligue',
    shooting: 'Tirs Cadrés %',
    xtPassing: 'xT du passing',
    xtPassingTooltip: 'Threat added by passing',
    xtDribbling: 'xT Dribble',
    xtDribblingTooltip: 'Threat added by carrying',
    foot: 'Strong Foot',
    aggressiveActions: 'Aggressive Actions',
    aggressiveActionsTooltip: 'Number of tackles attempted in the next two seconds after losing the possession',
    tacklesAttempted: 'Tackles Attempted',
    highDefensiveActionPct: '% HD Actions',
    highDefensiveActionPctTooltip: 'Percentage of Defensive Actions made 40 meters close to the opponent goal',
    individualPressureOppHalf: 'Pressure Opp. Half',
    individualPressureOppHalfTooltip: 'Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half',
    xGBuildUp5Pass: 'xG Buildup 5P',
    xGBuildUp5PassTooltip: 'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
    chancesCreatedOpenPlay: 'Chances Created OP',
    chancesCreatedOpenPlayTooltip: 'Number of passes leading to a shot during open play',
    fmf: {
      Defender: 'Défenseur',
      aerial: 'Aérien',
      goodDefender: 'Bon Défenseur',
      goodPresence: 'Bonne présence',
      playmaking: 'Création du jeu',
      Fullback: 'Arriére',
      defensiveness: 'Défensivité',
      offensiveness: 'Offensivité',
      fast: 'Rapide',
      Forward: 'Avant-centre',
      goalChances: 'Chances de but',
      goodDecissions: 'Bonnes écisions',
      individualTechnique: 'Technique Individuelle',
      Goalkeeper: 'Gardien de but',
      footWork: 'Jeu de Pieds',
      leadership: 'Leadership',
      Midfielder: 'Milieu Défensif',
      balance: 'Balance',
      ballRetention: '% Rétention du Ballon',
      offensivePasses: 'Passes Offensives',
      recoveries: 'Récupéerations',
      shotToGoal: 'Tir au But',
      'Attacking-Midfielder': 'Milieu Offensif',
      defensiveGame: 'Jeu Défensif',
      offensiveGame: 'Jeu Offensif',
      Winger: 'Aillier',
      crossing: 'Croisement',
      deepProgressions: 'Progressions Profondes',
      defendingEffort: 'Effort Défensif',
      facing: 'Face à'
    },
    yellowCards: 'Cartons Jaunes',
    redCards: 'Cartons Rouges',
    alert: 'Alert',
    yearOfBirth: 'Année de naissance',
    minYearOfBirth: 'Année de naissance min.',
    maxYearOfBirth: 'Année de naissance max.',
    women: 'Féminine',
    continental: 'Continental',
    countryCup: 'Coupe Nationale',
    statsName: 'Nom',
    abbreviation: 'Abréviation',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Afficher uniquement la dernière saison régulière jouée',
    gamesWith60PlusMinsTooltip: 'Nombre minimum de parties jouées avec plus de 60 minutes',
    starts: 'Commence',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Comparer jusqu\'à 5 joueurs',
    requestReport: 'Demander rapport',
    searchBarPlaceholder: 'Rechercher un joueur ou une équipe',
    allStats: 'Toutes les statistiques',
    placeholder: 'Vous pouvez commencer par ajouter quelques joueurs'
  },
  reports: {
    detailedInsights: 'Obtenir des informations détaillées',
    features: 'Contenu du rapport',
    performance: 'Performance',
    evolution: 'Évolution',
    compareWithMyTeam: 'Comparer avec mon équipe',
    similarPlayers: 'Joueurs similaires',
    potentialTeams: 'Équipes potentielles',
    requestSuccess: 'Demande envoyée avec succès',
    requestAt: 'Demandé',
    reportConversation: 'Report Conversation',
    writeYourMessage: 'Write your message...',
    you: 'You'
  },
  state: {
    requested: 'Demandé',
    inProgress: 'En cours',
    delivered: 'Livré'
  },
  langs: {
    es: 'Espagnol',
    en: 'Anglais',
    fr: 'Français',
    de: 'Allemand',
    it: 'Italien',
    pt: 'Portuguese',
    tr: 'Turc',
    jp: 'Japonais',
    cn: 'Chinois',
    sa: 'Arabe',
    nl: 'Néerlandais',
    pl: 'Polonais',
    sv: 'Suédois',
    cs: 'Tcheque',
    ko: 'Corean',
    hu: 'Hongrois',
    ru: 'Russe'
  },
  langsArea: {
    europe: 'Europe',
    asia: 'Asie',
    arabic: 'Arabe'
  },
  inbox: {
    subtitle: 'Restez au courant',
    new_injury_alert: 'Alerte Nouvelle Blessure',
    new_contract_alert: 'Alerte Nouveau Contrat',
    new_team_alert: 'Alerte nouvelle signature.',
    new_marketValue_alert: 'Alerte Nouvelle Valeur Marchande',
    new_game_alert: 'Alerte de nouveau jeu joué',
    receive_mail: 'Recevoir des e-mails',
    receive_mail_subtitle: 'Recevez quotidiennement des e-mails avec des joueurs qui répondent aux filtres',
    receive_notifications: 'Notifications',
    receive_notifications_subtitle: 'Recevez des notifications dans l\'application avec des joueurs qui répondent aux filtres',
    changedTo: 'Changé en',
    alerts: 'Alertes',
    includedIn: 'Inclus dans',
    noContract: 'Pas de contrat',
    newMessages: 'Nouveaux Messages',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder: 'The user will receive the reply along with the status update'
    }
  },
  gameAnalysis: {
    subtitle: 'Explorez les derniers matchs',
    subtitle2: 'Matchs dans les sept prochains jours',
    subtitle3: 'Tirez des enseignements des derniers matches et explorez les prochains',
    seeDetail: 'Voir'
  },
  statsNaming: {
    Possession: 'Possession',
    TimePossession: 'Temps de Possession',
    PassesPerShots: 'Passes Par Tir',
    PPDA: 'PPAD',
    ExpectedPoints: 'Points Attendus',
    Points: 'Points',
    Directness: 'Verticalité',
    PassesPerLongBall: 'Passes Par Longues Balles',
    CrossingPerXG: 'Centres par xG',
    PenaltySavedPenaltyFaced: 'Penalty Arrêté / Penalty Reçu',
    Goals: 'Goals',
    PenaltyShots: 'Tirs au but',
    PenaltyGoals: 'Buts sur penalty',
    NonPenaltyGoals: 'Buts sans Penalty',
    NPGOpenPlay: 'Buts sans Penalty en Jeu',
    NPGSetPiece: 'Buts sans Penalty Coup de Pied',
    Shooting: '% Tirs Cadrés',
    Finishing: 'Finition',
    xGEfficiency: 'Efficacité xG',
    HeaderPerShot: 'Tir de la Tête Par Tir',
    HeaderPerCross: 'Tir de la Tête Par Centre',
    HeadedGoals: 'Objectifs dirigés',
    GoalsConceded: 'Buts encaissés',
    SavesInBox: 'Enregistre dans la boîte',
    SavesOutBox: 'Enregistre hors de la boîte',
    Assists: 'Passes Décisives',
    ThroughBalls: 'Passe en Profondeur',
    CrossEfficiency: 'Efficacité des Centres',
    ScoringContribution: 'Contribution aux Buts',
    xAssistsOpenPlay: 'Passes Décisives en Jeu',
    xAssistsSetPiece: 'Passes Décisives sur Coup de Pied',
    xAssistsOpenPlayInTeam: 'Passes Décisives en Jeu dans l’équipe',
    xAssistsSetPieceInTeam: 'Passes Décisives sur Coup de Pied dans l’équipe',
    xGBuildupFinalThird: 'Construction xG Dernier ⅓',
    xGChainFinalThird: 'Participation xG Dernier ⅓',
    BallProgressionPassing: 'Progression de la Balle',
    BallProgressionDribbling: 'Progression de la Balle en Dribblant',
    TacklesWasDribbled: 'Duels défensifs 1 contre 1 gagnés',
    TacklesSuccessful: 'Tacles Réussies',
    Interceptions: 'Interceptions',
    Clearances: 'Dégagement',
    Fouls: 'Fautes',
    Recoveries: 'Récupérations',
    Shots: 'Tirs',
    ShotsPerGoal: 'Tirs par But',
    ShortPassesSuccessful: 'Passes Courtes Réussies',
    PassingSuccessForwardPct: '% Passes en Avant Réussies',
    PassingSuccessBackwardPct: '% Passes en Arrière Réussies',
    PassingForwardBackwardPct: '% Passes en Avant par Passe en Arrière',
    LongBallPerPassesPct: '% Longues Balles par Passe Effectuée',
    LongBallReceived: 'Longues Passes Reçu',
    LongBallReceivedOppHalf: 'Passes Longues Reçu Dans Terrain Adverse.',
    OffensiveActions: 'Actions Offensives ',
    DribblesAttempted: 'Nombre de Dribbles Tentés',
    SuccessfulDribblesPct: '% Dribbles Accompli',
    OffensiveTouchesOutBoxPct: '% Touches Offensives Dehors la Surface de Réparation',
    BallRetention: '% Rétention du Ballon',
    PassingPct: '% Passes',
    PassingOwnHalfPct: '% Passes Dans Propre Terrain',
    PassingOppHalfPct: '% Passes Dans le Terrain Adverse ',
    PassingFinalThird: 'Pases Dans le Dernier ⅓',
    PassesFinalThirdTotal: 'Total de passes finales ⅓',
    PassingFinalThirdPct: '% Passes Dans le Dernier ⅓',
    LongBallSuccessful: 'Passes Longues Réussies',
    LongBallPct: '% Passes Longues',
    LongBallTotal: 'Boules longues totales',
    SavesPct: '% Arrêts',
    SavesInBoxPct: '% Arrêts dans la Surface de Réparation',
    SavesOutOfBoxPct: '% Arrêts en Dehors la Surface de Réparation',
    xGSavedPerXGFacedOnTarget: 'xG Arrêtés / xG Reçu',
    xGFacedOnTargetPerGoalReceived: 'xG Reçu par But',
    xGFacedOnTargetEfficiency: 'Buts Évités',
    xGFacedOnTarget: 'xG Reçu',
    IndividualPressure: 'Pression Individuelle',
    AerialEfficiency: 'Efficacité Aérienne',
    AerialWins: 'Duels Aériens Gagnés',
    AerialWinsPct: '% Duels Aériens Gagnés',
    xG: 'Buts Attendus',
    xGDiff: 'Différence xG',
    xGOpenPlay: 'xG Jeu ouvert',
    xGSetPiece: 'xG Coup de Pied',
    xGPerShot: 'xG par Tir',
    ChancesCreated: 'Opportunités Créées',
    CompletedCrosses: 'Centres Réussis',
    Crossing: '% Centres Réussis',
    OpenPlayKeyPasses: 'Passes Clé en Jeu',
    OpenPlayKeyPassesInTeam: '% Passes Clé en Jeu dans l’équipe',
    OpenPlayPassesIntoOpponentBox: 'Total Passes en Jeu dans la Surface Adverse',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Passes en Jeu dans la Surface Adverse',
    xAssists: 'Passes Décisives Attendus',
    xGChain: 'Participation xG',
    xGBuildup: 'Construction xG',
    xGBuildupInTeam: 'Construction xG in Team',
    BallProgression: 'Progression de la Balle',
    SuccessfulDribbles: 'Dribbles Accomplis',
    Dispossessed: 'Dépossédé',
    TouchesInOpponentBox: 'Touches dans la Surface Adverse',
    xGSavedPerShot: 'xG Arrêtés par Tir',
    BallRetentionOppHalf: '% Retention du Ballon dans le Terrain Adverse',
    DeepProgression: 'Profondeur',
    DeepProgressionFinalThird: 'Profondeur dans le Dernier ⅓',
    FoulsTaken: 'Fautes Reçu',
    PenaltiesTaken: 'Penalties Reçu',
    BlockedCrosses: 'Centres Interceptés',
    BlockedShots: 'Tirs Bloqués',
    Blocks: 'Blocs',
    NonPenaltyGoalsAgainst: 'Buts sans Penalty Concédé',
    Headers: 'Tir de la Tête',
    AveragePassDistance: 'Distance Moyenne de Passes',
    ProgressiveRuns: 'Maniement Progressif',
    xT: 'Danger Attendu (xT)',
    xTOpenPlay: 'Danger Attendu en Jeu',
    xTSetPiece: 'Danger Attendu sur Coup de Pied',
    xGOT: 'Expected Goals On Target',
    BadActions: 'Pertes',
    BadActionsOwnHalf: 'Pertes au Terrain Adversaire',
    AerialsWonOwnBox: '% Duels Aériens Gagnés Propre Surface',
    AerialsWonOppBox: 'Aerials Won Opp Box',
    AerialsTotalOppBox: 'Aerials Total Opp Box',
    AerialsTotalOwnBox: 'Aerials Total Own Box',
    FoulsOwnHalfPct: '% Fautes Propre Terrain',
    RecoveriesOppHalf: 'Récupérations dans le Terrain Adverse',
    DuelsPct: '% Duels',
    TacklesUnsuccessful: 'Tacles Infructueux',
    TacklesWasDribbledFirstThird: 'Duels défensifs 1 contre 1 gagnés ⅓',
    TacklesWasDribbledSecondThird: 'Duels défensifs 1 contre 1 gagnés ⅔',
    TacklesWasDribbledFinalThird: 'Duels défensifs 1 contre 1 gagnés Finale ⅓',
    BallProgressionFinalThird: 'Prog. du Ballon le Dernier ⅓',
    DuelsTotal: 'Duels',
    QuickRecoveries: 'Récupérations Rapides',
    ShotsPerNPG: 'Des Buts pour des Buts sans Pénalités',
    ShotsOutBox: 'Tirs Hors de la Surface',
    GoalsOutBox: 'Buts Hors de la Surface',
    ShootingOutBox: '% Tirs au but Hors de la Surface',
    HandPassing: '% Passe à la Main',
    Catching: '% Attrapé s\'arrête',
    Caught: 'Sauvegardes capturées',
    ClaimAccuracy: 'Précision des Attrapages',
    HighTurnovers: 'Pertes Haute',
    ShotEndingHighTurnovers: 'Tir se terminant par une Perte Haute',
    GoalEndingHighTurnovers: 'Bur se terminant par une Perte Haute',
    AverageCarriesProgress: 'Progrès moyen',
    ChanceEndingCarries: 'Opportunité se terminant',
    AssistEndingCarries: 'Passe décisive se terminant',
    ShotEndingCarries: 'Portés se terminant par un tir',
    GoalEndingCarries: 'Portés se terminant par un but',
    ShotEndingSequence: 'Séquence se terminant par un tir',
    GoalEndingSequence: 'Séquence se terminant par un but',
    xGPerNPG: 'xG par Buts sans Penalties',
    AerialWonOffensive: 'Aériens Gagnés Offensif',
    AerialWonDefensive: 'Aériens Gagnés Defensif',
    xGAgainst: 'xG Reçu',
    xGDiffAgainst: 'xG Diff Reçu',
    xGPerNPGAgainst: 'xG par Buts sans Penalties Reçu',
    xGSetPieceAgainst: 'xG Coup de Pied Reçu',
    xGOpenPlayAgainst: 'xG en Jeu Reçu',
    xGPerShotAgainst: 'xG par Tir Reçu',
    ShotsAgainst: 'Tirs Reçu',
    ShotsOnTargetAgainst: 'Tirs cadrés concédés',
    ShotsOnTargetInBoxAgainst: 'Tirs cadrés dans la surface concédés',
    ShotsOnTargetOutBoxAgainst: 'Tirs cadrés hors de la surface concédés',
    RivalPossession: 'Possession Rivale',
    AerialDefensivePct: '% Duels Aériens Défensifs',
    HighRecoveries: 'Récupérations Dangereuses',
    HighDefensiveActions: 'Actions Défensives Dangereuses',
    HighDefensiveActionPct: '% Actions Défensives Dangereuses',
    HighDefensiveDistance: 'Haute Distance Défensive',
    PassesPerPossession: 'Passage par la Possession',
    LengthPerPossession: 'Distance par la Possession',
    xTNet: 'Net xT',
    AvgCarriesDistance: 'Avg. Carries Distance',
    PassesForwardPct: '% Passes Go Forward',
    PassesForwardSuccessful: 'Passes avant réussies',
    PassesForwardTotal: 'Total des passes avant',
    TacklesAttempted: 'Tackles Attempted',
    DuelsLost: 'Duels Lost',
    Carries: 'Carries',
    CarriesPct: '% Carries',
    Aerials: 'Aerials',
    ProgressivePassesReceivedIntoBox: 'Progressive Passes Receive Into Box',
    PassesOppHalf: 'Passes au Terrain Rival',
    ShotsOnTarget: 'Tirs Cadrés',
    AggressiveActions: 'Aggresive Actions',
    Crosses: 'Crosses',
    xGBuildup5pass: 'xGBuildup 5 passes',
    SpeedSequence: 'Sequence\'s Speed',
    Touches: 'Touches',
    AerialsTotalOppHalf: 'Aerials au Terrain Rival',
    AerialsWonOppHalf: 'Les sauts ont remporté l\'opp. Moitié',
    AerialsWonOppHalfPct: '% Aerials Gagnés au Terrain Rival',
    AerialsPctOppBox: '% Aerials Won Opp. Box',
    AerialsPctOwnBox: '% Aerials Won Own Box',
    AerialDefensive: 'Aerials Defensif',
    AerialOffensive: 'Aerials Offensif',
    AerialOffensivePct: '% Aerials Offensif',
    IndividualPressureOppHalf: 'Pression Individuelle au Terrain Rival',
    ChancesCreatedOP: 'Opportunités Créées en Jeu',
    TouchesPerShot: 'Touches par Tir',
    PassesFinalThirdTotalPct: '% Passes dans le Dernier Tiers',
    xACrosses: 'Passes Décisives de Centres',
    Passes: 'Passes',
    PassesSuccessful: 'Passes Réussies',
    TacklesWasDribbledFouls: '% Duels au Sol',
    OffsidesCaught: 'Offsides Caught',
    ProgressivePassesReceivedFinalThird: 'Passes Progressives Reçus dans le Dernier ⅓',
    ProgressivePassesReceived: 'Passes Progressives Reçus',
    Breadth: 'Ampleur',
    DuelsDefTotal: 'Duels Défensifs',
    DefensiveActions: 'Actions Défensives',
    ProgressivePassesReceivedOppHalf: 'Passes Progressives Reçues Dans le Terrain Adverse',
    CompletedCrossesOP: 'Centres Réussis en Jeu',
    CrossingOP: '% Centres en Jeu',
    CrossesOP: 'Total des croisements jeu ouvert',
    PassingContribution: '% Contribution de passes',
    BallProgressionOppHalfInTeam: '% Progression de la Balle Terrain Adverse dans l’équipe',
    PassesOPIntoBoxInTeam: '% de Passes en Jeu dans la surface adverse dans l’équipe',
    TouchesOppBoxInTeam: '% Touches dans la surface adverse dans l’équipe',
    xGOPInTeam: '% xG en Jeu dans l’équipe',
    DeepPasses: 'Passes en profondeur',
    DeepPassesTotal: 'Passes profondes',
    DefensiveDuelsPct: '% Duels Défensifs',
    DefensiveDistance: 'Distance Défensive',
    QuickRecoveriesPct: '% Récupérations Rapides',
    DiffDefensiveDistanceTeam: 'Diff. Defensive Distance Team',
    xTPassing: 'xT de Passe',
    xTPassing100Passes: 'xT de Passe 100 Passes',
    ProgressivePassesAccurate: 'Passes Progressives',
    PassAbility: 'Capacité de Passe',
    OPPassesIntoOppBoxPct: '% Passes en Jeu Dans La Surface Adverse',
    EntriesOppBox: 'Arrivées dans la Surface Adverse',
    Crosses6yardBox: 'Centres dans la Surface de But',
    Cutbacks: 'Cutbacks',
    xTDribbling: 'xT Dribble',
    AvgShotDistance: 'Distance Moyenne de Tir',
    xGOnTarget: 'xG Cadré',
    FinishingxGOT: 'Finition xGOT',
    DribblesWonOwnHalf: 'Dribbles Gagnés Moitié Propre',
    DribblesOwnHalf: 'Dribbles Moitié Propre',
    DribblesOwnHalfPct: '% Dribbles Moitié Propre',
    DribblesWonOppHalf: 'Dribbles Gagnés Moitié Adverse',
    DribblesOppHalf: 'Dribbles Moitié Adverse',
    DribblesOppHalfPct: '% Dribbles Moitié Adverse',
    DribblesWonFinalThird: 'Dribbles Gagnés Dernier Tiers',
    DribblesFinalThird: 'Dribbles Dernier Tiers',
    DribblesFinalThirdPct: '% Dribbles Dernier Tiers',
    ShotEndingHighRecoveries: 'Récupérations Hautes Conclues par un Tir',
    PassingFinalThirdAgainst: 'Passes Concédées dans le dernier Tiers',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Passes Concédées en jeu Ouvert dans la Surface',
    EntriesOppBoxAgainst: 'Entrées Concédées dans la Surface Adverse',
    DeepProgressionAgainst: 'Progressions Profondes Concédées',
    TouchesInOpponentBoxAgainst: 'Touches Concédées dans la Surface Adverse',
    Score: 'Score',
    PDScore: 'Score Physique',
    OrlegiScore: 'Score Orlegi',
    SirScore: 'Sirius Score',
    ExcScore: 'Excelsior Score',
    xTOPInTeam: 'xT en Jeu dans l’équipe',
    YellowCards: 'Cartons Jaunes',
    RedCards: 'Cartons Rouges',
    xTOpenPlayAgainst: 'Danger Attendu en Jeu Reçu',
    xTSetPieceAgainst: 'Danger Attendu Coup de Pied Reçu',
    NPGOpenPlayAgainst: 'BSP en Jeu Reçu',
    NPGSetPieceAgainst: 'BSP Coup de Pied Reçu',
    PassesOppHalfPerPossession: 'Passes au Terrain Rival par la Possession',
    AverageTimeRecovery: 'Temps Moyen de Récupération',
    ExpectedPassing: '% de Réussite Attendue',
    NumPossession10Passes: 'Possessions 10 Passes',
    PassesReceived: 'Passes Reçues',
    PassesReceivedFinalThird: 'Passes Reçues en Finale ⅓',
    ProgressivePassesTotalPct: '% de Passes Progressives',
    ShortPassesPct: '% de Passes Courtes',
    TouchesOppBoxOppTeam: 'Touches dans la Surface Propre Concédées Lorsqu’il Joue',
    ShotsOnTargetOppTeam: 'Tirs Cadrés Concédés Lorsqu’il Joue',
    NPGOppTeam: 'xG Sans Penalty de l’Adversaire Lorsqu’il Joue',
    ShotsOpenPlay: 'Tirs en jeu ouvert',
    xGSetPiecePerxG: 'xG sur coup de pied arrêté par xG',
    ShotsOpenPlayAgainst: 'Tirs concédés en jeu ouvert',
    ShotsFromDribble: 'Tirs après dribble',
    GoalsFromDribble: 'Buts après dribble',
    PassesIntoFinalThird: 'Passes vers le dernier tiers',
    PassesIntoFinalThirdTotal: 'Total passe dans le dernier tiers',
    PassesInsideFinalThird: 'Passes dans le dernier tiers',
    PassesInsideFinalThirdTotal: 'Total de passes en finale ⅓',
    PassesFinalThirdNoArea: 'Passe le dernier tiers (sans boîte)',
    PassesIntoOppBox: 'Passes dans la surface adverse',
    CarriesFinalThird: 'Conduites vers le dernier tiers',
    CarriesInsideFinalThird: 'Conduites dans le dernier tiers',
    CarriesFinalThirdNoBox: 'Transporte le dernier tiers (sans boîte)',
    CarriesIntoOppBox: 'Conduites dans la surface adverse',
    TimePossessionAgainst: 'Possession adverse',
    TimePossessionTotal: 'Possession totale',
    PassesInBox: 'Passes dans la surface',
    LongThrowInSuccessful: 'Toucher longue réussie',
    LongThrowInTotal: 'Total de touches longues',
    LongThrowInPct: '% de touches longues réussies',
    Games: 'Jeux joués',
    PointsPerGame: 'Points par jeu',
    ExpectedPointsDiff: 'Différence de points attendue',
    PassesTotalOwnHalf: 'Total Passe Propre Moitié',
    PassesOwnHalf: 'Passe sa propre moitié',
    PassesTotalOppHalf: 'Réussit la moitié totale de l\'opp',
    ProgressivePassesTotal: 'Passes progressives totales',
    DuelsWon: 'Duels gagnés',
    NonPenaltySaves: 'Arrêts sans pénalité',
    BadActionsOppHalf: 'Mauvaises actions Opp moitié',
    CarriesSuccessful: 'Porte avec succès',
    ShotsOnTargetOutBox: 'Tirs cadrés hors de la boîte',
    TotalDistance: 'Distance Totale',
    DistanceIP: 'Distance TIP',
    DistanceOOP: 'Distance OTIP',
    SprintsNumber: 'Quantité de sprints',
    SprintsDistance: 'Sprints Distance',
    WalkingDistance: 'Distance à pied',
    JoggingDistance: 'Distance en jogging',
    RunningDistance: 'Distance en course',
    ExtremeAccelerations: 'Accélérations extrêmes',
    NumberOfRuns: 'Nombre de courses',
    HsrNumber: 'Quantité de HSR',
    HsrDistance: 'Distance du HSR',
    SprintNumberDeclinePct: '% Baisse de la Quantité de Sprint',
    SprintDistanceDeclinePct: '% Baisse de la Quantité de Sprint',
    SprintNumberDecline: 'Baisse de la Quantité de Sprint',
    SprintDistanceDecline: 'Baisse de la Quantité de Sprint',
    HsrDistancePct: '% HSR Distance',
    SprintDistancePct: '% Distance Sprint',
    Accelerations: 'Accélérations Quantité',
    ExplosiveDistance: 'Distance Explosive',
    MaxSpeed: 'Vitesse Max.',
    AvgMaxSpeed: 'Moyenne Vitesse Max.',
    MaxAccelerations: 'Max. Accélérations',
    BypassedPlayersByPasses: 'Joueurs Contournés',
    BypassedDefendersByPasses: 'Défenseurs Contournés',
    PassesBypassingPlayers: 'Passes Contournant des Joueurs',
    PassesBypassingDefenders: 'Passes Contournant des Défenseurs',
    BypassedPlayersPerPass: 'Joueurs Contournés par Passe',
    BypassedDefendersPerPass: 'Défenseurs Contournés par Passe',
    LineBreakingPasses: 'Passes Cassant les Lignes',
    LineBreakingPassesMD: 'Passes Cassant les Lignes MD',
    LineBreakingPassesM: 'Passes Cassant les Lignes M',
    LineBreakingThroughBalls: 'Passes en Profondeur Cassant les Lignes',
    LineBreakingPassesPerPass: '% Passes Casse-lignes par Passe',
    TotalPassesUnderStrongPressure: 'Total des Passes sous Forte Pression',
    TotalPassesUnderLightPressure: 'Total des Passes sous Pression',
    SuccessfulPassesUnderStrongPressure: 'Passes sous Forte Pression Accompli',
    SuccessfulPassesUnderLightPressure: 'Passes sous Pression Accompli',
    PassingUnderStrongPressure: '% Passes sous Forte Pression',
    PassingUnderLightPressure: '% Passes sous Pression',
    PassReceiptsInSpaceCompleted: 'Réceptions de Passes dans l\'espace Réussies',
    PassReceiptsInSpace: 'Passes Reçues dans l’Espace',
    PassReceiptsInSpaceCompletedFirstThird: 'Réceptions en espace complétées 1er tiers',
    PassReceiptsInSpaceCompletedSecondThird: 'Réceptions en espace complétées 2e tiers',
    PassReceiptsInSpaceCompletedFinalThird: 'Réceptions en espace complétées dernier tiers',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Réceptions en espace complétées côté droit adverse',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Réceptions en espace complétées axe adverse',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Réceptions en espace complétées côté gauche adverse',
    PassReceiptsInSpaceFirstThird: 'Réceptions en espace 1er tiers',
    PassReceiptsInSpaceSecondThird: 'Réceptions en espace 2e tiers',
    PassReceiptsInSpaceFinalThird: 'Réceptions en espace dernier tiers',
    PassReceiptsInSpaceOppHalfRight: 'Réceptions en espace côté droit adverse',
    PassReceiptsInSpaceOppHalfCenter: 'Réceptions en espace axe adverse',
    PassReceiptsInSpaceOppHalfLeft: 'Réceptions en espace côté gauche adverse',
    TotalStrongOnBallPressures: 'Total de Pressions Fortes sur le Ballon',
    TotalLightOnBallPressures: 'Total de Pressions sur le Ballon',
    SuccessfulStrongOnBallPressures: 'Pressions Fortes sur le Ballon Accompli',
    SuccessfulLightOnBallPressures: 'Pressions sur le Ballon Accompli',
    StrongOnBallPressuresPct: '% de Pressions Fortes sur le Ballon',
    LightOnBallPressuresPct: '% de Pressions sur le Ballon',
    TimesBypassedByPasses: 'Dépassé par des Passes',
    TimesBypassedByCarries: 'Dépassé par des Conduites',
    TimesBypassedByActions: 'Dépassé par des Actions',
    BypassedPlayersByCarries: 'Joueurs Dépassés par des Conduites',
    BypassedDefendersByCarries: 'Défenseurs Dépassés par des Conduites',
    BypassedPlayersByActions: 'Joueurs Dépassés par des Actions',
    BypassedDefendersByActions: 'Défenseurs Dépassés par des Actions',
    CarriesBypassingPlayers: 'Conduites qui Dépassent des Joueurs',
    CarriesBypassingDefenders: 'Conduites qui Dépassent des Défenseurs',
    BypassedPlayersPerCarry: 'Joueurs Dépassés par Conduite',
    BypassedDefendersPerCarry: 'Défenseurs Dépassés par Conduite',
    LineBreakingCarries: 'Conduites entre les Lignes',
    LineBreakingCarriesMD: 'Conduites entre les Lignes Défenseurs et Milieux',
    LineBreakingCarriesM: 'Conduites entre la Ligne des Milieux',
    LineBreakingCarriesD: 'Conduites entre la Ligne des Défenseurs',
    LineBreakingCarriesPerCarry: 'Conduites entre les Lignes par Conduite',
    LineBreakingActions: 'Actions entre les Lignes',
    LineBreakingActionsMD: 'Actions entre la Ligne Défenseurs et Milieux',
    LineBreakingActionsM: 'Actions entre la Ligne des Milieux',
    LineBreakingActionsD: 'Actions entre la Ligne des Défenseurs',
    PassesPerLineBreakingPass: 'Passes par Passe entre les Lignes',
    CarriesPerLineBreakingCarry: 'Conduites par Conduite entre les Lignes',
    LinesBrokenByPasses: 'Lignes Cassées par des Passes',
    LinesBrokenByCarries: 'Lignes Cassées par des Conduites',
    LinesBrokenByActions: 'Lignes Cassées par des Actions',
    LinesBrokenPerPass: 'Lignes Cassées par Passe',
    LinesBrokenPerCarry: 'Lignes Cassées par Conduite',
    AvgLastDefenderDistanceIP: 'Distance Dernier Défenseur IP',
    AvgLastDefenderDistanceOOP: 'Distance Dernier Défenseur OOP',
    AvgDefensiveLineDistanceIP: 'Distance Ligne Défensive IP',
    AvgDefensiveLineDistanceOOP: 'Distance Ligne Défensive OOP',
    AvgRBDistanceIP: 'Distance Arrière Droit IP',
    AvgRBDistanceOOP: 'Distance Arrière Droit OOP',
    AvgLBDistanceIP: 'Distance Arrière Gauche IP',
    AvgLBDistanceOOP: 'Distance Arrière Gauche OOP',
    AvgBlockDistanceIP: 'Distance du Bloc IP',
    AvgBlockDistanceOOP: 'Distance du Bloc OOP',
    AvgBlockAreaIP: 'Zone du Bloc IP',
    AvgBlockAreaOOP: 'Zone du Bloc OOP',
    AvgDefensiveLineWidthOOP: 'Largeur Ligne Défensive OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Largeur Ligne Offensive Dernier Tiers IP',
    AvgLByIP: 'Position Arrière Gauche IP',
    AvgRByIP: 'Position Arrière Droit IP',
    AvgOffensiveLineDistanceIP: 'Distance Ligne Offensive IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Distance Ligne Offensive Dernier Tiers IP',
    AvgOffensiveLineWidthIP: 'Largeur Ligne Offensive IP',
    OffBallRuns: 'Total des Appels Sans Ballon',
    OffBallRunsOverlap: 'Appels en Superposition',
    OffBallRunsUnderlap: 'Appels en Sous-Position',
    OffBallRunsRunAhead: 'Appels en Avant',
    OffBallRunsRunBehind: 'Appels dans le Dos',
    OffBallRunsCrossReceiver: 'Appel pour Centre',
    OffBallRunsSupport: 'Appel de Soutien',
    OffBallRunsComingShort: 'Appel de Soutien Court',
    description: {
      Possession: 'Pourcentage de possession de l\'équipe',
      TimePossession: 'Temps de possession de l\'équipe',
      PassesPerShots: 'Nombre de passes effectuées par tir',
      PPDA: 'Passes par Actions Défensives. Mesure le nombre de passes qui ont été effectuées par l\'équipe adverse jusqu\'à ce que le jeu ait été interrompu par une action défensive. Plus le PPDA est élevé, plus la pression exercée sur l\'adversaire est faible.',
      Directness: 'Mesure le degré de verticalité d\'une équipe dans ses passes, récompensant les passes vers le but de l\'adversaire',
      ExpectedPoints: 'Nombre de points attendus d\'une équipe, calculé à partir des buts attendus générés et concédés dans chaque match. Ce calcul permet de connaître la performance d\'une équipe par rapport à un match (ou des matchs cumulés) en la comparant aux points que l\'équipe a effectivement obtenus',
      PassesPerLongBall: 'Nombre de passes effectués par longue passe',
      CrossingPerXG: 'Pourcentage des buts attendus qui proviennent des centres dans la surface de réparation',
      PenaltySavedPenaltyFaced: 'Pourcentage de penaltys sauvées par rapport aux pénalités concédées',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Nombre total de tirs sur penalty',
      PenaltyGoals: 'Nombre total de buts sur penalty',
      NonPenaltyGoals: 'Buts marqués, à l\'exclusion des penalties,',
      NPGOpenPlay: 'Number of goals scored by open play actions excluding penalty goals',
      NPGSetPiece: 'Number of goals scored by set piece actions excluding penalty goals',
      Shooting: 'Pourcentage de tirs cadrés',
      Finishing: 'Pourcentage de tirs qui se terminent par un but',
      xGEfficiency: 'Nombre de Buts Attendus nécessaires pour que le joueur marque un but.',
      HeaderPerShot: 'Nombre des tirs de la tête',
      HeaderPerCross: 'Pourcentage de centres résultant en tirs de la tête par le joueur par rapport au total des centres effectués par l\'équipe',
      Assists: 'Nombre d\'assistances',
      ThroughBalls: 'Passes en profondeur',
      CrossEfficiency: 'Nombre de centres réussis sur le nombre total de centres tentés',
      ScoringContribution: 'Nombre de Passes Décisives et de Buts',
      xAssistsOpenPlay: 'Nombre de passes décisives attendus qui proviennent des actions en jeu et non de coups de pied',
      xAssistsSetPiece: 'Nombre de passes décisives attendues qui proviennent des coups de pied',
      xAssistsOpenPlayInTeam: 'Nombre de passes décisives attendus qui proviennent des actions en jeu et non de coups de pied dans l’équipe',
      xAssistsSetPieceInTeam: 'Nombre de passes décisives attendues qui proviennent des coups de pied dans l’équipe',
      xGChainFinalThird: 'Nombre de buts attendus auxquels le joueur a participé au cours du dernier tiers du terrain',
      xGBuildupFinalThird: 'Nombre de buts attendus auxquels le joueur a participé au cours du dernier tiers du terrain (à l\'exclusion des tirs et des passes qui les précèdent)',
      BallProgressionPassing: 'Progression des balles à travers les passes',
      BallProgressionDribbling: 'Progression des balles grâce aux dribbles',
      TacklesWasDribbled: 'Métrique qui prend en compte le pourcentage de fois où le joueur récupère le ballon par tacle par rapport au nombre de fois où il a été débordé. Plus le pourcentage est élevé, mieux c\'est',
      TacklesSuccessful: 'Nombre de tacles réussis effectués par le joueur',
      Interceptions: 'Nombre de fois où le joueur intercepte une passe',
      Clearances: 'Nombre de fois qu\'un joueur dégage une passe',
      Fouls: 'Nombre de fautes effectuées par le joueur',
      Recoveries: 'Nombre de balles récupérées par le joueur',
      Shots: 'Nombre total de tirs',
      ShotsPerGoal: 'Nombre de tirs nécessaires pour marquer un but ',
      ShortPassesSuccessful: 'Nombre de passes courtes (moins de 12 mètres) effectuées',
      PassingSuccessForwardPct: 'Pourcentage de passes en avant réussies',
      PassingSuccessBackwardPct: 'Pourcentage de passes en arrière réussies',
      PassingForwardBackwardPct: 'Ratio entre les passes en avant et les passes en arrière',
      LongBallPerPassesPct: 'Pourcentage de balles longues par rapport au nombre total de passes',
      LongBallReceived: 'Balles longues reçues',
      LongBallReceivedOppHalf: 'Nombre de balles longues reçues dans le terrain adverse',
      OffensiveActions: 'Actions offensives',
      DribblesAttempted: 'Nombre de dribbles tentés',
      SuccessfulDribblesPct: 'Dribbles réussis / nombre total de tentatives de dribbles effectuées',
      OffensiveTouchesOutBoxPct: '% de touches offensives hors boîte',
      BallRetention: 'Pourcentage de temps où vous êtes en possession du ballon et où vous ne le perdez pas',
      PassingPct: 'Pourcentage de passes réussies par rapport au total des passes effectuées par le joueur',
      PassingOwnHalfPct: 'Pourcentage de succès avec les passes qui finissent dans le propre terrain',
      PassingOppHalfPct: 'Pourcentage de passes réussies qui se retrouvent dans le terrain adverse',
      PassingFinalThird: 'Passes réussies, hors centres, coups de pied arrêtés, corners et touches, qui commencent dans le dernier tiers',
      PassesFinalThirdTotal: 'Total de passes tentées, hors centres, coups de pied arrêtés, corners et remises en jeu, qui se terminent dans le dernier tiers',
      PassingFinalThirdPct: 'Pourcentage de passes réussies parmi toutes les passes du joueur (uniquement celles qui commencent dans le dernier tiers)',
      LongBallSuccessful: 'Nombre de passes effectuées sur plus de 32 mètres',
      LongBallPct: 'Pourcentage de longs passes réussies (plus de 32 mètres)',
      LongBallTotal: 'Nombre total de passages sur 32 mètres',
      SavesPct: 'Pourcentage des arrêts par rapport au nombre total de tirs concédés',
      SavesInBoxPct: 'Pourcentage des arrêts sur les tirs effectués dans la surface de réparation',
      SavesOutOfBoxPct: 'Pourcentage des arrêts sur les tirs effectués en dehors la surface de réparation',
      xGSavedPerXGFacedOnTarget: 'Coefficient qui indique le pourcentage du xG attendu arrêté par le gardien. Plus on se rapproche de 1, plus il est difficile de marquer',
      xGFacedOnTargetPerGoalReceived: 'Une mesure qui indique combien de buts attendus sont nécessaires pour marquer un but contre le gardien. Un score élevé dans cette métrique signifie que pour convertir un but en ce gardien, il faut avoir un xG élevé.',
      xGFacedOnTargetEfficiency: 'Nombre de buts non penalty évités par le gardien. Il s\'agit du nombre de buts attendus cadrés reçus par le gardien moins le nombre de buts (non -penalty) concédés. Cela indique le nombre de buts qui n\'ont pas été marqués par l\'adversaire grâce au gardien de but',
      xGFacedOnTarget: 'Total des xG (sauvés et marqués) auxquels le gardien de but a été confronté',
      IndividualPressure: 'Un modèle qui quantifie objectivement la pression que le joueur exerce sur l\'adversaire. Le modèle est basé sur le nombre de fois où l\'équipe qui reçoit le ballon fait pression sur l\'adversaire dans les trois derniers cinquièmes du terrain, que le ballon soit récupéré ou non, tant que l\'adversaire est sous pression. Plus le nombre de pressions est élevé, moins l\'adversaire est autorisé à faire et donc plus la pression est forte.',
      AerialEfficiency: 'Modèle qui combine le pourcentage de succès dans les duels aériens et le volume des duels aériens gagnés.',
      AerialWins: 'Nombre de duels aériens gagnés par le joueur',
      AerialWinsPct: 'Nombre de duels aériens que le joueur gagne sur le nombre total de duels aériens effectués.',
      xG: 'Buts Attendus générés. Cette mesure mesure le pourcentage de chance qu\'un tir termine dans un but en fonction des différentes variables de ce tir.',
      xGDiff: 'Différence entre xG et Goals',
      xGOpenPlay: 'Objectifs attendus générés par Open Play',
      xGSetPiece: 'xG Coup de Pied',
      xGPerShot: 'Buts Attendus par tir. Cette métrique mesure la dangerosité moyenne du tir reçu.Plus il est élevé, plus il est probable que les tirs se terminent par un but.  Une valeur élevée implique que le joueur choisit bien ses tirs s\'ils viennent de l\'intérieur de la surface de réparation et sont cadrés',
      ChancesCreated: 'Nombre de passes résultant d\'un tir cadrés',
      CompletedCrosses: 'Nombre de centres réussis',
      Crossing: 'Pourcentage de centres réussis',
      OpenPlayKeyPasses: 'Nombre de passes effectuées en jeu qui se traduisent par un tir (sans compte les passes décisives)',
      OpenPlayKeyPassesInTeam: 'Pourcentage de passes effectuées en jeu qui se traduisent par un tir (sans compte les passes décisives) dans l’équipe',
      OpenPlayPassesIntoOpponentBox: 'Total passes dans la surface de réparation adverse en jeu',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Passes complétées dans la surface de réparation adverse en jeu',
      xAssists: 'Nous utilisons xA, pour donner une valeur à la passe décisive créée par un coéquipier. Si un joueur donne une passe qui se termine par un tir à un autre joueur à un mètre du but, le xA sera très élevé car le danger de la passe est très élevé. Nous utilisons la différence (xA généré moins xA effectué par l\'équipe adverse pour analyser combien de xG sont générés par les équipes grâce au jeu de groupe ou au niveau individuel. Passes décisive attendus (xA)',
      xGChain: 'Nombre des Buts Attendus auxquels le joueur a participé. Si le joueur a participé à un jeu qui se termine par un tir, le xG du jeu sera ajouté à cette métrique.',
      xGBuildup: 'Similaire à Participation xG, mais sans tenir compte des deux derniers joueurs de la séquence (dernier passeur et finisseur)',
      xGBuildupInTeam: 'Construction xG in Team',
      BallProgression: 'Nombre de fois que le joueur avance 10 mètres ou plus, en passant ou en conduisant le ballon, ou une combinaison des deux',
      SuccessfulDribbles: 'Nombre de dribbles réussis',
      Dispossessed: 'Nombre de pertes du ballon du joueur',
      TouchesInOpponentBox: 'Nombre d\'actions du joueur dans la surface de réparation adverse',
      xGSavedPerShot: 'Nombre de Buts Attendus sauvés par tir',
      BallRetentionOppHalf: 'Pourcentage de temps où vous êtes en possession du ballon et où vous ne le perdez pas dans la moitié de terrain de l\'adversaire',
      DeepProgression: 'Nombre de touches dans le dernier cinquième du terrain ainsi que la progression du ballon',
      DeepProgressionFinalThird: 'Nombre de touches dans le dernier tiers du terrain ainsi que la progression du ballon',
      FoulsTaken: 'Nombre de fautes reçu',
      PenaltiesTaken: 'Nombre des penaltys reçu',
      BlockedCrosses: 'Nombre de centres bloqués pour atteindre la destination',
      BlockedShots: 'Tirs qui n\'ont pas atteint le but en raison de l\'intervention de l\'équipe adverse.',
      NonPenaltyGoalsAgainst: 'Buts concédés (hors tirs au but)',
      GoalsConceded: 'Nombre de buts encaissés',
      Headers: 'Tir de la Tête',
      HeadedGoals: 'Nombre de buts marqués de la tête',
      Points: 'Nombre de points marqués par l\'équipe',
      SavesInBox: 'Nombre d\'arrêts sur tirs à l\'intérieur de la surface',
      SavesOutBox: 'Nombre d\'arrêts sur tirs hors de la surface',
      ShotsOnTargetInBoxAgainst: 'Nombre de tirs cadrés depuis l\'intérieur de la surface concédés',
      ShotsOnTargetOutBoxAgainst: 'Nombre de tirs cadrés depuis l\'extérieur de la surface concédés',
      AveragePassDistance: 'Distance Moyenne de Passes',
      ProgressiveRuns: 'Maniement Progressif',
      xT: 'Danger Attendu (xT). Une métrique qui mesure le danger qu\'un joueur crée pour l\'équipe adverse en transportant le ballon, à la fois en conduisant et en passant, vers des zones où la probabilité que la possession se termine par un but est plus élevée',
      xTOpenPlay: 'Danger Attendu qui proviennent des actions en jeu et non de coups de pied',
      xTSetPiece: 'Danger Attendu qui proviennent des actions de coups de pied et non en jeu',
      xGOT: 'Buts cadrés attendus. Nombre de buts attendus par le gardien de but. Cette mesure ne prend en compte que les tirs cadrés (les tirs manqués et les tirs sur le poteau sont exclus)',
      BadActions: 'Pertes',
      BadActionsOwnHalf: 'Pertes sur le terrain propre',
      AerialsWonOwnBox: 'Duels aériens gagnés dans sa Propre Surface',
      AerialsWonOppBox: 'Aerials Won Opp Box',
      AerialsTotalOppBox: 'Aerials Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Total Own Box',
      FoulsOwnHalfPct: '% Fautes sur le terrain propre',
      RecoveriesOppHalf: 'Nombre de balles récupérées par le joueur dans le terrain adverse',
      DuelsPct: '% Duels réussis',
      TacklesUnsuccessful: 'Nombre de fois qu\'un joueur ne parvient pas à récupérer le ballon alors qu\'un adversaire réussit à le dépasser',
      TacklesWasDribbledFirstThird: 'Duels défensifs 1 contre 1 gagnés dans le dernier tiers',
      TacklesWasDribbledSecondThird: 'Duels défensifs 1 contre 1 gagnés ⅔',
      TacklesWasDribbledFinalThird: 'Duels défensifs 1 contre 1 gagnés Finale ⅓',
      BallProgressionFinalThird: 'Progression du ballon dans le dernier tiers',
      DuelsTotal: 'Nombre total de Tacles, de Sauts, de Touches de Balle, de Dribbles et de Fautes commis',
      QuickRecoveries: 'Récupération à 40 mètres ou plus de son propre but dans les 8 secondes qui suivent un turnover.',
      ShotsPerNPG: 'Nomnbres de tirs par But sans Penaltis',
      ShotsOutBox: 'Tirs de l\'extérieur de la surface',
      GoalsOutBox: 'Buts provenant de l\'extérieur de la surface',
      ShootingOutBox: 'Pourcentage de tirs au but en dehors de la Surface de Réparation',
      HandPassing: 'Pourcentage de passes réalisées avec la main',
      Catching: 'PPourcentage d\'arrêts Capturés',
      Caught: 'Enregistre l\'endroit où le gardien de but attrape et tient le ballon, empêchant tout deuxième jeu',
      ClaimAccuracy: 'Détermine la capacité du gardien de but à attraper ou à bloquer les ballons aériens. Un chiffre supérieur à 1 indique que le gardien attrape plus de ballons aériens que prévu',
      HighTurnovers: 'Pertes de balle à moins de 40 mètres de son propre but',
      ShotEndingHighTurnovers: 'Pertes Hautes (pertes à moins de 40 mètres de son propre but) qui se terminent par un tir de l\'équipe adverse',
      GoalEndingHighTurnovers: 'Pertes Hautes (pertes à moins de 40 mètres de son propre but) qui se terminent par un but de l\'équipe adverse',
      AverageCarriesProgress: 'Distance moyenne sur laquelle un joueur déplace le ballon verticalement par portée (mètres)',
      ChanceEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par une passe suivie d\'un tir',
      AssistEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par une passe suivie d\'un but',
      ShotEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par un tir',
      GoalEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par un but',
      ShotEndingSequence: 'Séquence se terminant par un tir',
      GoalEndingSequence: 'Séquence se terminant par un but',
      xGPerNPG: 'xG par Buts sans Penalties',
      AerialWonOffensive: 'Aériens Gagnés Offensif',
      AerialWonDefensive: 'Aériens Gagnés Defensif',
      xGAgainst: 'xG Reçu',
      xGDiffAgainst: 'xG Diff Reçu',
      xGPerNPGAgainst: 'xG par Buts sans Penalties Reçu',
      xGSetPieceAgainst: 'xG Coup de Pied Reçu',
      xGOpenPlayAgainst: 'xG en Jeu Reçu',
      xGPerShotAgainst: 'xG par Tir Reçu',
      ShotsAgainst: 'Tirs Reçu',
      ShotsOnTargetAgainst: 'Nombre de tirs cadrés concédés',
      RivalPossession: 'Possession Rivale',
      AerialDefensivePct: '% Duels Aériens Défensifs',
      HighRecoveries: 'Récupérations Dangereuses',
      HighDefensiveActions: 'Actions Défensives (plaquages, interceptions, blocages, fautes et 1vs1) effectuées à 40 mètres au-dessus de la ligne de base',
      HighDefensiveActionPct: 'Pourcentage d\'actions défensives (plaquages, interceptions, blocages, fautes et 1vs1) effectuées à 40 mètres au-dessus de la ligne de base',
      HighDefensiveDistance: 'Distance moyenne du but adverse de toutes les Actions Défensives',
      PassesPerPossession: 'Passage par la Possession',
      LengthPerPossession: 'Distance par la Possession',
      xTNet: 'Danger Net Attendu',
      AvgCarriesDistance: 'Distance moyenne des Conduites du ballon',
      PassesForwardPct: 'Pourcentage de passes en avant sur le total',
      PassesForwardSuccessful: 'Passes avant réussies',
      PassesForwardTotal: 'Total des passes avant',
      TacklesAttempted: 'Tacles tentés',
      DuelsLost: 'Duels Perdus',
      Carries: 'Conduites du ballon',
      CarriesPct: '% Conduites du ballon',
      Aerials: 'Duels Aériens',
      ProgressivePassesReceivedIntoBox: 'Passes progressives reçues dans la Surface',
      PassesOppHalf: 'Nombre total de passes réussies qui aboutissent dans le champ de l\'adversaire',
      ShotsOnTarget: 'Tirs Cadrés',
      AggressiveActions: 'Actions agressives',
      Crosses: 'Centres',
      xGBuildup5pass: 'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
      DefensiveDistance: 'Distance moyenne au but adverse des duels défensifs effectués',
      SpeedSequence: 'Vitesse de la Séquence',
      Touches: 'Touches',
      AerialsTotalOppHalf: 'Aerials Total au terrain rival',
      AerialsWonOppHalf: 'Duels aériens réussis dans la moitié de terrain adverse toutes',
      AerialsWonOppHalfPct: '% Aerials gagnés au terrain rival',
      AerialsPctOppBox: 'Percentage of aerials duels won into opponent box',
      AerialsPctOwnBox: 'Percentage of aerials duels won into own box',
      AerialDefensive: 'Nombre total de duels aériens lorsque l\'équipe adverse a la possession du ballon',
      AerialOffensive: 'Nombre total de duels aériens lorsque sa propre équipe a la possession du ballon',
      AerialOffensivePct: 'Pourcentage de duels aériens gagnés lorsque sa propre équipe a la possession du ballon',
      IndividualPressureOppHalf: 'Pression individuelle au terrain rival',
      ChancesCreatedOP: 'Opportunités créées en jeu',
      TouchesPerShot: 'Touches par tir',
      PassesFinalThirdTotalPct: '% Passes dans le dernier tiers',
      xACrosses: 'Passes décisives de centres',
      Passes: 'Passes',
      PassesSuccessful: 'Passes réussies',
      TacklesWasDribbledFouls: 'Pourcentage de tackles gagnés par rapport au total des tackles et des fautes commises',
      OffsidesCaught: 'Offsides Caught',
      ProgressivePassesReceivedFinalThird: 'Passes Progressifs Reçus dans le Dernier ⅓',
      ProgressivePassesReceived: 'Passes Progressifs Reçus',
      Breadth: 'Somme des plaquages, des contestations, des interceptions et des fautes commises, sur les bords du terrain',
      DuelsDefTotal: 'Somme du total des tacles, des duels aériens défensifs et des fautes commises',
      DefensiveActions: 'Actions défensives lorsqu\'un adversaire tente de dribbler (tacles, challenges et fautes)',
      ProgressivePassesReceivedOppHalf: ' Passes Progressives Reçues Moitié Adverse',
      CompletedCrossesOP: 'Centres Réalisées en Jeu',
      CrossingOP: 'Pourcentage de centres réalisées sur l\'ensemble des centres tentés en jeu',
      CrossesOP: 'Nombre total de centres pendant le jeu ouvert',
      PassingContribution: ' Pourcentage qui mesure la dangerosité des passes en tenant compte de la position du receveur. ',
      BallProgressionOppHalfInTeam: '% Progression de la balle dans la moitié de terrain adverse dans l’équipe',
      PassesOPIntoBoxInTeam: '% Passes en Jeu dans la surface dans l’équipe',
      TouchesOppBoxInTeam: '% Touches dans la surface adverse dans l’équipe',
      xGOPInTeam: '% xG en Jeu dans l’équipe',
      DeepPasses: 'Passes provenant de l\'extérieur d\'un rayon de 20 mètres du but adverse et aboutissant dans cette zone',
      DeepPassesTotal: 'Total des passes tentées depuis l\'extérieur d\'un rayon de 20 mètres du but adverse qui se terminent à l\'intérieur de cette zone',
      DefensiveDuelsPct: 'Pourcentage de duels défensifs gagnés sur le total des duels défensifs',
      QuickRecoveriesPct: 'Pourcentage de récupérations rapides par rapport aux interceptions et aux tentatives de tacle',
      DiffDefensiveDistanceTeam: 'Différence entre la distance défensive du joueur et la distance défensive de son équipe.',
      xTPassing: 'Danger attendu généré uniquement par les passes',
      xTPassing100Passes: 'Danger attendu généré uniquement par les passes par 100 passes',
      ProgressivePassesAccurate: 'Passes complétées de 10 mètres ou plus dans l\'axe X',
      PassAbility: 'Rapport entre les passes réalisées et les passes attendues (xP)',
      OPPassesIntoOppBoxPct: 'Pourcentage de passes réussies en jeu dans la surface adverse et de tentatives de passes en jeu dans la surface adverse',
      EntriesOppBox: 'Nombre de passes et de portés dans la surface adverse ',
      Crosses6yardBox: 'Nombre total de centres aboutissant dans la surface de but.',
      Cutbacks: 'Passes de la ligne de fond à l\'arrière et à l\'intérieur de la surface adverse ',
      xTDribbling: 'Danger attendu généré uniquement par les dribbles ',
      AvgShotDistance: 'Distance moyenne du nombre total de tirs réalisés',
      xGOnTarget: 'Buts attendus des tirs cadrés. Mesure la probabilité qu\'un tir aboutisse à un but en utilisant la position finale du tir',
      FinishingxGOT: 'Pourcentage de tirs cadrés aboutissant à un but supérieur à la moyenne. Cette mesure permet d\'évaluer la valeur ajoutée de l\'attaquant grâce à la qualité de ses tirs',
      DribblesWonOwnHalf: 'Dribbles réussis dans sa propre moitié du terrain',
      DribblesOwnHalf: 'Nombre de tentatives de dribbles effectuées dans la propre moitié du terrain. ',
      DribblesOwnHalfPct: 'Pourcentage de dribbles réussis et de tentatives de dribbles effectués dans la moitié de terrain',
      DribblesWonOppHalf: 'Dribbles réussis dans la moitié du terrain adverse ',
      DribblesOppHalf: 'Nombre de dribbles tentés dans la moitié du terrain adverse',
      DribblesOppHalfPct: 'Percentage of successful dribbles and attempted dribbles made in opponent half',
      DribblesWonFinalThird: 'Dribbles réussis dans le dernier tiers',
      DribblesFinalThird: 'Nombre de tentatives de dribbles réalisées dans le dernier tiers du terrain',
      DribblesFinalThirdPct: 'Pourcentage de dribbles réussis et de tentatives de dribbles réalisés dans le dernier tiers',
      ShotEndingHighRecoveries: 'Récupérations hautes (à 40 mètres ou moins du but adverse) se terminant par un tir',
      PassingFinalThirdAgainst: 'Passes réussies de l’adversaire vers le dernier tiers',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Nombre total de passes tentées par l’adversaire dans notre surface en jeu ouvert',
      EntriesOppBoxAgainst: 'Nombre de passes et courses de l’adversaire dans notre surface',
      DeepProgressionAgainst: 'Nombre de fois que l’adversaire atteint le dernier cinquième du terrain en portant le ballon, plus les possessions dans notre premier cinquième',
      TouchesInOpponentBoxAgainst: 'Nombre de fois que l’adversaire a le ballon dans notre surface',
      Score: 'Performances des joueurs en fonction de différents paramètres',
      PDScore: 'Performance physique des joueurs en fonction de différents paramètres physiques',
      OrlegiScore: 'Performances des joueurs en fonction de différents paramètres',
      SirScore: 'Performances des joueurs en fonction de différents paramètres',
      ExcScore: 'Performances des joueurs en fonction de différents paramètres',
      xTOPInTeam: 'Danger attendu (xT) généré dans le jeu par rapport au total de votre équipe',
      YellowCards: 'Cartons jaunes reçus',
      RedCards: 'Cartons rouges reçus',
      xTOpenPlayAgainst: 'Danger attendue concédée en jeu ouvert',
      xTSetPieceAgainst: 'Danger attendue sur coup de pied arrêté',
      NPGOpenPlayAgainst: 'BSP en Jeu Reçu',
      NPGSetPieceAgainst: 'BSP Coup de Pied Reçu',
      PassesOppHalfPerPossession: 'Passes au Terrain Rival par la Possession',
      AverageTimeRecovery: 'Temps Moyen de Récupération',
      ExpectedPassing: 'Pourcentage de passes qui auraient dû être complétées',
      NumPossession10Passes: 'Possessions 10 Passes',
      PassesReceived: 'Passes Reçues',
      PassesReceivedFinalThird: 'Passes Reçues en Finale ⅓',
      ProgressivePassesTotalPct: '% de Passes Progressives',
      ShortPassesPct: '% de Passes Courtes',
      TouchesOppBoxOppTeam: 'Nombre d’actions adverses concédées dans la propre surface lorsque le joueur est sur le terrain',
      ShotsOnTargetOppTeam: 'Tirs cadrés concédés lorsque le joueur est sur le terrain',
      NPGOppTeam: 'Buts encaissés hors penaltys lorsque le joueur est sur le terrain',
      xGSetPiecePerxG: 'xG généré sur coup de pied arrêté nécessaire pour produire un xG',
      ShotsOpenPlay: 'Nombre de tirs générés dans le jeu ouvert',
      ShotsOpenPlayAgainst: 'Nombre de tirs concédés dans le jeu ouvert',
      ShotsFromDribble: 'Tirs effectués après avoir dribblé un adversaire',
      GoalsFromDribble: 'Buts marqués après avoir dribblé un adversaire',
      PassesIntoFinalThird: 'Passes réussies depuis le dernier tiers',
      PassesIntoFinalThirdTotal: 'Nombre total de passes tentées commençant à l\'extérieur et se terminant à l\'intérieur du dernier tiers',
      PassesInsideFinalThird: 'Passes réussies à l’intérieur du dernier tiers (début et fin dans le dernier tiers)',
      PassesInsideFinalThirdTotal: 'Total des passes tentées dans le dernier tiers (début et fin dans le dernier tiers)',
      PassesFinalThirdNoArea: 'Passe le dernier tiers (sans boîte)',
      PassesIntoOppBox: 'Passes réussies se terminant dans la surface adverse',
      CarriesFinalThird: 'Conduites d’au moins 7 mètres se terminant dans le dernier tiers',
      CarriesInsideFinalThird: 'Conduites d’au moins 7 mètres à l’intérieur du dernier tiers (début et fin dans le dernier tiers)',
      CarriesFinalThirdNoBox: 'Transporte le dernier tiers (sans boîte)',
      CarriesIntoOppBox: 'Conduites d’au moins 7 mètres se terminant dans la surface adverse',
      TimePossessionAgainst: 'Temps de possession du ballon de l\'équipe adverse',
      TimePossessionTotal: 'Temps de possession du ballon des deux équipes',
      PassesInBox: 'Passes réussies qui commencent dans la surface adverse',
      LongThrowInSuccessful: 'Remise en jeu longue réussie depuis la ligne de touche, conçue pour envoyer le ballon à plus de 20 mètres',
      LongThrowInTotal: 'Nombre total de remises en jeu longues depuis la ligne de touche, conçues pour envoyer le ballon à plus de 20 mètres',
      LongThrowInPct: 'Pourcentage de remises en jeu longues (plus de 20 mètres) réussies',
      Games: 'Jeux joués',
      PointsPerGame: 'Points par jeu',
      ExpectedPointsDiff: 'Différence de points attendue',
      PassesTotalOwnHalf: 'Nombre total de passes effectuées depuis sa propre moitié de terrain',
      PassesOwnHalf: 'Nombre de passes réussies depuis sa propre moitié de terrain',
      PassesTotalOppHalf: 'Nombre total de passes effectuées depuis la moitié adverse',
      ProgressivePassesTotal: 'Nombre total de passages de 10 mètres ou plus sur l\'axe X',
      DuelsWon: 'Duels réussis (Tacles, Aériens, Touches de Ballon, Dribbles et Fautes commises)',
      NonPenaltySaves: 'Arrêts hors tirs de pénalité',
      BadActionsOppHalf: 'Somme de toutes les mauvaises actions commises (passe ratée, reprise ratée, dépossession, passe hors-jeu, touche de balle ratée) dans la moitié de terrain adverse',
      CarriesSuccessful: 'Nombre de portées d\'au moins 7 mètres se terminant par une épreuve réussie',
      ShotsOnTargetOutBox: 'Tirs cadrés depuis l\'extérieur de la surface',
      TotalDistance: 'Distance totale parcourue par le joueur pendant un match',
      WalkingDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse inférieure à 2 m/s (7,2 km/h)',
      JoggingDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse entre 2 m/s (7,2 km/h) et 4 m/s (14,4 km/h)',
      RunningDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse entre 4 m/s (14,4 km/h) et 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Nombre de fois que le joueur accélère de plus de 3 m/s²',
      NumberOfRuns: 'Nombre de courses effectuées à une vitesse entre 4 m/s (14,4 km/h) et 5,5 m/s (19,8 km/h)',
      DistanceIP: 'Distance (Équipe en possession) parcourue par le joueur pendant un match avec possession',
      DistanceOOP: 'Distance OTIP (Équipe adverse en possession) parcourue par le joueur pendant un match sans possession',
      HsrNumber: 'Nombre de fois que le joueur se déplace à une vitesse supérieure ou égale à 5,5 m/s (19,8 km/h) mais inférieure à 7 m/s (25,2 km/h) pendant au moins une seconde',
      HsrDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse supérieure ou égale à 5,5 m/s (19,8 km/h) mais inférieure à 7 m/s (25,2 km/h)',
      HsrDistancePct: 'Pourcentage de la distance de course à haute vitesse (HSR) par rapport à la distance totale parcourue',
      SprintsNumber: 'Nombre de fois que le joueur se déplace à une vitesse supérieure ou égale à 7 m/s (25,2 km/h) pendant au moins une seconde',
      SprintsDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse supérieure ou égale à 7 m/s (25,2 km/h)',
      SprintNumberDeclinePct: 'Pourcentage de diminution du nombre de sprints effectués par rapport à la deuxième mi-temps du match',
      SprintDistanceDeclinePct: 'Pourcentage de diminution de la distance parcourue en sprint par rapport à la deuxième mi-temps du match',
      SprintNumberDecline: 'Diminution du nombre de sprints effectués par rapport à la deuxième mi-temps du match',
      SprintDistanceDecline: 'Diminution de la distance parcourue en sprint par rapport à la deuxième mi-temps du match',
      SprintDistancePct: 'Pourcentage de la distance de sprint par rapport à la distance totale parcourue',
      Accelerations: 'Nombre de fois que le joueur accélère entre 1,5 m/s² et 3 m/s²',
      ExplosiveDistance: 'Distance explosive',
      MaxSpeed: 'Vitesse maximale atteinte par le joueur',
      AvgMaxSpeed: 'Vitesse maximale moyenne atteinte par le joueur',
      MaxAccelerations: 'Accélération maximale en mètres/seconde² atteinte par le joueur',
      BypassedPlayersByPasses: 'Nombre de joueurs du côté du but du porteur du ballon au début de l\'événement de touche, moins le nombre de joueurs du côté du but à la fin de l\'événement',
      BypassedDefendersByPasses: 'Nombre de défenseurs du côté du but du porteur du ballon au début de l\'événement de touche, moins le nombre de défenseurs du côté du but à la fin de l\'événement',
      PassesBypassingPlayers: 'Nombre de passes qui ont dépassé des joueurs',
      PassesBypassingDefenders: 'Nombre de passes qui ont dépassé des défenseurs',
      BypassedPlayersPerPass: 'Nombre total de joueurs dépassés par passe',
      BypassedDefendersPerPass: 'Nombre total de défenseurs dépassés par passe',
      LineBreakingPasses: 'Passes réussies qui avancent le ballon d\'au moins 10% vers le but adverse et traversent un couple de défenseurs en proximité ou passent derrière la ligne défensive',
      LineBreakingPassesMD: 'Passes réussies qui cassent les lignes du milieu et de la défense',
      LineBreakingPassesM: 'Passes réussies qui cassent la ligne du milieu',
      LineBreakingThroughBalls: 'Passes réussies qui cassent la ligne défensive',
      LineBreakingPassesPerPass: 'Nombre de lignes brisées par passe',
      TotalPassesUnderStrongPressure: 'Nombre total de passes effectuées sous forte pression (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      TotalPassesUnderLightPressure: 'Nombre total de passes effectuées sous pression (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      SuccessfulPassesUnderStrongPressure: 'Nombre de passes réussies effectuées sous forte pression (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      SuccessfulPassesUnderLightPressure: 'Nombre de passes réussies effectuées sous pression (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      PassingUnderStrongPressure: 'Pourcentage de passes réussies et totales sous forte pression (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      PassingUnderLightPressure: 'Pourcentage de passes réussies et totales sous pression (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      PassReceiptsInSpaceCompleted: 'Passes effectuées lorsque le receveur est dans le camp adverse sans défenseur dans un rayon de 5 mètres vers le but',
      PassReceiptsInSpace: 'Passes reçues dans le camp adverse sans défenseur dans un rayon de 5 mètres vers le but',
      PassReceiptsInSpaceCompletedFirstThird: 'Passes effectuées où le receveur est dans le premier tiers et n’a aucun défenseur dans un rayon de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedSecondThird: 'Passes effectuées où le receveur est dans le deuxième tiers et n’a aucun défenseur dans un rayon de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedFinalThird: 'Passes effectuées où le receveur est dans le dernier tiers et n’a aucun défenseur dans un rayon de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passes effectuées où le receveur est dans la moitié adverse (côté droit) et n’a aucun défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passes effectuées où le receveur est dans la moitié adverse (zone centrale) et n’a aucun défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passes effectuées où le receveur est dans la moitié adverse (côté gauche) et n’a aucun défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceFirstThird: 'Passes reçues dans le premier tiers sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceSecondThird: 'Passes reçues dans le deuxième tiers sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceFinalThird: 'Passes reçues dans le dernier tiers sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceOppHalfRight: 'Passes reçues dans la moitié adverse (côté droit) sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceOppHalfCenter: 'Passes reçues dans la moitié adverse (zone centrale) sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceOppHalfLeft: 'Passes reçues dans la moitié adverse (côté gauche) sans défenseur à moins de 5 mètres en direction du but',
      TotalStrongOnBallPressures: 'Nombre de fortes pressions sur le porteur du ballon (dans un rayon de 0-2 mètres)',
      TotalLightOnBallPressures: 'Nombre de pressions sur le porteur du ballon (dans un rayon de 2-4 mètres)',
      SuccessfulStrongOnBallPressures: 'Nombre de fortes pressions réussies sur le porteur du ballon (dans un rayon de 0-2 mètres)',
      SuccessfulLightOnBallPressures: 'Nombre de pressions réussies sur le porteur du ballon (dans un rayon de 2-4 mètres)',
      StrongOnBallPressuresPct: 'Pourcentage de fortes pressions réussies et totales sur le porteur du ballon (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      LightOnBallPressuresPct: 'Pourcentage de pressions réussies et totales sur le porteur du ballon (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      TimesBypassedByPasses: 'Nombre total de fois dépassé par une passe',
      TimesBypassedByCarries: 'Nombre total de fois dépassé par une conduite',
      TimesBypassedByActions: 'Nombre total de fois dépassé par des passes et des conduites combinées',
      BypassedPlayersByCarries: 'Nombre total d\'adversaires (défenseurs et milieux) dépassés par des conduites',
      BypassedDefendersByCarries: 'Nombre total d\'adversaires (défenseurs) dépassés par des conduites',
      BypassedPlayersByActions: 'Nombre total d\'adversaires (défenseurs et milieux) dépassés par des passes et des conduites combinées',
      BypassedDefendersByActions: 'Nombre total d\'adversaires (défenseurs) dépassés par des passes et des conduites combinées',
      CarriesBypassingPlayers: 'Nombre de conduites ayant dépassé des joueurs',
      CarriesBypassingDefenders: 'Nombre de conduites ayant dépassé des défenseurs',
      BypassedPlayersPerCarry: 'Moyenne d\'adversaires dépassés par conduite',
      BypassedDefendersPerCarry: 'Moyenne de défenseurs dépassés par conduite',
      LineBreakingCarries: 'Nombre de conduites ayant franchi une ou plusieurs lignes défensives',
      LineBreakingCarriesMD: 'Nombre de conduites ayant franchi les lignes des milieux et défenseurs',
      LineBreakingCarriesM: 'Nombre de conduites ayant franchi la ligne des milieux',
      LineBreakingCarriesD: 'Nombre de conduites ayant franchi la ligne défensive',
      LineBreakingCarriesPerCarry: 'Pourcentage de conduites entre les lignes par conduite',
      LineBreakingActions: 'Nombre de passes et de conduites combinées ayant franchi une ou plusieurs lignes défensives',
      LineBreakingActionsMD: 'Nombre de passes et de conduites combinées ayant franchi les lignes des milieux et défenseurs',
      LineBreakingActionsM: 'Nombre de passes et de conduites combinées ayant franchi la ligne des milieux',
      LineBreakingActionsD: 'Nombre de passes et de conduites combinées ayant franchi la ligne défensive',
      PassesPerLineBreakingPass: 'Ratio entre le nombre total de passes par passe entre les lignes',
      CarriesPerLineBreakingCarry: 'Ratio entre le nombre total de conduites par conduite entre les lignes',
      LinesBrokenByPasses: 'Nombre total de lignes franchies par des passes',
      LinesBrokenByCarries: 'Nombre total de lignes franchies par des conduites',
      LinesBrokenByActions: 'Nombre total de lignes franchies par des passes et des conduites combinées',
      LinesBrokenPerPass: 'Ratio entre le nombre total de lignes franchies par passe',
      LinesBrokenPerCarry: 'Ratio entre le nombre total de lignes franchies par conduite',
      AvgLastDefenderDistanceIP: 'Distance entre le dernier défenseur (le plus proche de son propre but) et la ligne de but en possession',
      AvgLastDefenderDistanceOOP: 'Distance entre le dernier défenseur (le plus proche de son propre but) et la ligne de but sans possession',
      AvgDefensiveLineDistanceIP: 'Distance entre la ligne défensive la plus reculée et le but en possession',
      AvgDefensiveLineDistanceOOP: 'Distance entre la ligne défensive la plus reculée et le but sans possession',
      AvgRBDistanceIP: 'Distance entre le latéral droit et son propre but en possession',
      AvgRBDistanceOOP: 'Distance entre le latéral droit et son propre but sans possession',
      AvgLBDistanceIP: 'Distance entre le latéral gauche et son propre but en possession',
      AvgLBDistanceOOP: 'Distance entre le latéral gauche et son propre but sans possession',
      AvgBlockDistanceIP: 'Distance entre le joueur de champ le plus avancé et le plus reculé en possession',
      AvgBlockDistanceOOP: 'Distance entre le joueur de champ le plus avancé et le plus reculé sans possession',
      AvgBlockAreaIP: 'Surface du rectangle englobant tous les joueurs de champ (mesure de l’espace occupé par l’équipe) en possession',
      AvgBlockAreaOOP: 'Surface du rectangle englobant tous les joueurs de champ (mesure de l’espace occupé par l’équipe) sans possession',
      AvgDefensiveLineWidthOOP: 'Largeur de la ligne la plus reculée (la plus éloignée du but) sans possession',
      AvgOffensiveLineLastThirdWidthIP: 'Largeur horizontale de la ligne offensive dans le dernier tiers en possession',
      AvgLByIP: 'Position du latéral gauche en possession',
      AvgRByIP: 'Position du latéral droit en possession',
      AvgOffensiveLineDistanceIP: 'Distance entre le but et la ligne offensive en possession',
      AvgOffensiveLineLastThirdDistanceIP: 'Distance entre le but et la ligne offensive dans le dernier tiers en possession',
      AvgOffensiveLineWidthIP: 'Largeur horizontale de la ligne offensive en possession',
      OffBallRuns: 'Déplacements sans ballon intentionnels pour soutenir la phase offensive',
      OffBallRunsOverlap: 'Courses où le joueur contourne son coéquipier par l\'extérieur (près de la ligne de touche) pendant que celui-ci a le ballon',
      OffBallRunsUnderlap: 'Courses où le joueur passe à l\'intérieur de son coéquipier, plus proche de l\'axe du terrain',
      OffBallRunsRunAhead: 'Course vers l’avant qui dépasse le porteur du ballon tout en restant devant le dernier défenseur',
      OffBallRunsRunBehind: 'Course vers l’avant qui pénètre la dernière ligne défensive, entre les défenseurs et le gardien',
      OffBallRunsCrossReceiver: 'Un joueur court vers la surface pour se positionner afin de recevoir un centre d’un coéquipier',
      OffBallRunsSupport: 'Le joueur court pour se joindre à la ligne du porteur du ballon, offrant une option de passe proche',
      OffBallRunsComingShort: 'Le joueur se rapproche du porteur du ballon pour offrir un soutien proche ou une option de passe en retrait',
      AerialsOppHalf: 'Aerials au terrain rival',
      CarriesIntoFinalThird: 'Canalisations d\'au moins 7 mètres de l\'extérieur vers l\'intérieur du dernier tiers',
      SpeedScore: 'Performance physique du joueur basée sur différentes mesures de vitesse',
      EnduranceScore: 'Performance physique d\'endurance du joueur basée sur différentes mesures',
      SwitchPlaySuccessful: 'Nombre de passes complétées sur 32 mètres où le déplacement latéral du ballon est supérieur à son déplacement vers le but adverse',
      SwitchPlayTotal: 'Nombre total de tentatives de passes sur 32 mètres où le déplacement latéral du ballon est supérieur à son déplacement vers le but adverse',
      PassesInsideOppHalf: 'Nombre total de passes commençant et se terminant dans la moitié de terrain adverse',
      PassesInsideOppHalfSuccessful: 'Nombre de passes complétées commençant et se terminant dans la moitié de terrain adverse',
      TacklesAttemptedFirstThird: 'Nombre total de plaquages ​​tentés dans le premier tiers du terrain',
      TacklesAttemptedSecondThird: 'Nombre total de plaquages ​​tentés dans le deuxième tiers du terrain',
      TacklesFirstThird: 'Nombre de plaquages ​​réussis réalisés dans le premier tiers du terrain',
      TacklesSecondThird: 'Nombre de plaquages ​​réussis réalisés dans le deuxième tiers du terrain',
      FoulsOwnHalf: 'Nombre de fautes commises dans la moitié de terrain du joueur',
      TouchesOppHalf: 'Nombre de touches de ballon dans la moitié de terrain adverse',
      TacklesAttemptedNotAdjusted: 'Nombre total de plaquages ​​tentés, sans ajustement de possession',
      TacklesSuccessfulNotAdjusted: 'Nombre total de plaquages ​​réussis, sans ajustement de possession',
      AvgTop5MaxSpeed: 'Moyenne des cinq vitesses maximales les plus élevées du joueur',
      LBPReceived: 'Nombre de passes décisives reçues. Il s\'agit de passes terminées qui rapprochent le ballon d\'au moins 10 % du but adverse et croisent deux défenseurs à proximité ou se déplacent au-delà de la ligne défensive.',
      LBPMReceived: 'Nombre de passes reçues qui franchissent la ligne médiane adverse',
      LBPMDReceived: 'Nombre de passes reçues qui traversent à la fois le milieu de terrain adverse et les lignes défensives',
      ThroughBallReceived: 'Nombre de passes reçues qui franchissent la dernière ligne défensive adverse',
      HsrDistanceIP: 'Distance de sprint >21 km/h en possession',
      HsrDistanceOOP: 'Distance de sprint >21 km/h hors possession',
      JoggingDistanceIP: 'Distance de jogging en possession',
      JoggingDistanceOOP: 'Distance de jogging hors possession',
      RunningDistanceIP: 'Distance de course en possession',
      RunningDistanceOOP: 'Distance de course hors possession',
      SprintsDistanceIP: 'Distance de sprint >24 km/h en possession',
      SprintsDistanceOOP: 'Distance de sprint >24 km/h hors possession',
      WalkingDistanceIP: 'À distance de marche en possession',
      WalkingDistanceOOP: 'À distance de marche hors de possession',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: 'Nombre de fois où vous forcez l\'adversaire à perdre la possession',
      HandPassesSuccessful: 'Passes réussies faites avec les mains (gardiens ou remise en jeu sur coup de pied arrêté)',
      HandPassesTotal: 'Nombre total de passes effectuées avec les mains (gardien ou remise en jeu sur coup de pied arrêté)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Pourcentage de possession de l\'équipe',
      TimePossession: 'Temps de possession de l\'équipe',
      PassesPerShots: 'Nombre de passes effectuées par tir',
      PPDA: 'Passes par Actions Défensives. Plus le PPDA est élevé, plus la pression exercée sur l\'adversaire est faible.',
      Directness: 'Mesure le degré de verticalité d\'une équipe dans ses passes, récompensant les passes vers le but de l\'adversaire',
      ExpectedPoints: 'Nombre de points attendus d\'une équipe, calculé à partir des buts attendus générés et concédés dans chaque match. Ce calcul permet de connaître la performance d\'une équipe par rapport à un match (ou des matchs cumulés) en la comparant aux points que l\'équipe a effectivement obtenus',
      PassesPerLongBall: 'Nombre de passes effectués par longue passe',
      CrossingPerXG: 'Pourcentage des buts attendus qui proviennent des centres dans la surface de réparation',
      PenaltySavedPenaltyFaced: 'Pourcentage de penaltys sauvées par rapport aux pénalités concédées',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Nombre total de tirs sur penalty',
      PenaltyGoals: 'Nombre total de buts sur penalty',
      NonPenaltyGoals: 'Buts sans penalty',
      AerialWins: 'Duels Aériens Gagnés',
      AerialEfficiency: 'Modèle combinant les duels aériens gagnés avec le total des duels aériens',
      AerialWinsPct: 'Pourcentage des duels aériens gagnés',
      Assists: 'Passes décisives',
      Catching: 'Pourcentage d\'arrêts rattrapés',
      Caught: 'Enregistre l\'endroit où le gardien de but attrape et tient le ballon, empêchant tout deuxième jeu',
      ChancesCreated: 'Opportunités crées',
      ClaimAccuracy: 'Balles attrapées au-dessus de la moyenne',
      CompletedCrosses: 'Nombre de centres réussis',
      Crossing: 'Pourcentage de centres réussis',
      Dispossessed: 'Nombre de pertes du ballon du joueur',
      Finishing: 'Finition',
      xGEfficiency: 'Quantity of expected goals needed for a player to score a goal',
      Fouls: 'Fautes réalisées',
      DeepProgression: 'Nombre de fois où le dernier cinquième du terrain est atteint en portant le ballon, plus le nombre de fois où la possession du ballon est dans le dernier cinquième',
      DeepProgressionFinalThird: 'Times the player has the possession in the final third',
      FoulsTaken: 'Fautes provoquées',
      IndividualPressure: 'Pression individuelle',
      Interceptions: 'Interceptions',
      LongBallPct: 'Pourcentage de passes longues complétées',
      LongBallTotal: 'Nombre total de passages sur 32 mètres',
      LongBallSuccessful: 'Passes longues complétées',
      NPGOpenPlay: 'Buts (excluding penalties) by open play actions',
      NPGSetPiece: 'Buts (excluding penalties) by set piece actions',
      OpenPlayKeyPasses: 'Nombre de passes effectuées en jeu qui se traduisent par un tir (sans compte les passes décisives)',
      OpenPlayKeyPassesInTeam: 'Pourcentage de passes effectuées en jeu qui se traduisent par un tir (sans compte les passes décisives) dans l’équipe',
      PassingFinalThird: 'Passes réussies, hors centres, coups de pied arrêtés, corners et touches, qui commencent dans le dernier tiers',
      PassesFinalThirdTotal: 'Total de passes tentées, hors centres, coups de pied arrêtés, corners et remises en jeu, qui se terminent dans le dernier tiers',
      PassingFinalThirdPct: 'Pourcentage de passes réussies parmi toutes les passes du joueur (uniquement celles qui commencent dans le dernier tiers)',
      PassingOppHalfPct: 'Pourcentage de passes dans le terrain adverse ',
      PassingOwnHalfPct: 'Pourcentage de passes dans le terrain propre',
      PassingPct: 'Pourcentage de passes',
      Recoveries: 'Nombre de balles récupérées par le joueur',
      SavesInBoxPct: 'Pourcentage d\'arrêts dans l\'intérieur de la surface ',
      SavesOutOfBoxPct: 'Pourcentage d\'arrêts en dehors la surface',
      SavesPct: 'Porcentaje d\'arrêts\'',
      ScoringContribution: 'Nombre de Passes Décisives et de Buts',
      xAssistsOpenPlay: 'Nombre de passes décisives attendus qui proviennent des actions en jeu et non de coups de pied',
      xAssistsSetPiece: 'Nombre de passes décisives attendues qui proviennent des coups de pied',
      xAssistsOpenPlayInTeam: 'Nombre de passes décisives attendus qui proviennent des actions en jeu et non de coups de pied dans l’équipe',
      xAssistsSetPieceInTeam: 'Nombre de passes décisives attendues qui proviennent des coups de pied dans l’équipe',
      xGChainFinalThird: 'Nombre de buts attendus auxquels le joueur a participé au cours du dernier tiers du terrain.',
      xGBuildupFinalThird: 'Nombre de buts attendus auxquels le joueur a participé dans le dernier tiers (à l\'exclusion des tirs et des passes qui les précèdent).',
      BallProgressionPassing: 'Progression des balles à travers les passes',
      BallProgressionDribbling: 'Progression des balles grâce aux dribbles',
      Shooting: 'Pourcentage de tirs cadrés',
      Shots: 'Tirs cadrés',
      ShotsPerGoal: 'Tirs cadrés par but',
      SuccessfulDribbles: 'Nombre de dribles accompli',
      TacklesSuccessful: 'Tacles',
      TacklesWasDribbled: 'Duels défensifs 1 contre 1 gagnés',
      ThroughBalls: 'Passe en profondeur',
      TouchesInOpponentBox: 'Touches dans la surface de réparation adverse',
      xAssists: 'Passes décisives attendus',
      xG: 'Buts attendus',
      xGDiff: 'Différence entre xG et Goals',
      xGOpenPlay: 'Buts attendus générés par le jeu ouvert',
      xGSetPiece: 'xG Coup de Pied',
      xGBuildup: 'Construction xG',
      xGBuildupInTeam: 'Construction xG in Team',
      BallProgression: 'Progression de la balle',
      xGChain: 'Participation xG',
      xGPerNPG: 'xG par Buts sans penalty contre',
      xGPerShot: 'xG par Tir',
      xGSavedPerShot: 'xG Arrêtes par Tir',
      xGSavedPerXGFacedOnTarget: 'xG Arrêtés/ xG Concedé',
      xGFacedOnTargetPerGoalReceived: 'Buts Attendus il faut pour marquer un but contre le gardien',
      xGFacedOnTargetEfficiency: 'Nombre de buts non penalty évités par le gardien',
      xGFacedOnTarget: 'Total des xG (sauvés et marqués) auxquels le gardien de but a été confronté',
      HighTurnovers: 'Pertes de balle à moins de 40 mètres de son propre but',
      OpenPlayPassesIntoOpponentBox: 'Total passes en jeu ouvert par le joueur dans la surface de réparation de l\'adversaire',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Passes complétées en jeu ouvert par le joueur dans la surface de réparation de l\'adversaire',
      ChancesCreatedOP: 'Opportunités créées en jeu',
      PenaltiesTaken: 'Nombre des penaltys reçu',
      BlockedCrosses: 'Nombre de centres bloqués pour atteindre la destination',
      BlockedShots: 'Tirs qui n\'ont pas atteint le but en raison de l\'intervention de l\'équipe adverse.',
      NonPenaltyGoalsAgainst: 'Buts concédés (hors tirs au but)',
      Headers: 'Tir de la Tête',
      AveragePassDistance: 'Distance Moyenne de Passes',
      ProgressiveRuns: 'Maniement Progressif',
      xT: 'Danger généré dans les zones dangereuses',
      xTOpenPlay: 'Danger Attendu qui proviennent des actions en jeu et non de coups de pied',
      xTSetPiece: 'Danger Attendu qui proviennent des actions de coups de pied et non en jeu',
      xGOT: 'Buts cadrés attendus. Nombre de buts attendus par le gardien de but. Cette mesure ne prend en compte que les tirs cadrés (les tirs manqués et les tirs sur le poteau sont exclus)',
      BadActions: 'Pertes',
      BadActionsOwnHalf: 'Pertes sur le terrain propre',
      AerialsWonOwnBox: 'Duels aériens gagnés dans sa Propre Surface',
      AerialsWonOppBox: 'Aerials Won Opp Box',
      AerialsTotalOppBox: 'Aerials Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Total Own Box',
      FoulsOwnHalfPct: '% Fautes sur le terrain propre',
      RecoveriesOppHalf: 'Nombre de balles récupérées par le joueur dans le terrain adverse',
      DuelsPct: '% Duels réussis',
      TacklesUnsuccessful: 'Nombre de fois qu\'un joueur ne parvient pas à récupérer le ballon alors qu\'un adversaire réussit à le dépasser',
      TacklesWasDribbledFirstThird: 'Duels défensifs 1 contre 1 gagnés le dernier tiers',
      TacklesWasDribbledSecondThird: 'Duels défensifs 1 contre 1 gagnés ⅔',
      TacklesWasDribbledFinalThird: 'Duels défensifs 1 contre 1 gagnés Finale ⅓',
      BallProgressionFinalThird: 'Progression du ballon dans le dernier tiers',
      DuelsTotal: 'Nombre total de tacles, de sauts, de touches de balle, de dribbles et de fautes commis',
      QuickRecoveries: 'Récupération à 40 mètres ou plus de son propre but dans les 8 secondes qui suivent un turnover.',
      ShotsPerNPG: 'Nomnbres de tirs par But sans Penaltis',
      ShotsOutBox: 'Tirs de l\'extérieur de la surface',
      GoalsOutBox: 'Buts provenant de l\'extérieur de la surface',
      ShootingOutBox: 'Pourcentage de tirs au but en dehors de la Surface de Réparation',
      HandPassing: 'Pourcentage de passes réalisées avec la main',
      ShotEndingHighTurnovers: 'Pertes Hautes (pertes à moins de 40 mètres de son propre but) qui se terminent par un tir de l\'équipe adverse',
      GoalEndingHighTurnovers: 'Pertes Hautes (pertes à moins de 40 mètres de son propre but) qui se terminent par un but de l\'équipe adverse',
      AverageCarriesProgress: 'Distance moyenne sur laquelle un joueur déplace le ballon verticalement par portée (mètres)',
      ChanceEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par une passe suivie d\'un tir',
      AssistEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par une passe suivie d\'un but',
      ShotEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par un tir',
      GoalEndingCarries: 'Portées d\'au moins 7 mètres qui se terminent par un but',
      ShotEndingSequence: 'Séquence se terminant par un tir',
      GoalEndingSequence: 'Séquence se terminant par un but',
      AerialWonOffensive: 'Aériens gagnés offensif',
      AerialWonDefensive: 'Aériens gagnés defensif',
      xGAgainst: 'xG Reçu',
      xGDiffAgainst: 'xG Diff Reçu',
      xGPerNPGAgainst: 'xG par Buts sans Penalties Reçu',
      xGOpenPlayAgainst: 'xG en Jeu Reçu',
      xGSetPieceAgainst: 'xG Coup de Pied Reçu',
      xGPerShotAgainst: 'xG par Tir Reçu',
      ShotsAgainst: 'Tirs Reçu',
      ShotsOnTargetAgainst: 'Tirs cadrés concédés',
      RivalPossession: 'Possession Rivale',
      AerialDefensivePct: '% Duels Aériens Défensifs',
      HighRecoveries: 'Récupérations Dangereuses',
      HighDefensiveActions: 'Actions Défensives (plaquages, interceptions, blocages, fautes et 1vs1) effectuées à 40 mètres au-dessus de la ligne de base',
      HighDefensiveActionPct: 'Pourcentage d\'actions défensives (plaquages, interceptions, blocages, fautes et 1vs1) effectuées à 40 mètres au-dessus de la ligne de base',
      HighDefensiveDistance: 'Distance moyenne du but adverse de toutes les Actions Défensives',
      PassesPerPossession: 'Passage par la Possession',
      LengthPerPossession: 'Distance par la Possession',
      xTNet: 'Danger Net Attendu',
      AvgCarriesDistance: 'Distance moyenne des Conduites du ballon',
      PassesForwardPct: 'Pourcentage de passes en avant sur le total',
      PassesForwardSuccessful: 'Passes avant réussies',
      PassesForwardTotal: 'Total des passes avant',
      TacklesAttempted: 'Tacles tentés',
      DuelsLost: 'Duels Perdus',
      Carries: 'Conduites du ballon',
      CarriesPct: '% Conduites du ballon',
      Aerials: 'Duels Aériens',
      ProgressivePassesReceivedIntoBox: 'Passes progressives reçues dans la Surface',
      PassesOppHalf: 'Nombre total de passes réussies qui aboutissent dans le champ de l\'adversaire',
      LongBallReceived: 'Longue Balle Reçue',
      ShotsOnTarget: 'Tirs Cadrés',
      AggressiveActions: 'Actions agressives',
      Crosses: 'Centres',
      xGBuildup5pass: 'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
      DefensiveDistance: 'Distance moyenne au but adverse des duels défensifs effectués',
      SpeedSequence: 'Vitesse de la Séquence',
      Touches: 'Touches',
      AerialsTotalOppHalf: 'Aerials Total au terrain rival',
      AerialsWonOppHalf: 'Duels aériens réussis dans la moitié de terrain adverse toutes',
      AerialsWonOppHalfPct: '% Aerials gagnés au terrain rival',
      AerialsPctOppBox: 'Percentage of aerials duels won into opponent box',
      AerialsPctOwnBox: 'Percentage of aerials duels won into own box',
      AerialDefensive: 'Nombre total de duels aériens lorsque l\'équipe adverse a la possession du ballon',
      AerialOffensive: 'Nombre total de duels aériens lorsque sa propre équipe a la possession du ballon',
      AerialOffensivePct: 'Pourcentage de duels aériens gagnés lorsque sa propre équipe a la possession du ballon',
      IndividualPressureOppHalf: 'Pression individuelle au terrain rival',
      TouchesPerShot: 'Touches par tir',
      PassesFinalThirdTotalPct: '% Passes dans le dernier tiers',
      xACrosses: 'Passes décisives de centres',
      Passes: 'Passes',
      PassesSuccessful: 'Passes réussies',
      TacklesWasDribbledFouls: 'Pourcentage de tackles gagnés par rapport au total des tackles et des fautes commises',
      OffsidesCaught: 'Offsides Caught',
      ProgressivePassesReceivedFinalThird: 'Passes Progressifs Reçus dans le Dernier ⅓',
      ProgressivePassesReceived: 'Passes Progressifs Reçus',
      Breadth: 'Somme des plaquages, des contestations, des interceptions et des fautes commises, sur les bords du terrain',
      DuelsDefTotal: 'Somme du total des tacles, des duels aériens défensifs et des fautes commises',
      DefensiveActions: 'Actions défensives lorsqu\'un adversaire tente de dribbler (tacles, challenges et fautes)',
      ProgressivePassesReceivedOppHalf: 'Passes Progressives Reçues Moitié Adverse',
      CompletedCrossesOP: 'Centres Réalisées en Jeu',
      CrossingOP: 'Pourcentage de centres réalisées sur l\'ensemble des centres tentés en jeu',
      CrossesOP: 'Nombre total de centres pendant le jeu ouvert',
      PassingContribution: 'Pourcentage qui mesure la dangerosité des passes en tenant compte de la position du receveur. ',
      BallProgressionOppHalfInTeam: '% Progression de la balle dans la moitié de terrain adverse dans l’équipe',
      PassesOPIntoBoxInTeam: '% Passes en Jeu dans la surface dans l’équipe',
      TouchesOppBoxInTeam: '% Touches dans la surface adverse dans l’équipe',
      xGOPInTeam: '% xG en Jeu dans l’équipe',
      DeepPasses: 'Passes provenant de l\'extérieur d\'un rayon de 20 mètres du but adverse et aboutissant dans cette zone',
      DeepPassesTotal: 'Total des passes tentées depuis l\'extérieur d\'un rayon de 20 mètres du but adverse qui se terminent à l\'intérieur de cette zone',
      DefensiveDuelsPct: 'Pourcentage de duels défensifs gagnés sur le total des duels défensifs',
      QuickRecoveriesPct: 'Pourcentage de récupérations rapides par rapport aux interceptions et aux tentatives de tacle',
      DiffDefensiveDistanceTeam: 'Différence entre la distance défensive du joueur et la distance défensive de son équipe.',
      xTPassing: 'Danger attendu généré uniquement par les passes',
      xTPassing100Passes: 'Danger attendu généré uniquement par les passes par 100 passes',
      ProgressivePassesAccurate: 'Passes complétées de 10 mètres ou plus dans l\'axe X',
      PassAbility: 'Rapport entre les passes réalisées et les passes attendues (xP)',
      OPPassesIntoOppBoxPct: 'Pourcentage de passes réussies en jeu dans la surface adverse et de tentatives de passes en jeu dans la surface adverse',
      EntriesOppBox: 'Nombre de passes et de portés dans la surface adverse ',
      Crosses6yardBox: 'Nombre total de centres aboutissant dans la surface de but.',
      Cutbacks: 'Passes de la ligne de fond à l\'arrière et à l\'intérieur de la surface adverse ',
      xTDribbling: 'Danger attendu généré uniquement par les dribbles ',
      AvgShotDistance: 'Distance moyenne du nombre total de tirs réalisés',
      xGOnTarget: 'Buts attendus des tirs cadrés. Mesure la probabilité qu\'un tir aboutisse à un but en utilisant la position finale du tir',
      FinishingxGOT: 'Pourcentage de tirs cadrés aboutissant à un but supérieur à la moyenne. Cette mesure permet d\'évaluer la valeur ajoutée de l\'attaquant grâce à la qualité de ses tirs',
      DribblesWonOwnHalf: 'Dribbles réussis dans sa propre moitié du terrain',
      DribblesOwnHalf: 'Nombre de tentatives de dribbles effectuées dans la propre moitié du terrain. ',
      DribblesOwnHalfPct: 'Pourcentage de dribbles réussis et de tentatives de dribbles effectués dans la moitié de terrain',
      DribblesWonOppHalf: 'Dribbles réussis dans la moitié du terrain adverse ',
      DribblesOppHalf: ' Nombre de dribbles tentés dans la moitié du terrain adverse',
      DribblesOppHalfPct: 'Percentage of successful dribbles and attempted dribbles made in opponent half',
      DribblesWonFinalThird: 'Dribbles réussis dans le dernier tiers',
      DribblesFinalThird: 'Nombre de tentatives de dribbles réalisées dans le dernier tiers du terrain',
      DribblesFinalThirdPct: 'Pourcentage de dribbles réussis et de tentatives de dribbles réalisés dans le dernier tiers ',
      ShotEndingHighRecoveries: 'Récupérations hautes (à 40 mètres ou moins du but adverse) se terminant par un tir',
      PassingFinalThirdAgainst: 'Passes réussies de l’adversaire vers le dernier tiers',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Nombre total de passes tentées par l’adversaire dans notre surface en jeu ouvert',
      EntriesOppBoxAgainst: 'Nombre de passes et courses de l’adversaire dans notre surface',
      DeepProgressionAgainst: 'Nombre de fois que l’adversaire atteint le dernier cinquième du terrain en portant le ballon, plus les possessions dans notre premier cinquième',
      TouchesInOpponentBoxAgainst: 'Nombre de fois que l’adversaire a le ballon dans notre surface',
      Score: 'Performances des joueurs en fonction de différents paramètres',
      PDScore: 'Performance physique des joueurs en fonction de différents paramètres physiques',
      OrlegiScore: 'Performances des joueurs en fonction de différents paramètres',
      SirScore: 'Performances des joueurs en fonction de différents paramètres',
      ExcScore: 'Performances des joueurs en fonction de différents paramètres',
      xTOPInTeam: 'Danger attendu (xT) généré dans le jeu par rapport au total de votre équipe',
      YellowCards: 'Cartons Jaunes',
      RedCards: 'Cartons Rouges',
      xTOpenPlayAgainst: 'Danger attendue concédée en jeu ouvert',
      xTSetPieceAgainst: 'Danger attendue sur coup de pied arrêté',
      NPGOpenPlayAgainst: 'BSP en Jeu Reçu',
      NPGSetPieceAgainst: 'BSP Coup de Pied Reçu',
      PassesOppHalfPerPossession: 'Passes au Terrain Rival par la Possession',
      AverageTimeRecovery: 'Temps Moyen de Récupération',
      ExpectedPassing: 'Pourcentage de passes qui auraient dû être complétées',
      NumPossession10Passes: 'Possessions 10 Passes',
      PassesReceived: 'Passes Reçues',
      PassesReceivedFinalThird: 'Passes Reçues en Finale ⅓',
      ProgressivePassesTotalPct: '% de Passes Progressives',
      ShortPassesPct: '% de Passes Courtes',
      TouchesOppBoxOppTeam: 'Nombre d’actions adverses concédées dans la propre surface lorsque le joueur est sur le terrain',
      ShotsOnTargetOppTeam: 'Tirs cadrés concédés lorsque le joueur est sur le terrain',
      NPGOppTeam: 'Buts encaissés hors penaltys lorsque le joueur est sur le terrain',
      xGSetPiecePerxG: 'xG généré sur coup de pied arrêté nécessaire pour produire un xG',
      ShotsOpenPlay: 'Nombre de tirs générés dans le jeu ouvert',
      ShotsOpenPlayAgainst: 'Nombre de tirs concédés dans le jeu ouvert',
      ShotsFromDribble: 'Tirs effectués après avoir dribblé un adversaire',
      GoalsFromDribble: 'Buts marqués après avoir dribblé un adversaire',
      PassesIntoFinalThird: 'Passes réussies depuis le dernier tiers',
      PassesIntoFinalThirdTotal: 'Nombre total de passes tentées commençant à l\'extérieur et se terminant à l\'intérieur du dernier tiers',
      PassesInsideFinalThird: 'Passes réussies à l’intérieur du dernier tiers (début et fin dans le dernier tiers)',
      PassesInsideFinalThirdTotal: 'Total des passes tentées dans le dernier tiers (début et fin dans le dernier tiers)',
      PassesFinalThirdNoArea: 'Passe le dernier tiers (sans boîte)',
      PassesIntoOppBox: 'Passes réussies se terminant dans la surface adverse',
      CarriesFinalThird: 'Conduites d’au moins 7 mètres se terminant dans le dernier tiers',
      CarriesInsideFinalThird: 'Conduites d’au moins 7 mètres à l’intérieur du dernier tiers (début et fin dans le dernier tiers)',
      CarriesFinalThirdNoBox: 'Transporte le dernier tiers (sans boîte)',
      CarriesIntoOppBox: 'Conduites d’au moins 7 mètres se terminant dans la surface adverse',
      TimePossessionAgainst: 'Temps de possession du ballon de l\'équipe adverse',
      TimePossessionTotal: 'Temps de possession du ballon des deux équipes',
      PassesInBox: 'Passes réussies qui commencent dans la surface adverse',
      LongThrowInSuccessful: 'Remise en jeu longue réussie depuis la ligne de touche, conçue pour envoyer le ballon à plus de 20 mètres',
      LongThrowInTotal: 'Nombre total de remises en jeu longues depuis la ligne de touche, conçues pour envoyer le ballon à plus de 20 mètres',
      LongThrowInPct: 'Pourcentage de remises en jeu longues (plus de 20 mètres) réussies',
      Games: 'Jeux joués',
      PointsPerGame: 'Points par jeu',
      ExpectedPointsDiff: 'Différence de points attendue',
      PassesTotalOwnHalf: 'Nombre total de passes effectuées depuis sa propre moitié de terrain',
      PassesOwnHalf: 'Nombre de passes réussies depuis sa propre moitié de terrain',
      PassesTotalOppHalf: 'Nombre total de passes effectuées depuis la moitié adverse',
      ProgressivePassesTotal: 'Nombre total de passages de 10 mètres ou plus sur l\'axe X',
      DuelsWon: 'Duels réussis (Tacles, Aériens, Touches de Ballon, Dribbles et Fautes commises)',
      NonPenaltySaves: 'Arrêts hors tirs de pénalité',
      BadActionsOppHalf: 'Somme de toutes les mauvaises actions commises dans la moitié de terrain adverse',
      CarriesSuccessful: 'Nombre de portées d\'au moins 7 mètres se terminant par une épreuve réussie',
      ShotsOnTargetOutBox: 'Tirs cadrés depuis l\'extérieur de la surface',
      TotalDistance: 'Distance totale que le joueur a parcourue pendant un match',
      WalkingDistance: 'Distance totale parcourue par le joueur lors d\'un match à une vitesse inférieure à 2 m/s (7,2 km/h)',
      JoggingDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse comprise entre 2 m/s (7,2 km/h) et 4 m/s (14,4 km/h)',
      RunningDistance: 'Distance totale parcourue par le joueur pendant un match à une vitesse comprise entre 4 m/s (14,4 km/h) et 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Nombre de fois où le joueur accélère à plus de 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Nombre de courses effectuées à une vitesse comprise entre 14,4 km/h et 19,8 km/h',
      HsrDistance: 'Distance totale à une vitesse >19.8 km/h',
      HsrNumber: 'Nombre de fois où le joueur se déplace à une vitesse >19.8 km/h',
      HsrDistancePct: '% de vitesse >19.8 km/h par rapport à la distance totale parcourue',
      SprintsNumber: 'Sprints Quantity >25.2 km/h',
      SprintsDistance: 'Distance totale à une vitesse >25.2 km/h',
      SprintNumberDeclinePct: '% de la dif. entre le nombre de fois où le joueur se déplace à une vitesse >25,2 km/h en première mi-temps et en seconde mi-temps',
      SprintDistanceDeclinePct: '% de dif. entre la distance totale à une vitesse >25,2 km/h en première mi-temps et en seconde mi-temps',
      SprintNumberDecline: 'Différence entre le nombre de fois où le joueur se déplace à une vitesse >25,2 km/h en première mi-temps et en seconde mi-temps',
      SprintDistanceDecline: 'Différence entre la distance totale à une vitesse >25,2 km/h en première mi-temps et en seconde mi-temps',
      SprintDistancePct: '% de la distance du sprint par rapport à la distance totale',
      Accelerations: 'Nombre de fois où le joueur accélère de plus de 1,5 m/s<sup>2</sup>',
      MaxSpeed: 'Vitesse maximale atteinte par le joueur',
      AvgMaxSpeed: 'Vitesse maximale moyenne atteinte par le joueur',
      MaxAccelerations: 'Accélération maximale en mètres/seconde² atteinte par le joueur',
      BypassedPlayersByPasses: 'Nombre de joueurs du côté du but du porteur du ballon au début de l\'événement de touche, moins le nombre de joueurs du côté du but à la fin de l\'événement',
      BypassedDefendersByPasses: 'Nombre de défenseurs du côté du but du porteur du ballon au début de l\'événement de touche, moins le nombre de défenseurs du côté du but à la fin de l\'événement',
      PassesBypassingPlayers: 'Nombre de passes qui ont dépassé des joueurs',
      PassesBypassingDefenders: 'Nombre de passes qui ont dépassé des défenseurs',
      BypassedPlayersPerPass: 'Nombre total de joueurs dépassés par passe',
      BypassedDefendersPerPass: 'Nombre total de défenseurs dépassés par passe',
      LineBreakingPasses: 'Passes réussies qui avancent le ballon d\'au moins 10% vers le but adverse et traversent un couple de défenseurs en proximité ou passent derrière la ligne défensive',
      LineBreakingPassesMD: 'Passes réussies qui cassent les lignes du milieu et de la défense',
      LineBreakingPassesM: 'Passes réussies qui cassent la ligne du milieu',
      LineBreakingThroughBalls: 'Passes réussies qui cassent la ligne défensive',
      LineBreakingPassesPerPass: 'Nombre de lignes brisées par passe',
      TotalPassesUnderStrongPressure: 'Nombre total de passes effectuées sous forte pression (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      TotalPassesUnderLightPressure: 'Nombre total de passes effectuées sous pression (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      SuccessfulPassesUnderStrongPressure: 'Nombre de passes réussies effectuées sous forte pression (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      SuccessfulPassesUnderLightPressure: 'Nombre de passes réussies effectuées sous pression (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      PassingUnderStrongPressure: 'Pourcentage de passes réussies et totales sous forte pression (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      PassingUnderLightPressure: 'Pourcentage de passes réussies et totales sous pression (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      PassReceiptsInSpaceCompleted: 'Passes effectuées lorsque le receveur est dans le camp adverse sans défenseur dans un rayon de 5 mètres vers le but',
      PassReceiptsInSpace: 'Passes reçues dans le camp adverse sans défenseur dans un rayon de 5 mètres vers le but',
      PassReceiptsInSpaceCompletedFirstThird: 'Passes effectuées où le receveur est dans le premier tiers et n’a aucun défenseur dans un rayon de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedSecondThird: 'Passes effectuées où le receveur est dans le deuxième tiers et n’a aucun défenseur dans un rayon de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedFinalThird: 'Passes effectuées où le receveur est dans le dernier tiers et n’a aucun défenseur dans un rayon de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passes effectuées où le receveur est dans la moitié adverse (côté droit) et n’a aucun défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passes effectuées où le receveur est dans la moitié adverse (zone centrale) et n’a aucun défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passes effectuées où le receveur est dans la moitié adverse (côté gauche) et n’a aucun défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceFirstThird: 'Passes reçues dans le premier tiers sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceSecondThird: 'Passes reçues dans le deuxième tiers sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceFinalThird: 'Passes reçues dans le dernier tiers sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceOppHalfRight: 'Passes reçues dans la moitié adverse (côté droit) sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceOppHalfCenter: 'Passes reçues dans la moitié adverse (zone centrale) sans défenseur à moins de 5 mètres en direction du but',
      PassReceiptsInSpaceOppHalfLeft: 'Passes reçues dans la moitié adverse (côté gauche) sans défenseur à moins de 5 mètres en direction du but',
      TotalStrongOnBallPressures: 'Nombre de fortes pressions sur le porteur du ballon (dans un rayon de 0-2 mètres)',
      TotalLightOnBallPressures: 'Nombre de pressions sur le porteur du ballon (dans un rayon de 2-4 mètres)',
      SuccessfulStrongOnBallPressures: 'Nombre de fortes pressions réussies sur le porteur du ballon (dans un rayon de 0-2 mètres)',
      SuccessfulLightOnBallPressures: 'Nombre de pressions réussies sur le porteur du ballon (dans un rayon de 2-4 mètres)',
      StrongOnBallPressuresPct: 'Pourcentage de fortes pressions réussies et totales sur le porteur du ballon (dans un rayon de 0-2 mètres de l\'adversaire le plus proche)',
      LightOnBallPressuresPct: 'Pourcentage de pressions réussies et totales sur le porteur du ballon (dans un rayon de 2-4 mètres de l\'adversaire le plus proche)',
      TimesBypassedByPasses: 'Nombre total de fois dépassé par une passe',
      TimesBypassedByCarries: 'Nombre total de fois dépassé par une conduite',
      TimesBypassedByActions: 'Nombre total de fois dépassé par des passes et des conduites combinées',
      BypassedPlayersByCarries: 'Nombre total d\'adversaires (défenseurs et milieux) dépassés par des conduites',
      BypassedDefendersByCarries: 'Nombre total d\'adversaires (défenseurs) dépassés par des conduites',
      BypassedPlayersByActions: 'Nombre total d\'adversaires (défenseurs et milieux) dépassés par des passes et des conduites combinées',
      BypassedDefendersByActions: 'Nombre total d\'adversaires (défenseurs) dépassés par des passes et des conduites combinées',
      CarriesBypassingPlayers: 'Nombre de conduites ayant dépassé des joueurs',
      CarriesBypassingDefenders: 'Nombre de conduites ayant dépassé des défenseurs',
      BypassedPlayersPerCarry: 'Moyenne d\'adversaires dépassés par conduite',
      BypassedDefendersPerCarry: 'Moyenne de défenseurs dépassés par conduite',
      LineBreakingCarries: 'Nombre de conduites ayant franchi une ou plusieurs lignes défensives',
      LineBreakingCarriesMD: 'Nombre de conduites ayant franchi les lignes des milieux et défenseurs',
      LineBreakingCarriesM: 'Nombre de conduites ayant franchi la ligne des milieux',
      LineBreakingCarriesD: 'Nombre de conduites ayant franchi la ligne défensive',
      LineBreakingCarriesPerCarry: 'Pourcentage de conduites entre les lignes par conduite',
      LineBreakingActions: 'Nombre de passes et de conduites combinées ayant franchi une ou plusieurs lignes défensives',
      LineBreakingActionsMD: 'Nombre de passes et de conduites combinées ayant franchi les lignes des milieux et défenseurs',
      LineBreakingActionsM: 'Nombre de passes et de conduites combinées ayant franchi la ligne des milieux',
      LineBreakingActionsD: 'Nombre de passes et de conduites combinées ayant franchi la ligne défensive',
      PassesPerLineBreakingPass: 'Ratio entre le nombre total de passes par passe entre les lignes',
      CarriesPerLineBreakingCarry: 'Ratio entre le nombre total de conduites par conduite entre les lignes',
      LinesBrokenByPasses: 'Nombre total de lignes franchies par des passes',
      LinesBrokenByCarries: 'Nombre total de lignes franchies par des conduites',
      LinesBrokenByActions: 'Nombre total de lignes franchies par des passes et des conduites combinées',
      LinesBrokenPerPass: 'Ratio entre le nombre total de lignes franchies par passe',
      LinesBrokenPerCarry: 'Ratio entre le nombre total de lignes franchies par conduite',
      AvgLastDefenderDistanceIP: 'Distance entre le dernier défenseur (le plus proche de son propre but) et la ligne de but en possession',
      AvgLastDefenderDistanceOOP: 'Distance entre le dernier défenseur (le plus proche de son propre but) et la ligne de but sans possession',
      AvgDefensiveLineDistanceIP: 'Distance entre la ligne défensive la plus reculée et le but en possession',
      AvgDefensiveLineDistanceOOP: 'Distance entre la ligne défensive la plus reculée et le but sans possession',
      AvgRBDistanceIP: 'Distance entre le latéral droit et son propre but en possession',
      AvgRBDistanceOOP: 'Distance entre le latéral droit et son propre but sans possession',
      AvgLBDistanceIP: 'Distance entre le latéral gauche et son propre but en possession',
      AvgLBDistanceOOP: 'Distance entre le latéral gauche et son propre but sans possession',
      AvgBlockDistanceIP: 'Distance entre le joueur de champ le plus avancé et le plus reculé en possession',
      AvgBlockDistanceOOP: 'Distance entre le joueur de champ le plus avancé et le plus reculé sans possession',
      AvgBlockAreaIP: 'Surface du rectangle englobant tous les joueurs de champ (mesure de l’espace occupé par l’équipe) en possession',
      AvgBlockAreaOOP: 'Surface du rectangle englobant tous les joueurs de champ (mesure de l’espace occupé par l’équipe) sans possession',
      AvgDefensiveLineWidthOOP: 'Largeur de la ligne la plus reculée (la plus éloignée du but) sans possession',
      AvgOffensiveLineLastThirdWidthIP: 'Largeur horizontale de la ligne offensive dans le dernier tiers en possession',
      AvgLByIP: 'Position du latéral gauche en possession',
      AvgRByIP: 'Position du latéral droit en possession',
      AvgOffensiveLineDistanceIP: 'Distance entre le but et la ligne offensive en possession',
      AvgOffensiveLineLastThirdDistanceIP: 'Distance entre le but et la ligne offensive dans le dernier tiers en possession',
      AvgOffensiveLineWidthIP: 'Largeur horizontale de la ligne offensive en possession',
      OffBallRuns: 'Déplacements sans ballon intentionnels pour soutenir la phase offensive',
      OffBallRunsOverlap: 'Courses où le joueur contourne son coéquipier par l\'extérieur (près de la ligne de touche) pendant que celui-ci a le ballon',
      OffBallRunsUnderlap: 'Courses où le joueur passe à l\'intérieur de son coéquipier, plus proche de l\'axe du terrain',
      OffBallRunsRunAhead: 'Course vers l’avant qui dépasse le porteur du ballon tout en restant devant le dernier défenseur',
      OffBallRunsRunBehind: 'Course vers l’avant qui pénètre la dernière ligne défensive, entre les défenseurs et le gardien',
      OffBallRunsCrossReceiver: 'Un joueur court vers la surface pour se positionner afin de recevoir un centre d’un coéquipier',
      OffBallRunsSupport: 'Le joueur court pour se joindre à la ligne du porteur du ballon, offrant une option de passe proche',
      OffBallRunsComingShort: 'Le joueur se rapproche du porteur du ballon pour offrir un soutien proche ou une option de passe en retrait',
      AerialsOppHalf: 'Aerials au terrain rival',
      CarriesIntoFinalThird: 'Canalisations d\'au moins 7 mètres de l\'extérieur vers l\'intérieur du dernier tiers',
      DribblesAttempted: 'Nombre de dribbles tentés',
      SpeedScore: 'Performance physique du joueur basée sur différentes mesures de vitesse',
      EnduranceScore: 'Performance physique d\'endurance du joueur basée sur différentes mesures',
      GoalsConceded: 'Nombre de buts encaissés',
      HeadedGoals: 'Nombre de buts marqués de la tête',
      SavesInBox: 'Nombre d\'arrêts sur tirs à l\'intérieur de la surface',
      SavesOutBox: 'Nombre d\'arrêts sur des tirs hors des sentiers battus',
      ShotsOnTargetInBoxAgainst: 'Nombre de tirs cadrés depuis l\'intérieur de la surface concédés',
      ShotsOnTargetOutBoxAgainst: 'Nombre de tirs cadrés depuis l\'extérieur de la surface concédés',
      SwitchPlaySuccessful: 'Nombre de passes complétées sur 32 mètres où le déplacement latéral du ballon est supérieur à son déplacement vers le but adverse',
      SwitchPlayTotal: 'Nombre total de tentatives de passes sur 32 mètres où le déplacement latéral du ballon est supérieur à son déplacement vers le but adverse',
      PassesInsideOppHalf: 'Nombre total de passes commençant et se terminant dans la moitié de terrain adverse',
      PassesInsideOppHalfSuccessful: 'Nombre de passes complétées commençant et se terminant dans la moitié de terrain adverse',
      TacklesAttemptedFirstThird: 'Nombre total de plaquages ​​tentés dans le premier tiers du terrain',
      TacklesAttemptedSecondThird: 'Nombre total de plaquages ​​tentés dans le deuxième tiers du terrain',
      TacklesFirstThird: 'Nombre de plaquages ​​réussis réalisés dans le premier tiers du terrain',
      TacklesSecondThird: 'Nombre de plaquages ​​réussis réalisés dans le deuxième tiers du terrain',
      FoulsOwnHalf: 'Nombre de fautes commises dans la moitié de terrain du joueur',
      TouchesOppHalf: 'Nombre de touches de ballon dans la moitié de terrain adverse',
      TacklesAttemptedNotAdjusted: 'Nombre total de plaquages ​​tentés, sans ajustement de possession',
      TacklesSuccessfulNotAdjusted: 'Nombre total de plaquages ​​réussis, sans ajustement de possession',
      AvgTop5MaxSpeed: 'Moyenne des cinq vitesses maximales les plus élevées du joueur',
      LBPReceived: 'Nombre de passes décisives reçues',
      LBPMReceived: 'Nombre de passes reçues qui franchissent la ligne médiane adverse',
      LBPMDReceived: 'Nombre de passes reçues qui traversent à la fois le milieu de terrain adverse et les lignes défensives',
      ThroughBallReceived: 'Nombre de passes reçues qui franchissent la dernière ligne défensive adverse',
      ShortPassesSuccessful: 'Nombre de passes courtes (moins de 12 mètres) réalisées',
      PassingSuccessForwardPct: 'Pourcentage de passes avant réussies',
      PassingSuccessBackwardPct: 'Pourcentage de passes arrière réussies',
      PassingForwardBackwardPct: 'Ratio passes avant/passes arrière',
      LongBallPerPassesPct: 'Pourcentage de balles longues par rapport au total de passes',
      LongBallReceivedOppHalf: 'Nombre de balles longues reçues dans le terrain rival',
      OffensiveActions: 'Actions offensives',
      SuccessfulDribblesPct: 'Dribbles réussis/tentatives de dribble totales effectuées',
      OffensiveTouchesOutBoxPct: '% de touches offensives hors de la surface',
      HsrDistanceIP: 'Distance de sprint >21 km/h en possession',
      HsrDistanceOOP: 'Distance de sprint >21 km/h hors possession',
      JoggingDistanceIP: 'Distance de jogging en possession',
      JoggingDistanceOOP: 'Distance de jogging hors possession',
      RunningDistanceIP: 'Distance de course en possession',
      RunningDistanceOOP: 'Distance de course hors possession',
      SprintsDistanceIP: 'Distance de sprint >24 km/h en possession',
      SprintsDistanceOOP: 'Distance de sprint >24 km/h hors possession',
      WalkingDistanceIP: 'À distance de marche en possession',
      WalkingDistanceOOP: 'À distance de marche hors de possession',
      PossessionRegain: 'Nombre de fois où vous forcez l\'adversaire à perdre la possession',
      HandPassesSuccessful: 'Passes réussies faites avec les mains (gardiens ou remise en jeu sur coup de pied arrêté)',
      HandPassesTotal: 'Nombre total de passes effectuées avec les mains (gardien ou remise en jeu sur coup de pied arrêté)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'UAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'CG',
      SavesInBox: 'SIB',
      SavesOutBox: 'SANGLOT',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      HeadedXG: 'Dirigé xG',
      HeadedSetPieceTooltip: 'Afficher uniquement les joueurs qui ont des têtes sur coups de pied arrêtés',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Aerials au Terrain Rival',
    CarriesIntoFinalThird: 'Conduit jusqu\'au dernier ⅓',
    scoreDifference: 'Différence de score : indique si la performance de ce jeu était supérieure ou inférieure à la moyenne de la saison.',
    SpeedScore: 'Score de puissance de vitesse',
    EnduranceScore: 'Score d\'endurance',
    SwitchPlaySuccessful: 'Changement de lecture réussi',
    SwitchPlayTotal: 'Changer le total de lecture',
    PassesInsideOppHalf: 'Passe à l’intérieur de la moitié Opp',
    PassesInsideOppHalfSuccessful: 'Passe à l\'intérieur de l\'Opp à moitié réussie',
    TacklesAttemptedFirstThird: 'Tacles tentés en premier ⅓',
    TacklesAttemptedSecondThird: 'S\'attaque à une tentative de deuxième ⅓',
    TacklesFirstThird: 'S\'attaque avec succès au premier ⅓',
    TacklesSecondThird: 'S\'attaque avec succès à la deuxième ⅓',
    FoulsOwnHalf: 'Fautes contre la moitié',
    TouchesOppHalf: 'Touche la moitié de l\'adversaire',
    TacklesAttemptedNotAdjusted: 'Tacles tentés non ajustés',
    TacklesSuccessfulNotAdjusted: 'Tacles réussis non ajustés',
    AvgTop5MaxSpeed: 'Vitesse maximale moyenne Top5',
    LBPReceived: 'Passes de rupture de ligne reçues',
    LBPMReceived: 'Passes de rupture de ligne (ligne M) reçues',
    LBPMDReceived: 'Passes de rupture de ligne (ligne MD) reçues',
    ThroughBallReceived: 'Balles traversantes reçues',
    recoveriesRate: 'Taux de récupération',
    turnoversRate: 'Taux de sinistre',
    HeadedShots: 'Coups de tête',
    HeadedXG: 'Dirigé xG',
    HeadedSetPieceTooltip: 'Afficher uniquement les joueurs qui ont des têtes sur coups de pied arrêtés',
    HsrDistanceIP: 'IP à distance THV',
    HsrDistanceOOP: 'TGV Distance POO',
    JoggingDistanceIP: 'IP de distance de jogging',
    JoggingDistanceOOP: 'Distance de jogging POO',
    RunningDistanceIP: 'Distance de course IP',
    RunningDistanceOOP: 'Distance de course POO',
    SprintsDistanceIP: 'Sprints Distance IP',
    SprintsDistanceOOP: 'Sprints Distance POO',
    WalkingDistanceIP: 'IP à distance de marche',
    WalkingDistanceOOP: 'POO à distance de marche',
    PossessionRegain: 'Reprise de possession',
    HandPassesSuccessful: 'Passes manuelles réussies',
    HandPassesTotal: 'Passes manuelles',
    SprintsNumberIP: 'Sprints Quantité IP',
    SprintsNumberOOP: 'Quantité de sprints POO',
    RunningNumberIP: 'IP de quantité courante',
    RunningNumberOOP: 'Quantité courante POO',
    HsrNumberIP: 'THV Quantité IP',
    HsrNumberOOP: 'Quantité HSR POO',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Fiche d\'équipe',
    subtitle: 'Approfondir les caractéristiques et les statistiques de l\'équipe',
    averageAge: 'Âge Moyen',
    transferBalance: 'Bilan des transferts',
    roster: 'Effectif',
    stadium: 'Stade',
    coach: 'Entraîneur',
    transfers: 'Transferts',
    trends: 'Tendances',
    loans: 'Joueurs en prêt',
    loanFrom: 'En Prêt de',
    loanTo: 'En Prêt à',
    latestGames: 'Dernier Matchs',
    latestXGames: '{0} derniers matchs',
    playingFor: 'Joue pour',
    overview: 'Résumé',
    visualization: 'Visualisation',
    location: 'Emplacement',
    outcome: 'Résultat',
    beeswarm: 'Classement',
    parentTeam: 'Première équipe',
    childTeam: 'Ligues de Jeunes',
    preferredFormation: 'Formation Préférée',
    mostFrecuentFormations: 'Formations les plus fréquentes',
    viewType: 'Voir Type',
    overviewTab: {
      axisXTotal: 'Total',
      axisXper90: 'Par 90\'',
      dataPerGameText: 'Data par match',
      season: 'Saison',
      last: 'Dernière',
      current: 'Actuelle',
      TeamStyle: 'Style',
      TeamDefensive: 'Défensive',
      TeamOffensive: 'Offensive',
      TeamCustom1: 'Personnalisé 1',
      TeamCustom2: 'Personnalisé 2',
      TeamCustom3: 'Personnalisé 3',
      TeamCustom4: 'Personnalisé 4',
      coach: 'Entraîneur',
      groups: {
        Goals: {
          name: 'Buts',
          desc: 'Tous les buts avec et sans pénalités ("coups de pied arrêtés" et "en jeu").'
        },
        Assists: {
          name: 'Passes Décisives',
          desc: 'Joueurs avec le plus de passes décisives (en jeu et sur coups de pied arrêtés) cette saison.'
        },
        xG: {
          name: 'Buts Attendus',
          desc: 'Buts attendus en jeu et sur coups de pied arrêtés, classés par ordre décroissant en fonction du total de xG générés.'
        },
        xA: {
          name: 'Passes Décisives Attendus',
          desc: 'Des aides attendues tant sur les coups de pied arrêtés que pendant le jeu.'
        },
        Finishing: {
          name: 'Finition',
          desc: 'Pourcentage de tirs aboutissant à un but.'
        },
        ScoringContribution: {
          name: 'Contribution aux Buts',
          desc: 'Nombre de passes décisives et de buts de l\'équipe.'
        },
        xT: {
          name: 'Danger Attendu',
          desc: 'Danger attendu généré pendant le jeu, les coups de pied arrêtés et les points négatifs.'
        }
      },
      stats: {
        openPlay: 'En Jeu',
        setPiece: 'Coup de Pied',
        negative: 'Négatif',
        npg: 'Buts Sans Penalty',
        goalsPenalty: 'Penalty Buts',
        npgOpenPlay: 'BSP en Jeu',
        npgSetPiece: 'BSP sur Coup de Pied',
        assists: 'Passes Décisives',
        assistsConceded: 'Passes Décisives Encaissées',
        assistsOpenPlay: 'Passes Décisives en Jeu',
        assistsSetPiece: 'Passes Décisives sur Coup de Pied',
        xGOpenPlay: 'xG en Jeu',
        xGSetPiece: 'xG a Coup de Pied',
        xAOpenPlay: 'Passes Décisives Attendus en Jeu',
        xASetPiece: 'Passes Décisives Attendus sur Coup de Pied',
        xAConceded: 'xA Encaissée',
        nonPenaltyShots: 'Tirs Sans penalty',
        penaltyShots: 'Tirs de penalty',
        xT: 'Danger Attendu',
        xTOpenPlay: 'Danger Attendu en Jeu',
        xTSetPiece: 'Danger Attendu sur Coup de Pied',
        xTNeg: 'Danger Attendu Négatif',
        totalFinishing: 'Finition',
        nonPenaltyFinishing: 'Non Penalty Finition',
        goalsPenaltyFinishing: 'Penalty Finition',
        goal: 'But',
        notGoal: 'Pas un objectif',
        chance: 'Chance',
        finished: 'Fini',
        notFinished: 'Pas fini',
        walkingDistance: 'Marche',
        joggingDistance: 'Jogging',
        runningDistance: 'Course',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprints',
        runningNumber: 'Nombre de courses',
        hsrNumber: 'Sprints HSR',
        sprintsNumber: 'Nombre de sprints',
        maxSpeed: 'Vitesse max.',
        accelerations: 'Accélérations',
        extremeAccelerations: 'Accélérations extrêmes',
        maxAcceleration: 'Accélération maximale'
      }
    },
    teamAnalysis: 'Analyse de l\'Équipe',
    agentView: {
      positions: {
        gk: 'GK',
        leftFullback: 'Arrière Gauche',
        centralDefender: 'Défenseur Central',
        rightFullback: 'Arrière Droit',
        midfielder: 'Milieu',
        attackingMidfielder: 'Milieu Offensif',
        leftWinger: 'Ailier Gauche',
        rightWinger: 'Ailier Droit',
        fw: 'FW'
      },
      groups: {
        contractEnd: 'Mois',
        age: 'Âg',
        availability: 'Disponibilité'
      },
      placer: {
        legend: 'Détermination en fonction de l\'âge, du contrat, de la disponibilité et de la performance'
      }
    },
    transfersTab: {
      valueMovements: 'Valeur de la transaction ',
      valueTransfers: 'Valeur de la transaction',
      valueLoans: 'Valeur de Joueurs en Prêt',
      avgAgeMovements: 'Âge moyen des tranferts',
      avgAgeTransfers: 'Âge moyen des tranferts',
      avgAgeLoans: 'Âge moyen des Joueurs en Prêt',
      operations: {
        buys: {
          buy: 'Achat',
          loan: 'En Prêt',
          'end of loan': 'Joueur en Prête jusqu\'a',
          'free transfer': 'Gratuit',
          free: 'Gratuit',
          'loan transfer': 'En Prêt',
          other: 'Other'
        },
        sells: {
          buy: 'Vente',
          loan: 'En Prêt',
          'end of loan': 'Joueur en Prête jusqu\'a',
          'free transfer': 'Gratuit',
          free: 'Gratuit',
          'loan transfer': 'En Prêt',
          other: 'Other',
          retired: 'Retiré'
        }
      }
    },
    trendsTab: {
      streaks: 'Gusts',
      wins: 'Victoires',
      cleanSheets: 'Feuilles Blanche',
      goalPeriods: 'Périodes avec Buts Marqués',
      concededGoalPeriods: 'Périodes avec Buts Concédés',
      comebacks: 'Comebacks',
      avgTime: 'Temps Moyen',
      kindOfGoals: 'Types de Buts',
      percentWinning: '% Victoire',
      percentDrawing: '% Attache',
      percentLosing: '% Perdant',
      totalOf: 'Total de',
      minutes: 'minutes',
      before: 'Avant',
      after: 'Après',
      playedOn: 'Joué sur',
      scored: 'Marqué',
      conceded: 'Concédé',
      ownGoals: 'Buts Propres',
      phasesOfGame: 'Phases de Jeu',
      intensityLabel: 'Intensité de zone',
      intensityByTeam: 'Par Equipe %',
      intensityByLeagueAvg: 'Par Moyenne Ligue %',
      buildup: 'Relance',
      midfieldProgression: 'Progression au milieu',
      attackOpposition: 'Attaque de l’adversaire',
      attackingTransition: 'Transition offensive',
      highPress: 'Pressing haut',
      midBlock: 'Bloc médian',
      lowBlock: 'Bloc bas',
      defensiveTransition: 'Transition défensive',
      draws: 'Match nul',
      losts: 'Défaites',
      chokes: 'Craquements',
      zoneTooltip: 'Détermine les critères utilisés pour le dégradé de couleur de chaque bloc :',
      teamPctTooltip: 'Basé sur le pourcentage du temps total joué par l’équipe dans chaque zone.',
      leagueAvgPctTooltip: 'Compare le pourcentage de l\'équipe à la moyenne de la ligue pour chaque zone.',
      leagueAvgMinsTooltip: 'Applique les mêmes critères de comparaison par rapport à la ligue, mais évalue le temps total en minutes plutôt qu\'en pourcentages.',
      losses: 'Pertes',
      results: 'Résultats',
      kindOfConcededGoals: 'Types de buts encaissés',
      showMinutes: 'Afficher le procès-verbal'
    },
    onOff: 'Activer/Désactiver',
    dragUpToXPlayers: 'Ajoutez jusqu\'à {x} joueurs',
    selectUpToXPlayers: 'Select up to {x} players',
    onOffTab: {
      G90: 'Buts 90',
      GA90: 'Buts Concédés 90',
      diffG90: 'Différence de buts 90',
      XG90: 'xG 90',
      XGA90: 'xG Concédé 90',
      diffXG90: 'xG Différence 90',
      playersOn: 'Combo Activé',
      playersOff: 'Combo Désactivé',
      ground: 'Terrain',
      playersOnThePitch: 'Joueurs sur le terrain',
      playersOffThePitch: 'Joueurs en dehors du terrain',
      attackTitle: 'Attaque',
      attackSubTitle: 'Stats Offensives',
      defenseTitle: 'Défense',
      defenseSubTitle: 'Stats Défensives',
      associationTitle: 'Association',
      associationSubTitle: 'Stats Associatives',
      comboOn: 'Combo Actif',
      comboOff: 'Toute Autre',
      diffGoals90: 'Buts Diff 90',
      goals90: 'B 90',
      goalsAgainst90: 'BC 90',
      xgAgainstPer90: 'xGA 90',
      xgDiffPer90: 'xG Diff 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Tirs Cadrés 90',
      touchesOppBox90: 'Touches Surface Adverse 90',
      shotsOnTargetAgainst90: 'Tira Cadrés Concédés 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Verticalité 90',
      possession: 'Possession %',
      pctPasses: '% Passes',
      pctPassesFinalThird: 'Passes Dernier Tiers %',
      placeholder: 'Commencez par sélectionner une équipe',
      subtitle: 'Optimisez les métriques de l\'équipe en ajoutant ou en retirant des joueurs de la formation'
    },
    terms: {
      short: 'Court Terme',
      mid: 'Moyen Term',
      long: 'Long Terme'
    },
    report: {
      title: 'Rapport d\'équipe',
      selectedPeriod: 'Période Sélectionnée',
      stackedCharts: 'Graphiques Empilés',
      radars: 'Radars',
      generalData: 'Données Générales',
      scoringChances: 'Occasions de Marquer',
      areasReport: 'Rapport des Zones',
      setPieceReport: 'Rapport sur les Phases Arrêtées',
      corners: 'Corners',
      cornersAgainst: 'Corners Contre',
      indirectFreeKicks: 'Coups Francs Indirects',
      indirectFreeKicksAgainst: 'Coups Francs Indirects Contre',
      freeKicks: 'Coups Francs',
      freeKicksAgainst: 'Coups Francs Contre',
      penaltys: 'Pénaltys',
      freeKicksContribution: 'Contribution des Coups Francs',
      shotsContribution: 'Contribution des Tirs',
      topXPlayersByStats: 'Top {x} Joueurs par Statistiques',
      lastShotZone: 'Dernière Zone de Tir',
      throwSide: 'Côté de la Touche',
      kindOfThrow: 'Type de Touche',
      scored: 'Marqué',
      against: 'Contre',
      perGame: 'par Match',
      total: 'Total',
      efficiency: 'Efficacité',
      organizedAttack: 'Attaque Organisée',
      offTransition: 'Transition Offensive',
      chances: 'Occasions',
      chancesScored: 'Occasions Marquées',
      chancesAgainst: 'Occasions Contre',
      goalsScored: 'Buts Marqués',
      goalsAgainst: 'Buts Contre',
      goalsOrganizedAttack: 'Buts Attaque Organisée',
      goalsOffTransition: 'Buts Transition Offensive',
      goalsSetPiece: 'Buts Phase Arrêtée',
      goalsOrganizedAttackScored: 'Buts Att. Org. Marqués',
      goalsOrganizedAttackAgainst: 'Buts Att. Org. Contre',
      goalsOffTransitionScored: 'Buts Trans. Off. Marqués',
      goalsOffTransitionAgainst: 'Buts Trans. Off. Contre',
      goalsSetPieceScored: 'Buts Phase Arrêtée Marqués',
      goalsSetPieceAgainst: 'Buts Phase Arrêtée Contre',
      crossSide: 'Côté du Centre',
      externalShot: 'Tir Extérieur',
      innerPlay: 'Jeu Intérieur',
      throwIn: 'Touche',
      box: 'Surface',
      zone2: 'Zone 2',
      goalsPerPhases: 'Buts par Phases'
    },
    minutesAlert: '*Ne sont affichés que les joueurs ayant joué 450 minutes ou plus',
    minutesException: 'Il n\'y a aucun joueur avec 450 minutes ou plus jouées. Afficher tous les joueurs',
    analysis: 'Analysis',
    substitutions: 'Substitutions',
    attackZones: 'Attack Zones',
    formations: 'Formations',
    shotZones: 'Shot Zones',
    crossings: 'Crossings',
    byTime: 'By Time',
    byPosition: 'By Position',
    byPlayer: 'By Player',
    W: 'Winning',
    D: 'Drawing',
    L: 'Losing',
    substitutionsByGame: 'Substitutions by game',
    substitutionsShort: 'Subs.',
    avgSeasonShort: 'Avg. Season',
    startingAt: 'Starting at',
    endingAt: 'Ending at',
    startingAtInfo: 'Montre la part des possessions basée sur la localisation du premier événement',
    endingAtInfo: 'Montre la part des possessions basée sur la localisation du dernier événement',
    endingWithShot: 'Ending with shot',
    endingInBox: 'Ending in box',
    pfX: 'PF {x}',
    bySide: 'By Side',
    cornerKicks: 'Corner Kicks',
    included: 'Included',
    excluded: 'Excluded',
    onlyCorner: 'Only Corner',
    sizeByMarketValue: 'Size by Market Value',
    timeInTeam: 'Saisons en Équipe',
    newSignings: 'New Signings',
    sizeBy: 'Size by',
    connections: 'Connections',
    assistant: 'Passer',
    finisher: 'Finisher',
    playersMinutesAlert: 'Affichage uniquement des joueurs ayant joué des minutes dans la saison sélectionnée',
    strategyFilterTooltip: 'Afficher les événements survenus lors de coups de pied arrêtés ou lors d\'un jeu ouvert',
    sideFilterTooltip: 'Afficher uniquement les coups de pied arrêtés qui débutent du côté sélectionné (gauche ou droite)',
    teamMinutesAlert: '*Affichant uniquement les équipes ayant joué 450 minutes ou plus',
    homeCoach: 'Entraîneur à domicile',
    awayCoach: 'Entraîneur extérieur'
  },
  leagueTable: {
    subtitle: 'Analyser l\'évolution des ligues'
  },
  leagueMatchdays: {
    byRound: 'Par journée',
    byDate: 'Par date',
    byTeam: 'Par équipe'
  },
  teamStats: {
    subtitle: 'Comparer les performances des équipes',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Difference between Expected Goals and Goals',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Difference between Expected Points and Points',
    games: 'GAM',
    gamesExplicit: 'Games played',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Points per Game'
  },
  roles: {
    ROLE_USER: 'Utilisateur',
    ROLE_ADMIN: 'Administrateur',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Extrayez sans effort des informations sur les joueurs, les équipes, les matchs et les ligues au format JSON.',
    ROLE_EVENTING_DATA_description: 'Plongez au cœur des statistiques avec les diagrammes radar, les classements des joueurs, les cartes et plus encore, basés sur +100 indicateurs de performance.',
    ROLE_PHYSICAL_DATA_description: 'Accédez aux données relatives à la condition physique et filtrez les joueurs en fonction de divers paramètres de performance (distance, vitesse, sprints, accélération...).',
    ROLE_VIDEO_description: 'Fournissez des vidéos et des listes de joueurs et faites en sorte que les matchs soient marqués par des événements et des statistiques pour une analyse approfondie.',
    ROLE_DRIBLAB_HUB_description: 'Suivez et gérez efficacement les tâches de repérage avec des calendriers, des notes, des alertes et le partage de documents.',
    ROLE_TRACKING_description: 'Recevez les données de position de tous les joueurs d\'un match par le biais de notre API pour une analyse complète.',
    ROLE_ARRIGO_description: 'Combine eventing et tracking en métriques innovantes qui vont au-delà du traditionnel et ajoutent de la valeur à chaque action.',
    ROLE_REPORTS_description: 'Demandez des rapports de scouting détaillés à notre équipe d\'analystes pour trouver l\'équipe ou le joueur idéal.',
    ROLE_RAW_EVENTING: 'Concours complet brut'
  },
  administration: {
    pageSubtitle: 'Gérer le fonctionnement de l\'application',
    newClient: 'Nouveau client',
    clientDuplicateName: 'Un client avec ce nom existe déjà. Sélectionnez-le dans la liste et utilisez « Nouvel utilisateur » pour y ajouter des utilisateurs.',
    newUser: 'Nouvel utilisateur',
    editClient: 'Modifier le client',
    editUser: 'Modifier utilisateur',
    clientName: 'Nom',
    permissions: 'Permis',
    releaseUser: 'Libérer l\'utilisateur',
    connectAsUser: 'Connectez-vous comme',
    releaseModalTitle: 'Confirmation de la libération de l\'utilisateur',
    releaseModalMessage: 'L\'utilisateur recevra un courriel vous informant de votre nouveau compte. Êtes-vous sûr d\'avoir été informé ?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Équipe',
      Brand: 'Marque',
      Federation: 'Fédération',
      Media: 'Médias',
      Agency: 'Agences',
      Individual: 'individuel'
    },
    userType: {
      Ownership: 'Propriétaire',
      SportingDirector: 'Directeur sportif',
      Brand: 'Marque',
      Federation: 'Fédération',
      Media: 'Médias',
      Agency: 'Agent',
      Individual: 'Individuel',
      Scout: 'Recruteur',
      Coach: 'Entraîneur',
      supervision: {
        title: 'Hiérarchie de surveillance',
        subtitle: 'La supervision s’effectue uniquement vers le bas. La supervision de même niveau n’est pas autorisée.',
        supervisesLowerLevels: 'Supervise tous les rôles ci-dessous',
        ruleNoSameLevel: 'Les rôles de même niveau ne peuvent pas se superviser.',
        ruleOnlyDownwards: 'La supervision n\'est autorisée que des rôles supérieurs aux rôles inférieurs.',
        ruleLevel3NoSupervision: 'Le niveau le plus bas n\'a aucune autorisation de supervision.',
        currentUserType: 'Votre type d\'utilisateur actuel'
      }
    },
    visibleYears: 'Années Visibles',
    areaModalTitle: 'Confirmation de l\'activation/désactivation des ligues',
    areaModalMessage: 'Etes-vous sûr d\'activer/désactiver toutes les ligues de la zone sélectionnée ?',
    countStats: 'Count Stats',
    userClientModalTitle: 'User already exists in another client',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Contrat',
    contracts: 'Contrats',
    invoiceName: 'Nom de la Facture',
    contractFee: 'Frais de Contrat',
    renewal: 'Renouvellement',
    consultancy: 'Consultance',
    deleteContract: 'Supprimer le Contrat Client',
    deleteContractMessage: 'Le contrat sera définitivement supprimé. Êtes-vous sûr ?',
    activeVsHired: 'Actif vs Recruté',
    requestedVsHired: 'Demandé vs Recruté',
    activeVsHiredWithPlaceholder: '{0} Actif vs {1} Embauché',
    requestedVsHiredWithPlaceholder: '{0} Demandé vs {1} Embauché',
    salesRepresentative: 'Représentant Commercial',
    periodicities: {
      periodicity: 'Périodicité',
      annual: 'Annuel',
      biannual: 'Semestriel',
      quarterly: 'Trimestriel',
      monthly: 'Mensuel',
      bimonthly: 'Bimestriel',
      onePayment: 'Un paiement',
      fourmonthly: 'Tous les quatre mois'
    },
    paymentMethods: {
      payment: 'Paiement',
      method: 'Méthode',
      transfer: 'Virement',
      mandate: 'Mandat'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Publicité sur les Réseaux Sociaux',
      videoWithFeedback: 'Vidéo avec Feedback'
    },
    status: {
      status: 'Statut',
      pending: 'En attente',
      active: 'Actif',
      expiringSoon: 'Expire bientôt',
      expired: 'Expiré',
      expiringSoonWithDays: 'Le contrat expire bientôt : {0} jours restants'
    },
    updates: {
      roleAdded: '<b>{0}</b> a ajouté le rôle <b>{1}</b> à <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> a retiré le rôle <b>{1}</b> de <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> a ajouté <b>{1}</b> à la ligue <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> a retiré <b>{1}</b> de la ligue <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> a ajouté <b>{1}</b> à la saison <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> a retiré <b>{1}</b> de la saison <b>{2}</b>.',
      updateNotesPlaceholder: 'Veuillez inclure un contexte pour le changement ou ajouter des notes pertinentes ici...',
      updates: 'Mises à jour',
      products: 'Produits'
    },
    clients: 'Clientèle',
    trials: 'Essais',
    activeClients: 'Clients actifs',
    activeTrials: 'Essais actifs',
    activeTrialUsers: 'Utilisateurs d\'essai actifs',
    activeContracts: 'Contrats actifs',
    expiration: 'Expiration',
    clientWarnings: {
      activeContractInactiveClient: 'Clients avec des contrats actifs mais aucun utilisateur activé',
      activeContractTrialUsers: 'Clients avec des utilisateurs d\'essai pendant qu\'un contrat est actif',
      activeUsersWithoutContract: 'Clients avec des utilisateurs actifs sans essai mais sans contrat actif',
      upcomingExpirations: 'Expirations à venir',
      renewedContracts: 'Clients sous contrats renouvelés',
      clientsWithWarnings: 'Clients nécessitant une attention',
      enabledUsersWithoutContract: '« Utilisateurs autorisés sans essai sans contrat actif »',
      trialUsersWithContract: 'Utilisateurs en mode essai malgré un contrat actif',
      activeContractInactiveUsers: 'Le client a un contrat actif avec tous les utilisateurs inactifs',
      activeContract: 'Ce client a un contrat actif',
      noEnabledUsers: 'Ce client n\'a aucun utilisateur activé',
      ongoingTrialInactiveUsers: 'Clients avec un essai en cours mais aucun utilisateur activé',
      neverLoggedIn: 'Clients qui ne se sont jamais connectés'
    },
    daysLeft: 'Jours restants',
    expiringSoon: 'Expire bientôt',
    loggedThisWeek: 'Connecté cette semaine',
    withWarnings: 'Avec des avertissements',
    ofActiveClients: 'de clients actifs',
    endingIn30Days: 'se termine dans 30 jours',
    neverLogged: 'jamais connecté',
    ofActiveTrials: 'd\'essais actifs',
    activeClientsWithoutTrial: 'clients actifs (hors essai)',
    renewals: 'Renouvellements',
    ofActiveContracts: 'de contrats actifs'
  },
  dashboards: {
    lastGame: 'Analyse du dernier match',
    lastGameSimple: 'Dernier Match',
    seeAllGameInfo: 'Voir toutes les informations',
    nextGame: 'Prochain match',
    myTeam: 'Mon équipe',
    lastMatchdayGames: 'Les derniers matchs',
    lastAdded: 'Derniers ajouts',
    myFavorites: 'Mes favoris',
    seeAllFavorites: 'Voir tous les favoris',
    placeholderFavorites: 'À partir du profil d\'un joueur, vous pouvez l\'ajouter à vos favoris',
    placeholderTeamFavorites: 'À partir du profil d\'une équipe, vous pouvez l\'ajouter à vos favoris',
    placeholderLeagueFavorites: 'À partir du profil d\'une ligue, vous pouvez l\'ajouter à vos favoris',
    myCollections: 'Mes collections',
    placeholderCollections: 'Vous n\'avez pas de collections créées',
    lastCreated: 'Dernières créations',
    seeAllCollections: 'Voir toutes les collections',
    seeRival: 'Voir rival',
    seeMyTeam: 'Voir mon équipe',
    title: 'Panneau de contrôle',
    subtitle: 'Bienvenue',
    recentPlayers: 'Joueurs récents',
    lastScouted: 'Dernières recherches',
    scout: 'Recruteur',
    reportsRequested: 'Rapports',
    lastRequested: 'Dernières commandes',
    goInbox: 'Aller à la boîte de réception',
    placeholderLastScouted: 'Vous pouvez rechercher des joueurs dans la barre de recherche sur la gauche ou dans l\'outil de scouting',
    placeholderReports: 'Vous pouvez demander des rapports à partir du profil d\'un joueur',
    nationalPlayers: 'Les meilleurs joueurs des équipes nationales dans d\'autres pays',
    lastGames: 'Derniers matchs',
    nationalPlayersShort: 'Joueurs des équipes nationales dans d\'autres pays',
    nextMatchdayGames: 'Prochains matchs',
    injuredPlayers: 'Joueurs blessés',
    atPresent: 'Actuellement',
    seeAllPlayers: 'Voir tous',
    suspendedPlayers: 'Joueurs suspendus',
    placeholderInjured: 'Aucun joueur blessé',
    teamValueImpacted: 'Valeur de l\'équipe impactée',
    placeholderSuspended: 'Aucun jouer suspendu',
    placeholderNextGame: 'Pas de match disponible',
    placeholderNoGames: 'Pas de matchs disponibles',
    placeholderLastMatchDayNotFound: 'les derniers matchs ne sont pas disponibles',
    placeholderNextMatchDayNotFound: 'les prochaines matchs ne sont pas disponibles',
    usersMostSearch: 'Les utilisateurs qui recherchent le plus',
    lastTwoDays: 'Deux derniers jours',
    searchesHistory: 'Historique de la recherche',
    dayByDay: 'Au quotidien',
    activeUsersTitle: 'Utilisateurs actifs',
    activeUsersSubtitle: 'Se sont connectés au cours du dernier mois',
    onlineUsersTitle: 'Utilisateurs connectés',
    onlineUsersSubtitle: 'Ils ont cherché au cours de la dernière heure',
    searchesPerformed: 'Recherches effectuées',
    onlyClients: 'Clients uniquement',
    activeClientsTitle: 'Clients actifs',
    activeClientsSubtitle: 'Au moins un utilisateur actif',
    last24Hours: 'Les dernières 24 heures',
    activityHistory: 'Activity History',
    loginHistory: 'Historique d\'accès',
    failLogins: 'Accès refusé',
    successLogins: 'succès de la connexion',
    clientStats: 'Statistiques des Clients',
    playersMostSearch: 'Joueurs avec le plus de recherches',
    toolsMoreUsed: 'Outils plus utilisés',
    hotPlayers: 'Joueurs les plus recherchés',
    last_month: 'Le Mois Dernier',
    last_week: 'La Semaine Dernière',
    last_day: 'Dernier jour',
    nClients: 'Nombre de clients',
    userDashboard: 'Tableau de bord de l\'utilisateur',
    userDashboardSubtitle: 'Résumé de l\'activité du compte',
    offlineDaysOfClient: 'Jours hors ligne pour chaque client',
    hideNoConnected: 'Masquer les non connectés',
    onlyTrial: 'Uniquement les clients d\'essai',
    daysWithoutLogin: 'Jours sans connexion',
    trialDays: 'Jours d\'essai'
  },
  faq: {
    subtitle: 'Qu\'est-ce que Driblab PRO?',
    categories: {
      playerMetrics: 'Métriques de Joueur',
      teamMetrics: 'Métriques D\'équipe',
      positions: 'Position D\'équipe',
      tools: 'Outils',
      api: 'API',
      videos: 'Tutorials',
      playerPositions: 'Positions des Joueurs',
      userTypes: 'Types d\'utilisateurs'
    },
    positions: {
      GK: 'Gardien de but',
      DR: 'Arrière Droit',
      DC: 'Défenseur Central',
      DL: 'Arrière Gauche',
      DMR: 'Piston Droit',
      DMC: 'Milieu Défensif',
      DML: 'Piston Gauche',
      MR: 'Milieu Droit',
      MC: 'Milieu Central',
      ML: 'Milieu Gauche',
      AMR: 'Milieu Offensif Droit',
      AMC: 'Milieu Offensif',
      AML: 'Milieu Offensif Gauche',
      FWR: 'Ailier Droit',
      FW: 'Avant-Centre',
      FWL: 'Ailier Gauche'
    },
    metrics: {
      categories: {
        Association: 'Association',
        Saving: 'Arrêts',
        Shooting: 'Finition',
        Defending: 'Défense',
        Passing: 'Passes',
        BallHandling: 'Contrôle',
        Aerial: 'Aériens',
        Physical: 'Physiques',
        Predictive: 'Prédictif',
        Arrigo: 'Arrigo',
        Score: 'Score',
        Turnovers: 'Pertes',
        Carries: 'Portées',
        SequenceInvolvement: 'Implication dans la séquence',
        Crosses: 'Centres',
        Distance: 'Distance',
        Sprint: 'Sprint',
        Acceleration: 'Accélération',
        MaxAcceleration: 'Accélération maximale',
        Speed: 'Vitesse',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Passes de Rupture de Lignes',
        LineBreakingCarries: 'Portées de Rupture de Lignes',
        LineBreakingActions: 'Actions de Rupture de Lignes',
        PassUnderPressure: 'Passe sous Pression',
        BallReceived: 'Ballon Reçu',
        PassesUnderPressure: 'Passe Sous Pression',
        OnBallPressureReceived: 'Pression sur le Porteur Reçu',
        OnBallPressure: 'Pression sur le Porteur',
        BallReceiptsInSpace: 'Réceptions de Ballon en Espace',
        SpatialCoverage: 'Contrôle du Terrain',
        OffBallPressure: 'Pression Hors du Ballon',
        OffBallRuns: 'Appels Sans Ballon',
        NoCategory: 'Autres',
        subcategories: {
          Quality: 'Qualité',
          Quantity: 'Quantité',
          TeamComparison: 'Comparaison d\'équipes',
          Receptions: 'Réceptions',
          LongBalls: 'Longs ballons',
          Efficiency: 'Efficacité',
          Ratio: 'Ratio',
          Defensive: 'Défensif',
          Offensive: 'Offensif',
          Foot: 'Pied',
          Progression: 'Progression',
          TopValue: 'Valeur maximale',
          Predictive: 'Prédictif',
          Distance: 'Distance',
          Aerial: 'Aériens',
          Crosses: 'Centres',
          NoCategory: 'Autres'
        },
        desc: {
          Association: 'Association',
          Saving: 'Arrêts',
          Shooting: 'Finition',
          Defending: 'Défense',
          Passing: 'Passes',
          BallHandling: 'Contrôle',
          Aerial: 'Aériens',
          Physical: 'Physiques',
          Predictive: 'Prédictif',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Pertes',
          Carries: 'Portées',
          SequenceInvolvement: 'Implication dans la séquence',
          Crosses: 'Centres',
          Distance: 'Distance parcourue à différentes vitesses',
          Sprint: 'Courses à différentes vitesses',
          Acceleration: 'Accélération',
          Speed: 'Vitesse',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Passes de Rupture de Lignes',
          LineBreakingCarries: 'Portées de Rupture de Lignes',
          LineBreakingActions: 'Actions de Rupture de Lignes',
          PassUnderPressure: 'Passe sous Pression',
          BallReceived: 'Ballon Reçu',
          OnBallPressureReceived: 'Pression sur le Porteur Reçu',
          OnBallPressure: 'Pression sur le Porteur',
          BallReceiptsInSpace: 'Réceptions de Ballon en Espace',
          SpatialCoverage: 'Contrôle du Terrain',
          OffBallPressure: 'Pression Hors du Ballon',
          OffBallRuns: 'Appels Sans Ballon',
          HandPassing: 'Passes faites avec la main par les gardiens ou remise en jeu sur coup de pied arrêté'
        },
        abbr: {
          Association: 'Association',
          Saving: 'Arrêts',
          Shooting: 'Finition',
          Defending: 'Défense',
          Passing: 'Passes',
          BallHandling: 'Contrôle',
          Aerial: 'Aériens',
          Physical: 'Physique',
          Predictive: 'Prédictif',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'PRT',
          Carries: 'Portées',
          SequenceInvolvement: 'Implication dans la séquence',
          Crosses: 'Centres',
          Distance: 'Distance',
          Sprint: 'Sprint',
          Acceleration: 'Accélération',
          MaxAcceleration: 'Accélération maximale',
          Speed: 'Vitesse',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Passes de Rupture de Lignes',
          LineBreakingCarries: 'Portées de Rupture de Lignes',
          LineBreakingActions: 'Actions de Rupture de Lignes',
          PassUnderPressure: 'Passe sous Pression',
          BallReceived: 'Ballon Reçu',
          OnBallPressureReceived: 'Pression sur le Porteur Reçu',
          OnBallPressure: 'Pression sur le Porteur',
          BallReceiptsInSpace: 'Réceptions de Ballon en Espace',
          SpatialCoverage: 'Contrôle du Terrain',
          OffBallPressure: 'Pression Hors du Ballon',
          OffBallRuns: 'Appels Sans Ballon',
          HandPassing: 'Passage à la main'
        },
        HandPassing: 'Passage à la main'
      },
      types: {
        1: 'Par 90',
        2: 'Pourcentage',
        3: 'Ratio',
        4: 'Efficacité',
        5: 'Moyenne',
        6: 'Par Match',
        7: 'Différence',
        8: 'Max'
      },
      moreInfo: 'Vous pouvez en lire plus ici'
    },
    api: {
      subtitle: 'Obtenir des donnése à partir de différentes requètes',
      resourcesTitle: 'Ressources',
      authentication: 'Authentification',
      authText: 'Afin d\'obtenir l\'API, vous devez inclure dans chaque requête l\'en-tête `Authorization` avec la valeur `Bearer {API_TOKEN}`',
      generate: 'Générer',
      tokenPlaceholder: 'Si vous n\'avez pas de jeton ou si celui-ci a expiré, cliquez sur \'Générer\'',
      pathParameters: 'Paramètres de la voie',
      queryParameters: 'Paramètres de la Requête',
      responseModel: 'Modèle de réponse',
      tokenWarning: '* Générer un jeton afin d\'utiliser l\'API',
      pathParamsWarning: '* Il y a des paramètres non remplis',
      genericDescription: 'Une API (Interface de Programmation d\'Applications) permet aux développeurs d\'accéder à des données ou de les intégrer dans leurs propres applications. Notre API de statistiques de football offre un accès complet à une variété de données sur les pays, compétitions, équipes, joueurs, matchs et plus encore. En utilisant cette API, vous pouvez créer des applications exploitant nos riches données footballistiques pour des analyses, des visualisations ou d\'autres solutions innovantes.',
      methods: {
        getAllCountries: 'Cette méthode récupère une liste complète de tous les pays disponibles dans l\'API, fournissant des détails clés tels que l\'identifiant unique et le nom de chaque pays. Ce point de terminaison est idéal pour les applications nécessitant des données géographiques sur le football, permettant des fonctionnalités comme la sélection de pays, le filtrage et l\'analyse. Il sert également de ressource fondamentale pour interagir avec d\'autres points de terminaison qui dépendent d\'un paramètre `countryId`, assurant une navigation et une intégration fluides avec l\'ensemble de données de l\'API.',
        getCountryDetail: 'Cette méthode fournit des informations détaillées sur un pays spécifique disponible dans l\'API. En utilisant ce point de terminaison, vous pouvez récupérer des données telles que le nom du pays, son code et des métadonnées associées. Cette méthode est particulièrement utile pour les applications nécessitant des détails spécifiques au pays pour améliorer l\'expérience utilisateur, comme afficher des informations contextuelles ou créer des analyses personnalisées basées sur des données géographiques. Elle complète d\'autres points de terminaison en permettant une exploration approfondie d\'un pays sélectionné.',
        getCountryCompetitions: 'Cette méthode récupère une liste de toutes les compétitions disponibles dans un pays spécifique. C\'est une ressource précieuse pour construire des fonctionnalités permettant aux utilisateurs d\'explorer les compétitions par région, offrant une manière fluide de connecter les données des pays à leurs tournois associés. Ce point de terminaison est essentiel pour les applications axées sur le contenu footballistique localisé ou les analyses régionales.',
        getAllCompetitionTypes: 'Cette méthode retourne une liste de tous les types de compétitions disponibles dans l\'API, comme les ligues, les coupes et les tournois internationaux. Ce point de terminaison est idéal pour catégoriser les compétitions et offrir aux utilisateurs une vue organisée des différents types d\'événements couverts. Il est particulièrement utile pour construire des fonctionnalités comme des filtres ou des menus déroulants permettant aux utilisateurs d\'explorer les données footballistiques en fonction de la nature de la compétition.',
        getAllCompetitions: 'Cette méthode récupère une liste complète de toutes les compétitions disponibles dans l\'API, quel que soit le type ou l\'emplacement. Ce point de terminaison est utile pour les applications qui doivent afficher ou analyser une large gamme de compétitions footballistiques, permettant aux utilisateurs d\'explorer et de sélectionner des événements d\'intérêt.',
        getCompetitionAvailable: 'Cette méthode récupère une liste des compétitions actuellement marquées comme disponibles dans l\'API. Cela garantit que les données retournées sont à jour et prêtes à être utilisées dans les applications. Elle est particulièrement utile pour les développeurs construisant des fonctionnalités reposant sur des compétitions actives ou accessibles, permettant aux utilisateurs d\'explorer des événements pertinents sans rencontrer de données obsolètes ou incomplètes.',
        getCompetitionDetail: 'Cette méthode fournit des informations détaillées sur une compétition spécifique disponible dans l\'API. Elle est particulièrement utile pour les applications nécessitant des informations approfondies sur une compétition, permettant des fonctionnalités comme des vues détaillées, des analyses contextuelles ou des options de filtrage basées sur les caractéristiques de la compétition.',
        getCompetitionSeasons: 'Cette méthode récupère une liste de toutes les saisons associées à une compétition spécifique. Ce point de terminaison est essentiel pour les applications cherchant à offrir une couverture complète de l\'histoire ou de l\'état actuel d\'une compétition, permettant aux utilisateurs d\'explorer les données saison par saison.',
        getSeasonAvailable: 'Cette méthode fournit une liste des saisons actuellement marquées comme disponibles dans l\'API. Elle est particulièrement utile pour les applications qui se concentrent sur des événements de football en direct ou en cours, permettant aux utilisateurs d\'interagir avec les données des saisons pertinentes et actuelles.',
        getSeasonDetail: 'Cette méthode récupère des informations détaillées sur une saison spécifique, y compris sa chronologie, la compétition associée et les métadonnées clés. Ce point de terminaison est essentiel pour les applications nécessitant des perspectives approfondies sur une saison particulière, permettant des fonctionnalités comme des aperçus de saison, le filtrage par compétition ou l\'affichage de chronologies détaillées pour l\'interaction utilisateur.',
        getSeasonTeams: 'Cette méthode fournit une liste de toutes les équipes participant à une saison spécifique. Elle est idéale pour des fonctionnalités comme la gestion des effectifs, l\'analyse des performances des équipes ou la création de filtres spécifiques à la saison pour les utilisateurs.',
        getSeasonPlayer: 'Cette méthode récupère une liste de tous les joueurs inscrits dans une saison spécifique. Elle est idéale pour développer des fonctionnalités telles que les effectifs des joueurs, le suivi des performances ou le filtrage des joueurs en fonction de la saison sélectionnée.',
        getSeasonPlayerStats: 'Cette méthode fournit des statistiques détaillées pour tous les joueurs d\'une saison spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse, les comparaisons entre joueurs ou la création de visualisations dynamiques des performances des joueurs tout au long de la saison.',
        getSeasonArrigoMetrics: 'Cette méthode fournit des statistiques combinées pour tous les joueurs d\'une saison donnée. Elle est particulièrement utile pour les applications axées sur l\'analyse, la comparaison des joueurs ou la création de visualisations dynamiques des performances des joueurs sur une saison.',
        getSeasonTeamStats: 'Cette méthode fournit des statistiques complètes pour toutes les équipes participant à une saison spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse des équipes, les résumés de saison ou les comparaisons des performances des équipes tout au long de la saison.',
        getSeasonCoaches: 'Cette méthode récupère une liste de tous les entraîneurs ayant dirigé des équipes pendant une saison spécifique. Elle est particulièrement utile pour les applications qui se concentrent sur les perspectives de saison, l\'analyse des entraîneurs ou le suivi des changements dans la gestion des équipes au cours d\'une saison.',
        getSeasonGames: 'Cette méthode fournit une liste de tous les matchs joués dans une saison spécifique. Elle est idéale pour les applications qui doivent afficher les calendriers de saison complète, analyser les résultats des matchs ou fournir aux utilisateurs un accès complet aux données des matchs de la saison.',
        getSeasonGamesMatchday: 'Cette méthode récupère tous les matchs d\'une journée de match spécifique dans une saison donnée. Elle est particulièrement utile pour les applications qui visent à afficher les calendriers des journées de match, analyser des tours spécifiques ou fournir des perspectives ciblées sur un ensemble particulier de matchs pendant la saison.',
        getSeasonLeagueTable: 'Cette méthode fournit le classement de la ligue pour une saison spécifique, y compris les classements, les points, les victoires, les matchs nuls, les défaites et d\'autres statistiques pertinentes pour chaque équipe. Ce point de terminaison est essentiel pour les applications axées sur le suivi des classements des équipes, l\'analyse de la progression de la ligue ou la présentation d\'un classement mis à jour tout au long de la saison.',
        getTeamDetail: 'Cette méthode fournit des informations détaillées sur une équipe spécifique, y compris son nom, son année de fondation, son stade et d\'autres métadonnées. Ce point de terminaison est idéal pour les applications nécessitant des perspectives spécifiques à une équipe, permettant des fonctionnalités comme des profils d\'équipe détaillés, un contexte historique ou des expériences utilisateur enrichies avec des données riches liées aux équipes.',
        getTeamLoans: 'Cette méthode récupère des informations sur les transactions de prêt impliquant une équipe spécifique. Ce point de terminaison est particulièrement utile pour les applications axées sur l\'analyse des transferts, la gestion des effectifs d\'équipe ou le suivi des mouvements de joueurs pendant une saison.',
        getTeamRoster: 'Cette méthode fournit une liste complète des joueurs dans l\'effectif d\'une équipe spécifique. Elle est idéale pour les applications qui doivent afficher les compositions d\'équipe, analyser les rôles des joueurs ou gérer les fonctionnalités liées aux effectifs d\'une équipe.',
        getTeamGames: 'Cette méthode récupère une liste de tous les matchs joués par une équipe spécifique. Elle est particulièrement utile pour les applications qui se concentrent sur la performance de l\'équipe, le suivi des calendriers ou la fourniture d\'un accès complet à l\'historique des matchs d\'une équipe.',
        getTeamGameStats: 'Cette méthode fournit des statistiques détaillées pour une équipe spécifique dans un match donné. Elle est particulièrement utile pour les applications axées sur les analyses de match, les évaluations de performance ou les analyses approfondies des performances d\'une équipe dans des matchs individuels.',
        getTeamTransfers: 'Cette méthode récupère des informations sur les transactions de transfert impliquant une équipe spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse du marché des transferts, les changements dans les effectifs des équipes ou le suivi des mouvements des joueurs au fil du temps.',
        getGameStatus: 'Cette méthode fournit une liste de tous les statuts possibles de match disponibles dans l\'API, tels que programmé, en cours, terminé, reporté ou annulé. Ce point de terminaison est particulièrement utile pour les applications nécessitant un suivi en temps réel des matchs, le filtrage des matchs par statut ou la fourniture d\'informations claires sur l\'avancement ou l\'état d\'un match.',
        getPlayerPositions: 'Cette méthode renvoie une liste de toutes les positions possibles des joueurs, telles que gardien de but, défenseur, milieu de terrain et attaquant. Ce point de terminaison est particulièrement utile pour les applications qui classent les joueurs, analysent les données de positionnement ou permettent aux utilisateurs de filtrer les joueurs en fonction de leurs rôles sur le terrain.',
        getGameDetail: 'Cette méthode fournit des informations complètes sur un match spécifique, y compris des détails tels que les équipes participantes, la date et l\'heure, le lieu, le score et d\'autres métadonnées clés. Ce point de terminaison est idéal pour les applications nécessitant des analyses approfondies des matchs, permettant des fonctionnalités comme des aperçus détaillés, des rapports ou des analyses.',
        getGameStats: 'Cette méthode fournit des statistiques détaillées pour un match spécifique, y compris des métriques telles que les buts, les tirs, les pourcentages de possession, les passes et les actions défensives. Ce point de terminaison est particulièrement utile pour les applications axées sur l\'analyse des matchs, les rapports post-match ou les visualisations des performances des équipes pendant un match.',
        getGamePlayerStats: 'Cette méthode récupère des statistiques détaillées de performance pour tous les joueurs ayant participé à un match spécifique. Elle est particulièrement utile pour les applications qui analysent les performances individuelles des joueurs, génèrent des rapports de match ou comparent les joueurs dans le cadre d\'un même match.',
        getGamePlayerPhysicalStats: 'Cette méthode fournit des métriques détaillées de performance physique pour les joueurs lors d\'un match spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse de la condition physique des joueurs, le suivi des performances physiques ou la génération d\'analyses détaillées pour des joueurs individuels.',
        getGameTeamPhysicalStats: 'Cette méthode fournit des métriques détaillées sur la performance physique des équipes lors d\'un match spécifique. Cela inclut des données telles que la distance totale parcourue, le nombre de sprints, les courses à haute intensité et d\'autres attributs physiques. Elle est particulièrement utile pour les applications axées sur l\'analyse de la condition physique des équipes, la comparaison des efforts physiques entre équipes ou l\'évaluation des performances globales lors d\'un match.',
        getGamePlayerArrigoMetrics: 'Cette méthode fournit des métriques Arrigo détaillées pour les joueurs d\'un match spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse et la génération d\'informations détaillées sur les joueurs d\'un match. ',
        getGameTeamArrigoMetrics: 'Cette méthode fournit des statistiques détaillées sur l\'équipe Arrigo lors d\'un match spécifique. Cela inclut des données telles que les joueurs battus et d\'autres attributs. Elle est particulièrement utile pour les applications axées sur l\'analyse des performances globales d\'un match.',
        getGameLineup: 'Cette méthode récupère la composition des équipes pour un match spécifique, y compris les joueurs titulaires, les remplaçants et leurs positions respectives. Ce point de terminaison est particulièrement utile pour les applications affichant des informations avant-match, analysant les formations d\'équipe ou fournissant des perspectives sur les décisions tactiques prises par les équipes pour un match donné.',
        getGameTimeline: 'Cette méthode fournit une liste chronologique des événements survenus pendant un match spécifique. Elle est particulièrement utile pour les applications offrant des mises à jour en direct des matchs, des résumés post-match ou des analyses détaillées des événements du match.',
        getGameTracking: 'Cette méthode fournit un lien pour télécharger le fichier de données de suivi pour un match spécifique. Ce fichier contient des données détaillées sur les mouvements et les positions des joueurs et du ballon tout au long du match. Elle est particulièrement utile pour les applications axées sur les analyses avancées, l\'analyse tactique ou la création de visualisations des mouvements des joueurs et du ballon pendant le match.',
        getTrackingStatus: 'Cette méthode renvoie une liste complète de tous les états disponibles dans le suivi, fournissant des détails clés tels que l\'identifiant unique et le nom de chaque état. Ce point de terminaison est idéal pour les applications qui nécessitent un suivi des correspondances, permettant des fonctionnalités telles que la sélection d\'état, le filtrage et l\'analyse. Il sert également de ressource essentielle pour interagir avec d\'autres points de terminaison qui dépendent d\'un paramètre « statusId », garantissant une navigation et une intégration transparentes avec l\'ensemble de données plus large de l\'API.',
        getPlayerTransfersTypes: 'Cette méthode récupère une liste des types possibles de transferts de joueurs, tels que transfert permanent, prêt, transfert libre ou échange. Ce point de terminaison est particulièrement utile pour les applications qui analysent les tendances du marché des transferts, classent les mouvements de joueurs ou fournissent aux utilisateurs des informations détaillées sur les types de transactions impliquant les joueurs.',
        getPlayerDetail: 'Cette méthode fournit des informations détaillées sur un joueur spécifique, y compris des détails personnels, des statistiques de carrière et son affiliation actuelle à une équipe. Ce point de terminaison est idéal pour les applications offrant des profils de joueurs, des perspectives historiques ou des analyses des performances individuelles et des trajectoires de carrière des joueurs.',
        getPlayerGames: 'Cette méthode récupère une liste de tous les matchs auxquels un joueur spécifique a participé. Elle est particulièrement utile pour les applications axées sur le suivi des performances des joueurs, l\'analyse de l\'historique des matchs ou la fourniture aux utilisateurs de journaux complets des matchs des joueurs.',
        getPlayerInjuries: 'Cette méthode fournit un enregistrement détaillé des blessures subies par un joueur spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse de la santé des joueurs, les évaluations de l\'impact sur leur carrière ou le suivi des délais de récupération.',
        getPlayerNationalTeam: 'Cette méthode récupère des informations détaillées sur la participation d\'un joueur aux matchs de l\'équipe nationale. Elle est particulièrement utile pour les applications axées sur les performances des joueurs au niveau national, le suivi des carrières internationales ou la fourniture de perspectives sur leurs contributions lors des tournois et des matchs amicaux.',
        getPlayerSeasons: 'Cette méthode fournit une liste de toutes les saisons auxquelles un joueur spécifique a participé. Elle est particulièrement utile pour les applications qui suivent la progression de la carrière d\'un joueur, analysent ses performances au fil des saisons ou fournissent un contexte historique sur ses réalisations.',
        getPlayerTransfers: 'Cette méthode récupère un historique détaillé des transactions de transfert impliquant un joueur spécifique. Elle est particulièrement utile pour les applications axées sur l\'analyse de la carrière des joueurs, les informations sur le marché des transferts ou le suivi des mouvements des joueurs entre les équipes au fil du temps.',
        getPlayerSeasonTeamStats: 'Cette méthode fournit des statistiques détaillées de performance pour un joueur spécifique pendant une saison particulière avec une équipe. Elle est particulièrement utile pour les applications axées sur l\'analyse des joueurs sur une saison, les comparaisons entre les équipes ou les saisons et le suivi des contributions individuelles au succès de l\'équipe.',
        getPlayerSeasonPhysicalStats: 'Cette méthode fournit des métriques détaillées de performance physique pour un joueur spécifique tout au long d\'une saison. Elle est particulièrement utile pour les applications axées sur le suivi de la condition physique des joueurs, l\'analyse des performances physiques ou l\'évaluation de la charge de travail d\'un joueur pendant une saison.',
        getPlayerSeasonGamePhysicalStats: 'Cette méthode fournit des métriques détaillées de performance physique pour un joueur spécifique sur une base match par match au cours d\'une saison. Elle est particulièrement utile pour les applications axées sur l\'analyse de la condition physique spécifique aux matchs, le suivi de la charge de travail des joueurs ou la comparaison des performances physiques entre différents matchs.',
        getPlayerSeasonGameStats: 'Cette méthode récupère des statistiques détaillées de performance pour un joueur spécifique sur une base match par match au cours d\'une saison. Elle est particulièrement utile pour les applications axées sur l\'analyse spécifique des joueurs pour un match, les tendances de performance ou les comparaisons détaillées entre les matchs d\'une saison.',
        getCoachDetail: 'Cette méthode fournit des informations détaillées sur un entraîneur spécifique, y compris son nom, son historique de carrière, les équipes qu\'il a dirigées et ses réalisations notables. Ce point de terminaison est particulièrement utile pour les applications qui mettent en avant les profils d\'entraîneurs, suivent les carrières managériales ou analysent l\'impact des entraîneurs sur les performances des équipes.',
        getCoachHistory: 'Cette méthode récupère un historique complet de la carrière d\'un entraîneur spécifique, y compris les équipes qu\'il a dirigées, les compétitions auxquelles il a participé et les durées de ses mandats. Ce point de terminaison est particulièrement utile pour les applications axées sur l\'analyse des carrières des entraîneurs, le suivi des changements managériaux ou la fourniture de perspectives sur le parcours professionnel et les réalisations d\'un entraîneur.',
        getGameEventing: 'Cette méthode fournit tous les événements',
        getLinkStream: 'Cette méthode récupère le lien pour regarder la vidéo du jeu',
        getLinkDownload: 'Cette méthode récupère le lien pour télécharger la vidéo du jeu',
        getGameTs: 'Cette méthode fournit le dernier horodatage d\'une correspondance spécifique',
        getGameFileTypes: 'Cette méthode fournit les types de fichiers pour la correspondance',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Cette méthode renvoie une liste de positions générales possibles, telles que gardien de but, défenseur, milieu de terrain et attaquant.',
        getPercentiles: 'Cette méthode fournit tous les percentiles disponibles',
        getPlayerPercentilesEventing: 'Cette méthode fournit toutes les statistiques pour un centile et une position spécifiques'
      },
      responseCodes: 'Codes de Réponse',
      furtherInformation: 'For further information, please read our API documentation',
      clipboard: 'Copié dans le presse-papiers!',
      limit50: 'Afficher uniquement les 50 premiers résultats'
    }
  },
  globalSearch: {
    subtitle: 'Filtrage intensif'
  },
  global: {
    teamElos: {
      title: 'ELO d’équipe',
      subtitle: 'Classements et analyses globales des équipes',
      team: 'Équipe',
      teams: 'Équipes',
      dates: 'Dates',
      excludeInternational: 'Exclure les équipes internationales',
      elo: 'ELO',
      selectButton: 'Sélectionnez Haut',
      selectTeamFromTable: 'Sélectionnez une équipe dans le tableau pour afficher la tendance ELO.',
      showingTeamAveragesLastSeason: 'Affichage des moyennes d\'équipe pour la dernière saison',
      showingTeamStatsLastSeason: 'Affichage uniquement des statistiques d\'équipe pour leur dernière saison active',
      searchToolTip: 'Astuce : Appuyez sur Ctrl + B pour accéder directement à la barre de recherche',
      selectTopTooltip: 'Afficher des équipes supplémentaires dans le graphique à des fins de comparaison',
      loadingPage: 'Préparation des données...'
    },
    leagueElos: {
      title: 'LEAGUE ELO\'S',
      subtitle: 'Classements de ligues globaux et analyses',
      rankings: 'CLASSEMENTS',
      insights: 'ANALYSES',
      filters: 'FILTRES',
      leagues: 'Ligues',
      from: 'De',
      to: 'À',
      elo: 'ELO',
      change: 'Changement',
      league: 'Ligue',
      excludeContinental: 'Exclure les compétitions internationales',
      eloTrend: 'Tendance ELO',
      eloRanking: 'Classement ELO',
      currentELOLabel: '(ELO actuel)',
      allTime: 'Tout le temps',
      average: 'Moyenne',
      noChartData: 'Aucune donnée disponible pour les filtres sélectionnés.',
      selectLeagueFromTable: 'Sélectionnez une ligue dans le tableau pour afficher la tendance ELO.',
      noInsightsData: 'Aucune donnée d\'analyses disponible pour les ligues sélectionnées. Veuillez vous assurer que les ligues ont des saisons disponibles et des données d\'analyses des équipes.',
      showingLeagueAveragesLastSeason: 'Affichage uniquement des moyennes de ligue pour leur dernière saison active',
      selectTopTooltip: 'Afficher des ligues supplémentaires dans le tableau à des fins de comparaison',
      confederations: {
        world: 'World',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Nombre de ligues',
      minimumElo: 'ELO minimum'
    },
    players: {
      title: 'GPI du joueur',
      subtitle: 'Classements et informations mondiaux des joueurs',
      gpiRanking: 'Classement GPI',
      rankTooltip: 'Survolez pour afficher le classement mondial',
      globalRanking: 'Classement mondial',
      player: 'Joueur',
      players: 'Joueurs',
      gpiTrend: 'Tendance GPI',
      currentGPILabel: '(GPI actuel)',
      nationality: 'Pays de naissance',
      position: 'Position',
      marketValue: 'Valeur marchande',
      apply: 'Appliquer',
      marketValueAndAgeTooltip: 'Entrez une plage et cliquez sur Appliquer ou appuyez sur Entrée.',
      searchPlaceholder: 'Rechercher un joueur...',
      selectTopTooltip: 'Afficher des joueurs supplémentaires dans le tableau à des fins de comparaison',
      gpi: 'GPI',
      numberOfPlayers: 'Nombre de joueurs',
      showingPlayerStatsLastSeason: 'Afficher uniquement les statistiques moyennes des joueurs pour leur dernière saison active',
      date: 'DATE',
      showChartLabels: 'Afficher les étiquettes',
      marketValueTooltip: 'Entrez une plage et cliquez sur Appliquer ou appuyez sur Entrée.',
      freeAgents: 'Agents libres',
      selectPlayerFromTable: 'Sélectionnez un joueur dans le tableau pour afficher la tendance GPI.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algérie',
    AO: 'Angola',
    AR: 'Argentine',
    AU: 'Australie',
    AZ: 'Azerbaïdjan',
    BH: 'Bahreïn',
    BB: 'Barbade',
    BE: 'Bélgique',
    BJ: 'Bénin',
    BO: 'Bolivie',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodge',
    CA: 'Canada',
    CF: 'République centrafricaine',
    CL: 'Chili',
    CO: 'Colombie',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Côte de Ivoire',
    CU: 'Cuba',
    CZ: 'Czechia',
    DJ: 'Djibouti',
    DO: 'République Dominicaine',
    EC: 'Équateur',
    SV: 'El Salvador',
    ER: 'Érythrée',
    ET: 'Éthiopie',
    FI: 'Finlande',
    PF: 'Polynésie Française',
    GM: 'Gambie',
    DE: 'Allemagne',
    GI: 'Gibraltar',
    GL: 'Groenland',
    GP: 'Guadalupe',
    GN: 'Guinea',
    GY: 'Guyane',
    HN: 'Honduras',
    HU: 'Hongrie',
    IN: 'Inde',
    IR: 'Irán',
    IE: 'Irlande',
    IT: 'Italie',
    JP: 'Japon',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Corée du Sud',
    KG: 'Kirghizistan',
    LV: 'Lettonie',
    LS: 'Lesotho',
    LY: 'Libye',
    LT: 'Lituanie',
    MO: 'RAS de Macao',
    MG: 'Madagascar',
    MY: 'Malaisie',
    ML: 'Mali',
    MH: 'Îles Marshall',
    MR: 'Mauritanie',
    MX: 'Mexique',
    MD: 'Moldavie',
    MN: 'Mongolie',
    MA: 'Maroc',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Pays-Bas',
    NZ: 'Nouvelle-Zélande',
    NE: 'Nigeria',
    MP: 'Îles Mariannes',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Rumanie',
    RW: 'Rwanda',
    LC: 'Sainte-Lucie',
    SM: 'Saint-Marin',
    SA: 'Arabie Saoudite',
    RS: 'Serbie',
    SL: 'Sierra Leone',
    SK: 'Slovaquie',
    SB: 'Îles Salomon',
    ZA: 'Afrique du Sud',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Esuatini',
    CH: 'Suisse',
    TW: 'Taiwan',
    TZ: 'Tanzanie',
    TG: 'Togo',
    TT: 'Trinité-et-Tobago',
    TR: 'Turquie',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'Royaume-Uni',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Îles Vierges Britanniques',
    EH: 'Sahara occidental',
    ZM: 'Zambie',
    AL: 'Albanie',
    AD: 'Andorre',
    AG: 'Antigua et Barbuda',
    AM: 'Arménie',
    AT: 'Autriche',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhoutan',
    BA: 'Bosnie y Herzégovine',
    BR: 'Brésil',
    BG: 'Bulgarie',
    BI: 'Burundi',
    CM: 'Cameroun',
    CV: 'Cap-Vert',
    TD: 'Tchad',
    CN: 'Chine',
    KM: 'Comores',
    CR: 'Costa Rica',
    HR: 'Croatie',
    CY: 'Chypre',
    DK: 'Danemark',
    DM: 'Dominique',
    TL: 'Timor de l\'Est',
    EG: 'Egypte',
    GQ: 'Guinée Équatoriale',
    EE: 'Estonie',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Géorgie',
    GH: 'Ghana',
    GR: 'Grèce',
    GD: 'Grenade',
    GT: 'Guatemala',
    GW: 'Ghinea-Bissau',
    HT: 'Haïti',
    HK: 'Hong Kong SAR',
    IS: 'Islande',
    ID: 'Indonésie',
    IQ: 'Irak',
    IL: 'Israël',
    JM: 'Jamaïque',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Corée du Nord',
    KW: 'Koweït',
    LA: 'Laos',
    LB: 'Liban',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxemburg',
    MK: 'Macédoine',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malte',
    MQ: 'Martinique',
    MU: 'Mauritius',
    FM: 'Micronésie',
    MC: 'Mónaco',
    ME: 'Monténégro',
    MZ: 'Mozambique',
    NA: 'Namibiar',
    NP: 'Népal',
    NC: 'Nouvelle Calédonie',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norvège',
    PK: 'Pakistan',
    PS: 'Territoires Palestiniens',
    PG: 'Papouasie-Nouvelle-Guinée',
    PE: 'Pérou',
    PL: 'Pologne',
    PR: 'Porto Rico',
    RE: 'Réunion',
    RU: 'Fédération de Russie',
    KN: 'Saint-Kitts-et-Nevis',
    WS: 'Samoa',
    ST: 'Sao Tomé et Principe',
    SN: 'Sénégal',
    SC: 'Seychelles',
    SG: 'Singapour',
    SI: 'Slovénie',
    SO: 'Somalie',
    ES: 'Espagne',
    VC: 'San Vicent y las Granadines',
    SR: 'Suriname',
    SE: 'Suède',
    SY: 'Syrie',
    TJ: 'Tadjikistan',
    TH: 'Thaïlande',
    TO: 'Tonga',
    TN: 'Tunisie',
    TM: 'Turkménistan',
    UG: 'Ouganda',
    AE: 'Émirats Arabes Unis',
    US: 'États-Unis',
    UZ: 'Ouzbékistan',
    VA: 'Cité du Vatican',
    VN: 'Vietnam',
    VI: 'Îles Vierges Américaines',
    YE: 'Yémen',
    ZW: 'Zimbabwe',
    EU: 'Europe',
    INT: 'International',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'Angleterre',
    'GB-WLS': 'Pays de Galles',
    'GB-SCT': 'Ecosse',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Saint-Martin'
  },
  loadingMessages: {
    players: 'Préparation des joueurs',
    teams: 'Rassemblement des équipes',
    games: 'Récupération des matchs',
    stats: 'Calcul des métriques',
    graphs: 'Traçage des graphiques',
    gettingReady: 'préparation du système',
    placeholder: 'Chargement'
  },
  requestReport: {
    subtitle: 'Recevez un rapport détaillé avec ce dont vous avez besoin',
    categories: {
      scouting: {
        title: 'Recruitement',
        subtitle: 'Qui sont les meilleurs joueurs dans une ligue et dans plusieurs ligues ? Faites une demande personnalisée, avec les filtres que vous jugez appropriés (âge, taille, fin de contrat) et découvrez les joueurs qui vous conviennent le mieux.'
      },
      coaches: {
        title: 'entraîneurs',
        subtitle: 'Comment un entraîneur joue-t-il et comment son style et son jeu conviennent-ils à votre club ? Obtenez des informations détaillées ou, grâce à un profil, découvrez quels sont les entraîneurs qui répondent à vos besoins.'
      },
      'team analysis': {
        title: 'Analyse de l\'équipe',
        subtitle: 'Obtenez un rapport détaillé sur une équipe: style, performances défensives et offensives, faiblesses, meilleurs joueurs, etc...'
      },
      'game analysis': {
        title: 'Analyse du jeu',
        subtitle: 'Obtenir une analyse pré/post match avec des informations détaillées'
      },
      'special projects': {
        title: 'Projets Spéciaux',
        subtitle: 'Comment un joueur se comporte-t-il à l\'extérieur ? Comment les joueurs passent-ils d\'une ligue à l\'autre ? Quels sont les joueurs que nous pourrions trouver pour un prêt? Posez toutes les questions auxquelles vous pensez.'
      },
      conversation: {
        title: 'Conversation',
        subtitle: 'Commencez une conversation avec notre équipe'
      }
    },
    notesPlaceholder: 'Indiquez le championnat, le profil, l\'entraîneur, l\'équipe ou le match sur lequel vous souhaitez obtenir des informations.',
    chooseType: 'Sélectionnez un type de rapport',
    requestSummary: 'Résumé de la demande',
    reportType: 'Type de rapport',
    reportLanguage: 'Langue du rapport',
    detailTitle: 'Suivi du rapport',
    detailSubtitle: 'Toutes les informations sur le rapport demandé'
  },
  bugReport: {
    modalSubtitle: 'Aidez-nous à améliorer',
    about: 'À propos de',
    sendSuccess: 'Envoyé avec succès. Vérifiez les mises à jour dans la boîte de réception',
    bugs: 'Erreurs'
  },
  gbe: {
    autopass: 'Auto Pass',
    bandX: 'Bande {0}',
    bandXCont: 'Bande {0} Concours Continental',
    points: 'Points',
    titleWinner: 'Vainqueur du Titre',
    qualifiedGroupsBandX: 'Qualifié pour la phase de groupe d\'une Compétition Continentale de bande {0}',
    qualifiedQualifiersBandX: 'Qualifié pour les qualifications d\'une bande {0} Concours Continental',
    midTable: 'Milieu de table',
    relegation: 'Rélegation',
    promotion: 'Promotion',
    final: 'Finale',
    semifinal: 'Demi-Finale',
    quarterfinal: 'Quarts de Finale',
    round16: 'Huitième de Finale',
    round32: '32e Tour',
    groupstage: 'Phase de Groupe',
    firstRound: '1st Round',
    secondRound: '2nd Round',
    thirdRound: '3rd Round',
    fourthRound: '4th Round',
    preliminaryRound: 'Preliminary Round',
    other: 'Autre',
    score: 'Score',
    totalSummary: 'Résumé Total',
    currentlyPlayingInUK: 'Le joueur est un citoyen du Royaume-Uni ou de l\'Irlande, ou le joueur est un résident permanent au Royaume-Uni',
    bandsAlert: 'Il y a des minutes jouées dans plus d\'un bande, le total est la valeur maximale',
    bandsAlertMax: 'Il y a des minutes jouées dans plus d\'un bande, le total est la valeur maximale',
    bandsAlertAvg: 'Il y a des minutes jouées dans plus d\'un bande, le total est la valeur moyenne',
    generate: 'Formulaire de demande GBE',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: 'Apparitions internationales du joueur',
      title1: 'Classement mondial FIFA agrégé de l\'association nationale du joueur',
      title2: 'Apparitions Internationales du Joueur'
    },
    table2: {
      name: 'Minutes Nationales du joueur',
      title1: 'Minutes Nationales du joueur'
    },
    table3: {
      name: 'Minutes Continentales du joueur',
      title1: 'Minutes Continentales du joueur'
    },
    table4: {
      name: 'Classement en championnat du dernier club du joueur',
      title1: 'Classement en championnat du dernier club du joueur'
    },
    table5: {
      name: 'Progression continentale du dernier club du joueur',
      title1: 'Progression continentale'
    },
    table6: {
      name: 'Qualité de la ligue du club actuel du joueur',
      title1: 'Bande du club actuel du joueur'
    },
    table7: {
      name: 'Jeunesse - Début',
      title1: 'Bande'
    },
    table8: {
      name: 'Jeunesse - classement final dans la ligue',
      title1: 'Classement du dernier club en championnat'
    },
    table9: {
      name: 'Jeunesse - Continental Progression',
      title1: 'Progression continentale'
    },
    table10: {
      name: 'Jeunesse - Qualité de la ligue de l\'équipe actuelle du joueur',
      title1: 'Bande de l\'équipe actuelle du joueur'
    },
    table11: {
      name: 'Youth - Qualité de la ligue de l\'équipe actuelle du joueur',
      title1: 'Bande de l\'équipe actuelle du joueur'
    },
    table12: {
      name: 'Youth - Apparitions Internationales',
      title1: 'Apparitions Internationales du joueur'
    }
  },
  mediaMode: {
    borderColor: 'Couleur de la bordure',
    fillColor: 'Couleur de remplissage',
    bgColor: 'Couleur du fond',
    upperText: 'Texte supérieur',
    lowerText: 'Texte inférieur',
    socialMedia: 'Médias sociaux',
    textColor: 'Couleur du texte',
    axisColor: 'Couleur des axes',
    logo: 'Logo',
    comparisonBorderColor: 'Comparaison couleur des bordures',
    comparisonFillColor: 'Comparaison coeleur de remplissage',
    comparisonUpperText: 'Comparaison texte supérieur',
    comparisonLowerText: 'Comparaison texte inférieur',
    homeFillColor: 'Couleur de remplissage de l\'équipe locale',
    homeBorderColor: 'Couleur de la bordure de l\'équipe locale',
    awayFillColor: 'Couleur de remplissage de l\'équipe extérieure',
    awayBorderColor: 'Couleur de la bordure de l\'équipe extérieure',
    face: 'Face',
    nationalTeam: 'Sélection',
    comparisonFace: 'Comparison Face',
    upperTextX: 'Texte supérieur {0}',
    lowerTextX: 'Texte inférieur {0}',
    borderColorX: 'Couleur de la bordure {0}',
    fillColorX: 'Couleur de remplissage {0}',
    homeFillColorX: 'Couleur de remplissage (Domicile) {0}',
    homeBorderColorX: 'Couleur de la bordure (Domicile) {0}',
    awayFillColorX: 'Couleur de remplissage (Extérieur) {0}',
    awayBorderColorX: 'Couleur de la bordure (Extérieur) {0}',
    faceX: 'Face {0}',
    selectField: 'Sélectionnez une propriété',
    orientationX: 'Orientation {0}',
    searchBarPlaceholder: 'Recherche de joueurs et/ou de matchs...',
    title: 'Panneau de bord des médias',
    pageSubtitle: 'Consulter et télécharger des cartes et des graphiques',
    chooseChart: 'Choisir la carte...',
    headerTextX: 'Texte de l\'en-tête {0}',
    avatarLineLength: 'Longueur de ligne de l\'avatar',
    avatarLineWeight: 'Poids de la ligne d\'Avatar',
    avatarSize: 'Taille de l\'avatar',
    chartX: 'Carte {0}',
    chartHeaderFontSize: 'taille de la police de l\'en-tête du carte',
    chartHeaderFontWeight: 'poids de la police de l\'en-tête du carte',
    upperTextFontSize: 'Taille de la police du texte supérieur',
    upperTextFontWeight: 'Poids de la police du texte supérieur',
    lowerTextFontSize: 'Taille de la police du texte inférieur',
    lowerTextFontWeight: 'Poids de la police du texte inférieur',
    socialMediaFontSize: 'Taille de la police des médias sociaux',
    socialMediaFontWeight: 'Poids de la police des médias sociaux',
    subtitle: 'Sous-titres',
    subtitleFontSize: 'Taille de la police des sous-titres',
    subtitleFontWeight: 'Poids de la police des sous-titres',
    subtitleX: 'Sous-titres {0}',
    subtitleFontSizeX: 'Sous-titre ${0} Taille de la police',
    subtitleFontWeightX: 'Subtitle ${0} Poids de la police',
    titleX: 'Titre {0}',
    titleFontSize: 'Titre Taille de la police',
    titleFontWeight: 'Titre Police Poids',
    sponsor: 'Sponsor',
    fontFamily: 'Font family'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Rapports de Scouting',
      GAME_REPORT: 'Rapports de match',
      MEDICAL_REPORT: 'Rapports médicaux',
      PHYSICAL_REPORT: 'Rapports physiques',
      PSYCHOLOGICAL_REPORT: 'Rapports psychologiques',
      OTHER: 'Autres',
      QUICK_NOTES: 'Notes rapides',
      PLAYER_REPORT: 'Rapports des joueurs',
      GENERAL_COMMENTS: 'Commentaires généraux',
      PLAYER_ANALYSIS: 'Analyse des joueurs'
    },
    uploadDocument: 'Télécharger le document',
    notesPlaceholder: 'Tapez des notes descriptives ou des commentaires relatifs au document',
    notesPlaceholderAlt: 'Tapez des notes descriptives ou des commentaires relatifs au joueur',
    uploadedBy: 'Téléchargé par',
    updatedBy: 'Mis à jour par',
    seeNotes: 'Voir les notes',
    addNote: 'Ajouter une note',
    rating: 'Rating',
    position: 'Meilleure position',
    physical: 'Physical',
    onBall: 'On Ball',
    offBall: 'Off Ball',
    mental: 'Mental',
    potential: 'Potential',
    conclusion: 'Conclusion',
    recommendation: {
      1: 'Signer',
      2: 'Surveiller',
      3: 'Écarter',
      4: 'Intéressant',
      label: 'Recommandation'
    },
    match: 'Match',
    deleteQuickNote: 'Supprimer la note',
    deleteQuickNoteMessage: 'La note sera supprimée définitivement. Êtes-vous sûr?',
    noQuickNotes: 'Aucune donnée. Commencez par ajouter des notes!',
    deleteDocument: 'Supprimer le document',
    deleteDocumentMessage: 'Le document sera supprimé définitivement. Êtes-vous sûr?',
    noDocuments: 'Aucune donnée. Commencez par ajouter des documents!'
  },
  notifications: {
    newReportMessage: 'Il y a un nouveau message dans un rapport'
  },
  blog: {
    subtitle: 'Derniers articles, mises à jour et nouvelles',
    newEntry: 'Nouvelle entrée',
    title: 'Titre',
    text: 'Texte',
    link: 'Lien',
    image: 'Image',
    author: 'Auteur',
    date: 'RDate de sortie',
    deleteEntry: 'Supprimer l\'entrée',
    deleteEntryMessage: 'Êtes-vous sûr de vouloir supprimer cette entrée?',
    readMore: 'Lire la suite'
  },
  positionsOrlegi: {
    GK: 'Gardien',
    DC: 'Défenseur',
    DR: 'Arrière',
    MC: 'Milieu',
    AMC: 'Milieu offensif',
    FW: 'Avant-centre',
    FWR: 'Ailier'
  },
  library: {
    subtitle: 'Visualiser et partager des documents mis à jour',
    mediaSubtitle: 'Visualiser et partager les graphiques exportés',
    charts: 'Cartes',
    goToLibrary: 'Aller à la bibliothèque'
  },
  scatterPlot: {
    bubbleSize: 'Taille de la bulle',
    byMinutes: 'Par minutes',
    byAge: 'Par Âge',
    byMarketValue: 'Par valeur marchande'
  },
  eventChart: {
    successfulEvent: 'Réussi',
    unsuccessfulEvent: 'Infructueux',
    possessionLost: 'Réussite non récupéré',
    successfulPass: 'Passe réussie',
    unsuccessfulPass: 'Passe ratée',
    successfulCarry: 'Conduite réussie',
    unsuccessfulCarry: 'Conduite non réussie',
    carryAndKeyPass: 'Conduite & passe-clé',
    carryAndAssist: 'Conduit & Passe décisive',
    carryAndShot: 'Conduit & Tir',
    ballProgressionAndPass: 'Prog. du ballon et passe',
    ballProgression: 'Progression du ballon',
    ballProgressionAndKeyPass: 'Prog. du ballon et passe clé',
    ballProgressionAndAssist: 'Prog. du ballon et passe décisive',
    ballProgressionAndShot: 'Prog. du ballon et tir',
    ballProgressionAndGoal: 'Prog. du ballon et but',
    pass: 'Passe',
    carryAndPass: 'Conduit & Passe',
    carryAndGoal: 'Conduit & But',
    totalTouches: 'Touches totales',
    totalPasses: 'Passes Totales',
    successful: 'Réussi',
    unsuccessful: 'Raté',
    tacklePossessionLost: 'Réussite – Possession perdue',
    gamesSelected: '{count} matchs sélectionnés',
    allGamesOfSeason: 'Tous les matchs de la saison',
    allGamesOfSeasons: 'Tous les matchs des saisons',
    allEvents: 'Tous les événements',
    eventTypesCount: '{count} types d\'événements',
    totalEvents: 'Total des événements',
    zoneDominanceNote: 'Les touches montrées par chaque équipe dans chaque zone représentent uniquement les touches réussies',
    selectedEvents: 'Événements sélectionnés'
  },
  event: {
    Pass: 'Passe',
    TakeOn: 'Drible',
    Takeon: 'Drible',
    Foul: 'Faute',
    Error: 'Erreur',
    Tackle: 'Tacle',
    Interception: 'Interception',
    Clearance: 'Dégagement',
    MissedShot: 'Tir Raté',
    ShotOnPost: 'Tir au Barre',
    SavedShot: 'Tir Arrête',
    Goal: 'But',
    Aerial: 'Duel Aériens',
    BallRecovery: 'Récupération de la Balle',
    Dispossessed: 'Dépossédé',
    ChanceMissed: 'Occasion Manquée',
    BallTouch: 'Toucher du Ballon',
    BlockedPass: 'Passe Bloquée',
    Challenge: 'Challenge',
    lossPossession: 'Perte de la possession',
    OffsidePass: 'Passe en position de hors-jeu',
    groundDuelsLost: 'Duels au sol perdus',
    'Ball touch': 'Touche de balle',
    Smother: 'Étouffer',
    'Keeper pickup': 'Ramassage du gardien',
    'Good skill': 'bonne aptitude',
    Punch: 'Punch',
    'Saved shot': 'Tir sauvé',
    'Shot on post': 'Tir sur le poteau',
    'Missed shot': 'Tir ratée',
    Save: 'Arrêt',
    'Take on': 'Prende en charge',
    'Offside pass': 'Passe hors jeu',
    Claim: 'Attraper',
    'Blocked pass': 'Passe Bloquée',
    KeeperPickup: 'Ramassage du gardien',
    'Ball recovery': 'Récupération de la Balle',
    'Ball Recovery': 'Récupération de la Balle',
    'Chance missed': 'Occasion Manquée',
    'Loss possession': 'Perte de la possession',
    Carries: 'Conduite',
    BallProgression: 'Progression de la balle',
    MissedChance: 'Occasion manquée',
    Event: 'Événement',
    Shot: 'Tir',
    Assist: 'Passe décisive',
    KeyPass: 'Passe Clé',
    'Foul taken': 'Faute reçue'
  },
  leagueTab: {
    leagueTable: 'League Table',
    matchdays: 'Matchdays',
    playerInsights: 'Player Insights',
    onlyLocalPlayers: 'Joueurs locaux uniquement',
    teamInsights: 'Team Insights',
    head2head: 'Head To Head',
    addNewChart: 'Add new chart',
    rounds: {
      16: 'Round of 16',
      32: 'Round of 32',
      W: 'Winner',
      F: 'Final',
      SF: 'Semi-Finals',
      QF: 'Quarter-Finals',
      GR: 'Group Stage',
      '4R': 'Fourth Round',
      '3R': 'Third Round',
      '2R': 'Second Round',
      '1R': 'First Round',
      PR: 'Preliminary Round',
      QPO1: 'Make Round of 32 Tier Below',
      QPO2: 'Qualifier Round of 16',
      QPO3: 'huitièmes de finale de qualification'
    },
    positions: 'Positions',
    prediction: 'Predictions',
    predicted: 'Prédiction',
    groups: 'Groups',
    ranking: 'Ranking',
    numberOfTeams: 'Nombre d\'équipes',
    statsWithMinimum: {
      message: 'Affichage uniquement des joueurs avec plus de {0} {1} sur la saison sélectionnée',
      dribblesTotal90: 'dribbles par 90 minutes',
      crosses90: 'centres par 90 minutes',
      tacklesAttempted90: 'tacles tentés par 90 minutes',
      aerialsTotal90: 'duels aériens par 90 minutes'
    },
    numberOfLeagues: 'Nombre de ligues',
    position: {
      titleWinner: 'Gagnant du titre',
      championsLeague: 'Ligue des Champions',
      qualifierChampionsLeague: 'Qualification Ligue des Champions',
      europeLeague: 'Ligue européenne',
      qualifierEuropeLeague: 'Qualification Ligue Europe',
      conferenceLeague: 'Ligue de conférence',
      qualifierConferenceLeague: 'Ligue de conférence de qualification',
      midTable: 'Milieu de table',
      relegation: 'Relégation',
      promotion: 'Promotion',
      relegationPlayoff: 'Barrage de relégation',
      promotionPlayoff: 'Barrages de promotion',
      championshipGroup: 'Groupe de championnat',
      relegationGroup: 'Groupe de relégation',
      championshipPlayoffs: 'Playoffs du championnat',
      preChampionshipPlayoffs2: 'Playoffs pré-championnat 2',
      preChampionshipPlayoffs3: 'Playoffs pré-championnat 3',
      playoffsQualifierBand3: 'Groupe 3 de qualification pour les séries éliminatoires',
      continentalGroup: 'Groupe Continental'
    },
    group: {
      1: 'UN',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'je',
      10: 'J.',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Find similar players',
    searchBarPlaceholder: 'Search and select a player to find similar',
    radarFilters: 'Radar filters',
    similarityFilters: 'Similarity filters',
    playersFilters: 'Players filters',
    similarPlayers: 'Similar Players',
    seasonWarning: 'Seules les saisons disponibles dans l’outil Similarity où au moins 450 minutes ont été jouées sont affichées'
  },
  squadBuilder: {
    subtitle: 'Sketch your unique elevens',
    playerSelector: 'Player selector',
    loadSquad: 'Load squad',
    yearsOld: 'yo.',
    playersPerPosition: 'Players per position',
    custom: 'Custom',
    removeSquad: 'Supprimer l\'équipe',
    removeSquadMessage: 'Êtes-vous sûr de vouloir supprimer l\'équipe ?',
    deleteSquadSuccess: 'L\'équipe a été supprimée avec succès',
    playerDetails: 'Visibilité des détails',
    ageFormat: 'Format de l\'âge',
    mainPlayer: 'Joueur principal',
    showDetails: 'Afficher les détails',
    all: 'Tous',
    squadPosition: 'Position dans l\'effectif',
    noData: 'Aucune donnée. Commencez en ajoutant quelques joueurs sur le terrain!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Ne vous montrez plus',
      skipTour: 'Sauter la visite guidée',
      previous: 'Précédent',
      next: 'Suivant',
      finish: 'Terminer'
    },
    playerRadar: {
      step1: {
        title: 'FICHIER PERSONNEL',
        message: 'Vérifier les données de base du joueur âge, taille ou date de contrat'
      },
      step2: {
        title: 'GBE FILTER',
        message: 'Fonctionnalité permettant de savoir si un joueur a suffisamment de points GBE pour jouer au Royaume-Uni'
      },
      step3: {
        title: 'DISPONIBILITÉ',
        message: 'Pourcentage de minutes disponibles et pourcentage de minutes jouées'
      },
      step4: {
        title: 'POSITIONS',
        message: 'Découvrez à quels postes le joueur a joué et combien de minutes il a joué à chaque poste'
      },
      step5: {
        title: 'FORMATS D\'AFFICHAGE',
        message: 'Mesurer la performance avec 4 visualisations différentes, Radar, Polar, Lollipop et Text, pour la comparer avec les joueurs de sa position'
      },
      step6: {
        title: 'RADAR DE PERFORMANCE',
        message: 'Ici, la performance est reflétée visuellement. Le panneau est interactif, vous pouvez survoler chaque mesure et obtenir sa définition'
      },
      step7: {
        title: 'SÉLECTION DE LA SAISON',
        message: 'Sélectionnez ou ajoutez des saisons pour mesurer votre performance'
      },
      step8: {
        title: 'SÉLECTION D\'UN MODÈLE PERSONNALISÉ',
        message: ' Utilisez les modèles personnalisés que vous avez créés pour mesurer le joueur avec des métriques différentes de celles du radar standard '
      },
      step9: {
        title: 'SÉLECTION DES POSITIONS JOUÉES',
        message: 'Cochez et décochez les différentes positions pour le mesurer dans la position dans laquelle vous voulez le mesurer'
      },
      step10: {
        title: 'SÉLECTION DES MINIMA ET MAXIMA',
        message: 'Mesurer le joueur avec les hauts et les bas de sa saison, des cinq meilleures ligues ou de la saison propre et par défaut du compte utilisateur'
      },
      step11: {
        title: 'COMPARISONS',
        message: 'Compare le joueur avec ses performances précédentes, avec les autres joueurs de sa position, avec la moyenne de la position'
      },
      step12: {
        title: 'FORMATS DE TÉLÉCHARGEMENT DES IMAGES',
        message: 'Trois formats de téléchargement sont disponibles png, svg et embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SAISON, EFFECTIF ET POSITION',
        message: 'Sélectionnez la saison, l\'effectif et le poste avec lesquels vous souhaitez comparer le joueur'
      },
      step2: {
        title: 'FILTRES DE BASE',
        message: 'Filtrer les joueurs par âge, minutes jouées ou taille'
      },
      step3: {
        title: 'METTRE EN ÉVIDENCE ET EXCLURE',
        message: 'Mettez en surbrillance les joueurs que vous voulez et excluez les équipes de l\'affichage'
      },
      step4: {
        title: 'FILTER BY CATEGORY',
        message: 'Filtrer les statistiques par catégorie Association, Défense, Passe, Maniement de balle, etc'
      },
      step5: {
        title: 'FORMATS DE TÉLÉCHARGEMENT DES IMAGES',
        message: 'Trois formats de téléchargement sont disponibles png, svg et embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'SÉLECTIONNER L\'AFFICHAGE',
        message: 'Vous pouvez voir la carte d\'arrivée en vue principale, en vue des objectifs et dans un tableau de distribution'
      },
      step2: {
        title: 'SELECT SEASONS',
        message: 'Ajoutez des saisons pour mesurer votre efficacité au tir'
      },
      step3: {
        title: 'SHOOTING LOCATION',
        message: 'Sélectionnez la possibilité de voir l\'emplacement exact du tir (cercles) ou par zones de la boîte et du terrain (cases)'
      },
      step4: {
        title: 'xG ON TARGET',
        message: 'Cochez les cases xG to Goal et xG Completion pour voir quelle valeur ajoutée le joueur a apporté après le tir'
      },
      step5: {
        title: 'SHOT TYPE',
        message: 'Filtrer par type de cliché, stratégie, zone ou partie du corps'
      },
      step6: {
        title: 'FILTER MINUTES',
        message: 'Barre des minutes pour sélectionner les tirs et les buts marqués par des périodes de jeu spécifiques'
      },
      step7: {
        title: 'FORMATS DE TÉLÉCHARGEMENT DES IMAGES',
        message: 'Trois formats de téléchargement sont disponibles png, svg et embed'
      },
      step8: {
        title: 'CARTE DES PRISES DE VUE',
        message: 'La carte est interactive. Cochez chaque cercle avec la souris pour connaître le xG de chaque tir'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SÉLECTION DE SAISON',
        message: 'Ajoutez des saisons pour mesurer votre efficacité au tir'
      },
      step2: {
        title: 'EMPLACEMENT DE LA PASSE CLÉ',
        message: 'Sélectionnez la possibilité d\'afficher l\'emplacement exact de la passe clé (cercle) ou par zones de la zone et du terrain (zones)'
      },
      step3: {
        title: 'TYPE DE FINITION APRÈS LA PASSE CLÉ',
        message: 'Filtre par type de tir, stratégie, zone ou partie du corps effectué après la passe clé'
      },
      step4: {
        title: 'FILTRE MINUTES',
        message: 'Barre des minutes pour sélectionner les tirs et les buts marqués par des périodes de jeu spécifiques'
      },
      step5: {
        title: 'FORMATS DE TÉLÉCHARGEMENT DES IMAGES',
        message: 'Trois formats de téléchargement sont disponibles png, svg et embed'
      },
      step6: {
        title: 'CARTE DES PASSES CLÉS',
        message: 'La carte est interactive. Consultez chaque cercle avec la souris pour connaître les xA de chaque passage'
      }
    },
    playerThreat: {
      step1: {
        title: 'SÉLECTION DE SAISONS',
        message: 'Ajoutez des saisons pour mesurer votre efficacité au tir'
      },
      step2: {
        title: 'LOCALISATION DE LA MENACE',
        message: 'Sélectionnez la possibilité d\'afficher l\'emplacement exact de la passe clé (cercle) ou par zone et zones de terrain (zones)'
      },
      step3: {
        title: 'ACTION ET RÉALISATION',
        message: 'Cochez et décochez en fonction du type d\'action et d\'achèvement que vous souhaitez afficher sur la carte'
      },
      step4: {
        title: 'MINUTES ET MENACE',
        message: 'Filtre par période, par minutes et par valeur de menace des actions'
      },
      step5: {
        title: 'FORMATS DE TÉLÉCHARGEMENT DES IMAGES',
        message: 'Trois formats de téléchargement sont disponibles png, svg et embed'
      },
      step6: {
        title: 'CARTE DES MENACES',
        message: 'La carte est interactive. Consultez chaque cercle avec la souris pour connaître la menace générée dans chaque jeu xT de chaque passe'
      }
    },
    playerTouches: {
      step1: {
        title: 'SÉLECTION DES JEUX ET DES ÉVÉNEMENTS',
        message: 'Sélectionnez le jeu et les événements que vous souhaitez afficher sur la carte'
      },
      step2: {
        title: 'TYPE D\'ÉVÉNEMENT',
        message: 'Cochez et décochez en fonction de la nature défensive ou offensive de l\'événement du joueur tout au long de la partie'
      },
      step3: {
        title: 'FILTRE D\'AFFICHAGE',
        message: 'Filtrer la carte en fonction des actions de base, de la carte thermique, des cercles ou des cases'
      },
      step4: {
        title: 'FORMATS DE TÉLÉCHARGEMENT DES IMAGES',
        message: 'Trois formats de téléchargement sont disponibles png, svg et embed'
      },
      step5: {
        title: 'CARTE TACTILE',
        message: 'La carte est interactive. Vous pouvez visualiser chaque événement en cliquant dessus'
      }
    },
    playerAllGames: {
      step1: {
        title: 'DISPONIBILITÉ',
        message: 'Vérifiez la disponibilité et le nombre de minutes jouées pour chaque match'
      },
      step2: {
        title: 'POSITIONS',
        message: 'Consulter les positions dans lesquelles il a joué lors de chaque match'
      }
    },
    playerInjuries: {
      step1: {
        title: 'HISTORIQUE ET JOURS PERDUS',
        message: 'Consultez les blessures de l\'année écoulée ou l\'historique complet et l\'éventail des blessures en fonction de leur durée en jours'
      },
      step2: {
        title: 'BLESSURES PAR CLUB',
        message: 'Consulter les blessures séparées par saison et/ou par club de sa trajectoire'
      }
    },
    playerInfo: {
      step1: {
        title: 'CARRIÈRE ET TRANSFERTS',
        message: 'Vous pouvez consulter l\'historique des minutes, des positions ou des disponibilités avec son club, avec son équipe nationale et les transferts du joueur tout au long de sa carriè'
      }
    },
    teamOverview: {
      step1: {
        title: 'FICHE D\'ÉQUIPE',
        message: 'Consulter les données de base de l\'équipe : âge moyen, formation de base, ELO ou solde des transferts.'
      },
      step2: {
        title: 'STATISTIQUES DE BASE',
        message: 'Consulter la possession, le xG, les tirs, le PPDA ou la verticalité'
      },
      step3: {
        title: 'RADAR ET SAISON',
        message: 'Sélectionner le radar, la saison et les matchs à domicile ou à l\'extérieur pour mesurer la performance de l\'équipe'
      },
      step4: {
        title: 'FILTRER PAR ENTRAÎNEUR ET PAR MATCH',
        message: 'Sélectionner les performances par étape pour chaque entraîneur'
      },
      step5: {
        title: 'RADAR DE PERFORMANCE',
        message: 'Le tableau est interactif, vous pouvez survoler chaque indicateur et obtenir sa définition'
      },
      step6: {
        title: 'FORMATS DE TÉLÉCHARGEMENT D\'IMAGES',
        message: 'Deux formats de téléchargement sont disponibles : png et svg'
      },
      step7: {
        title: 'CALENDRIER',
        message: 'Consulter le calendrier des matches de l\'équipe'
      },
      step8: {
        title: 'MEILLEURS JOUEURS SELON LES MÉTRIQUES',
        message: 'Dans ce panneau, vous pouvez sélectionner différents indicateurs et voir quels sont les joueurs les plus importants'
      },
      step9: {
        title: 'PROCHAIN MATCH ET BLESSURES',
        message: 'Vérifier le prochain adversaire et les joueurs blessés et suspendus de l\'équipe'
      },
      step10: {
        title: 'GRAPHIQUES ET TENDANCES',
        message: 'Visualiser différents graphiques pour les 10 ou 20 derniers matchs'
      }
    },
    teamRoster: {
      step1: {
        title: 'TYPE DE VUE',
        message: 'Consultez l\'effectif à partir de 6 catégories différentes : par poste, fin de contrat, âge, disponibilité, profil d\'âge et terrain'
      }
    },
    teamLoans: {
      step1: {
        title: 'JOUEURS DE PRÊTS',
        message: 'Consultez les joueurs prêtés à d\'autres équipes et leur poste de travail'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SAISON ET EFFECTIF',
        message: 'Filtrez par saison, radarisez l\'équipe et comparez avec les ligues de votre choix'
      },
      step2: {
        title: 'PERFORMANCE PAR MESURE',
        message: 'Voir où se situe l\'équipe dans chaque indicateur par rapport à toutes les équipes des ligues précédemment sélectionnées'
      },
      step3: {
        title: 'FORMATS DE TÉLÉCHARGEMENT D\'IMAGES',
        message: 'Trois formats de téléchargement sont disponibles : png, svg et embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SÉLECTION DE LA SAISON',
        message: 'Add seasons to measure shooting efficiencyAjouter des saisons pour mesurer l\'efficacité des tirs'
      },
      step2: {
        title: 'LA FINITION PROPRE OU CELLE DE L\'ADVERSAIRE',
        message: 'Choisissez si vous voulez voir la carte d\'achèvement de l\'équipe ou celle de tous ses adversaires.'
      },
      step3: {
        title: 'PLACEMENT DES TIRS',
        message: 'Sélectionnez la façon dont vous voulez voir les tirs de l\'équipe, par cercles ou par zones (cases).'
      },
      step4: {
        title: 'TYPE DE TIR',
        message: 'Filtrer par type de prise de vue, stratégie, zone ou partie du corps'
      },
      step5: {
        title: 'FILTRE MINUTES',
        message: 'Barre des minutes pour sélectionner les tirs et les buts marqués lors de périodes spécifiques du match'
      },
      step6: {
        title: 'FORMATS DE TÉLÉCHARGEMENT D\'IMAGES',
        message: 'Trois formats de téléchargement sont disponibles : png, svg et embed'
      },
      step7: {
        title: 'CARTE DES TIRS',
        message: 'La carte est interactive. Cochez chaque cercle avec la souris pour connaître le xG de chaque tir'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SÉLECTION DE LA SAISON',
        message: 'Ajouter des saisons pour mesurer l\'efficacité des tirs'
      },
      step2: {
        title: 'LES PASSEPORTS CLÉS PROPRES OU CONCURRENTS',
        message: 'Choisissez si vous voulez voir une carte des passes clés de l\'équipe ou de tous ses rivaux.'
      },
      step3: {
        title: 'EMPLACEMENT DU LAISSEZ-PASSER',
        message: 'Choisissez si vous voulez voir l\'emplacement exact du passe-partout (cercle) ou par zone et par champ (cases).'
      },
      step4: {
        title: 'TYPE DE FINITION APRÈS LE PASSAGE',
        message: 'Filtrer par type de tir, stratégie, zone ou partie du corps après une passe décisive'
      },
      step5: {
        title: 'FILTRE MINUTES',
        message: 'Barre des minutes pour sélectionner les tirs et les buts marqués lors de périodes spécifiques du match'
      },
      step6: {
        title: 'FORMATS DE TÉLÉCHARGEMENT D\'IMAGES',
        message: 'Trois formats de téléchargement sont disponibles : png, svg et embed'
      },
      step7: {
        title: 'CARTE DES TIRS',
        message: 'La carte est interactive. Consultez chaque cercle avec la souris pour connaître le xA de chaque passage'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'DERNIERS JEUX',
        message: 'Consulter les résultats, la possession, le xG et le % de victoire de tous les matchs de l\'équipe'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ARRIVÉES',
        message: 'Consulter toutes les arrivées (achats + transferts) par année civile'
      },
      step2: {
        title: 'DÉPARTS',
        message: 'Consulter tous les départs (ventes + transferts) par année civile'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TENDANCES',
        message: 'Interroger la forme de l\'équipe par le biais de séries, de victoires, d\'arrêts de jeu, de remontées, de périodes avec des buts ou des types de buts'
      },
      step2: {
        title: 'COUP DE PIED',
        message: 'Comparez les performances de l\'équipe entre les coups de pied arrêtés et les jeux ouverts et obtenez un aperçu détaillé des coups de pied arrêtés'
      },
      step3: {
        title: 'SUBSTITUTIONS',
        message: 'Voir quand l\'équipe effectue des remplacements et quels sont les joueurs qui sont le plus souvent remplacés'
      },
      step4: {
        title: 'CONNEXIONS',
        message: 'Consultez les connexions les plus courantes entre les joueurs. Filtrer par saison et par type de jeu'
      },
      step5: {
        title: 'ZONES D\'ATTAQUE',
        message: 'Découvrez les zones d\'attaque de l\'équipe et filtrez par saison ou type d\'attaque'
      },
      step6: {
        title: 'FORMATIONS',
        message: 'Consultez les formations les plus utilisées et leur pourcentage de victoires, de nuls et de défaites avec chacune d\'entre elles'
      },
      step7: {
        title: 'ZONES DE TIR',
        message: 'Filtre par saison, équipe ou adversaire, mode de visualisation de la carte, types de tirs ou minutes'
      },
      step8: {
        title: 'CROISEMENTS',
        message: 'Recherche et filtrage par saison, type d\'affichage, réussi ou raté, point de départ et d\'arrivée, ou encore coups de pied de coin'
      },
      step9: {
        title: 'JOUEURS',
        message: 'Filtre par saison, type d\'affichage, réussi ou non, d\'où ils partent et où ils finissent ou incluant les coups de pied de coin'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SAISONS ET MATCHES',
        message: 'Filtrer par saison, par match ou par match à domicile ou à l\'extérieur'
      },
      step2: {
        title: 'JOUEURS',
        message: 'Visualisez les performances de tous les joueurs de l\'équipe grâce à d\'innombrables indicateurs'
      }
    }
  },
  alerts: {
    numPlayers: 'Number of players',
    newPlayersLastWeek: 'New players last week',
    subtitle: 'Get alerts when new players meet your search criteria',
    generalSubtitle: 'Alertes sur les nouveaux joueurs en fonction de vos critères et nouvelles de vos joueurs préférés',
    subtitlePlayer: 'Recevez des alertes lorsque nous avons des nouvelles de vos joueurs préférés',
    subtitleSearch: 'Recevez des alertes lorsque de nouveaux joueurs correspondent à vos critères de recherche',
    favorite: 'Favori',
    newEventCalendar: 'Nouvel Événement',
    updatedEventCalendar: 'Événement Mis à Jour',
    newShareFrom: 'Nouveau Partage de',
    injuryAlert: 'Alerte de Blessure',
    contractAlert: 'Alerte de Contrat',
    teamAlert: 'Alerte de Signature',
    marketValueAlert: 'Alerte de Valeur Marchande',
    gameAlert: 'Alerte de Match Joué'
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Full game',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Search player, game or team...',
    subtitle: 'Analyze events through video',
    successful: 'Success',
    unsuccessful: 'Fail',
    playing: 'Playing',
    games: 'Games',
    moreFilters: 'More filters...',
    startArea: 'Start area',
    endArea: 'End area',
    select: 'Select',
    selectLastXGames: 'Select last {0} games',
    advancedFilters: 'Advanced Filters',
    freeKicks: 'Free Kicks',
    cornerKicks: 'Corner Kicks',
    allShots: 'All Shots',
    generateZip: 'Generate ZIP',
    zippedModalMessage: 'ZIP process has been started, could take some minutes. You would receive an email when is finished',
    clickToSeeVideo: 'Click to see video'
  },
  videoUpload: {
    subtitle: 'Upload video and create new game',
    uploadVideo: 'Upload video',
    selectPeriod: 'Select period',
    gameData: 'Game Data',
    venue: 'Venue',
    matchType: 'Match type',
    matchGroup: 'Match group',
    roundType: 'Round type',
    roundNumber: 'Round number',
    offsetFh: 'Offset First Half',
    offsetSh: 'Offset Second Half',
    offsetFhOT: 'Offset Overtime First Half',
    offsetShOT: 'Offset Overtime Second Half',
    homeLineup: 'Home Lineup',
    awayLineup: 'Away Lineup',
    existingPlayer: 'Existing player',
    newPlayer: 'New player',
    startingTeam: 'Starting',
    saveAndUpload: 'Save and upload',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: 'Vous avez téléchargé {0} jeux avec {1}. Votre limite est de {2}',
    requestedGames: 'Matchs demandés',
    limitClose: 'Il ne reste que {0} matchs à demander',
    limitReached: 'Vous avez atteint votre limite de téléversement de vidéos. Ajouter d\'autres matchs peut entraîner des frais supplémentaires.',
    seasonFinishedWarning: 'Cela créera un match dans une saison qui est déjà terminée. Veuillez vérifier que cela est correct.',
    teamCountryWarning: 'Cette équipe est d\'un pays différent de celui de la ligue choisie. Veuillez vérifier que cela est correct.',
    uploading: 'Téléchargement',
    doNotNavigateAway: 'Veuillez ne pas fermer cet onglet, actualiser la page ou quitter la page pendant que le téléchargement est en cours.',
    severalMinutes: 'Ce processus peut prendre plusieurs minutes.'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: 'Voir toutes les listes'
  },
  videoHighlights: {
    recap: 'Résumer',
    homeCondensed: 'Jeu condensé à domicile',
    awayCondensed: 'Match condensé à l\'extérieur',
    selectedActions: 'Actions sélectionnées',
    noActions: 'Aucune action ne correspond aux critères de filtre spécifiés',
    noGames: 'Aucun match n\'a encore été téléchargé',
    attackingActions: 'Actions offensives',
    defensiveActions: 'Actions défensives',
    groundDuels: 'Duels au sol',
    penaltiesProvoked: 'Penalties provoqués',
    goalkeeperActions: 'Actions du Gardien',
    addSomeGames: 'Commencez par ajouter des matchs !',
    goToVideoUploadTool: 'Aller à Charger des Vidéos',
    ballInPlay: 'Balle en jeu',
    filterSeasons: 'Filtrer les Saisons',
    streaming: 'Streaming',
    clips: 'Clips',
    qualifiers: {
      Pass: 'Passe',
      Save: 'Arrêt',
      'Saved Shot': 'Tir Sauvé',
      Shot: 'Tir',
      Goal: 'But',
      'Missed Shot': 'Tir Raté',
      'Shot on Post': 'Tir sur le Poteau',
      Error: 'Erreur',
      Clearance: 'Dégagement',
      Aerial: 'Duel Aérien',
      Challenge: 'Duel Perdu',
      Dispossessed: 'Perte de Balle',
      Foul: 'Faute',
      Card: 'Carton',
      'Offside Pass': 'Passe Hors-jeu',
      Claim: 'Ballon Capté',
      'Keeper Pickup': 'Ballon Ramassé',
      'Ball Touch': 'Toucher de Balle',
      Dribble: 'Dribble',
      Interception: 'Interception',
      Tackle: 'Tacle',
      'Ball Recovery': 'Récupération de Balle',
      Takeon: 'Dribble'
    },
    qualifierIds: {
      1: 'Passe longue',
      2: 'Centre',
      5: 'Coup franc direct',
      6: 'Corner',
      9: 'Penalty',
      15: 'De la tête',
      20: 'Pied droit',
      21: 'Autre partie du corps',
      22: 'Jeu ouvert',
      23: 'Contre-attaque',
      24: 'Coup de pied arrêté',
      25: 'Depuis le corner',
      26: 'Coup franc',
      28: 'But contre son camp',
      29: 'Assisté',
      31: 'Carton jaune',
      32: 'Deuxième carton jaune',
      33: 'Carton rouge',
      72: 'Pied gauche',
      73: 'Gauche',
      82: 'Tir arrêté (sans gardien)',
      94: 'Blocage défensif',
      123: 'Lancer du gardien',
      124: 'Six mètres',
      160: 'Touche',
      170: 'Menant à un but',
      173: 'Dégagement sûr',
      174: 'Dégagement dangereux',
      177: 'Ramassé',
      178: 'Debout',
      179: 'En plongeant',
      182: 'Mains',
      183: 'Pieds',
      185: 'Centre bloqué',
      210: 'Passe décisive',
      215: 'Action individuelle',
      279: 'Coup d\'envoi',
      285: 'Défensif',
      286: 'Offensif'
    },
    areas: {
      goalArea: 'Surface de But',
      boxLeft: 'Surface Gauche',
      boxCenter: 'Surface Centrale',
      boxRight: 'Surface Droite',
      outBoxDeepLeft: 'Hors Surface Profonde Gauche',
      outBoxDeepRight: 'Hors Surface Profonde Droite',
      outBoxLeft: 'Hors Surface Gauche',
      outBoxCentreLeft: 'Hors Surface Centre Gauche',
      outBoxCentre: 'Hors Surface Centrale',
      outBoxCentreRight: 'Hors Surface Centre Droite',
      outBoxRight: 'Hors Surface Droite',
      midfieldLeft35: 'Milieu de Terrain Gauche',
      midfieldCentreLeft35: 'Milieu de Terrain Centre Gauche',
      midfieldCentre35: 'Milieu de Terrain Central',
      midfieldCentreRight35: 'Milieu de Terrain Centre Droite',
      midfieldRight35: 'Milieu de Terrain Droite',
      ownGoalArea: 'Propre Surface de But',
      ownBoxLeft: 'Propre Surface Gauche',
      ownBoxCenter: 'Propre Surface Centrale',
      ownBoxRight: 'Propre Surface Droite',
      ownFieldOutOfBoxDeepLeft: 'Propre Terrain Hors Surface Profonde Gauche',
      ownFieldOutOfBoxDeepRight: 'Propre Terrain Hors Surface Profonde Droite',
      ownFieldOutOfBoxLeft: 'Propre Terrain Hors Surface Gauche',
      ownFieldOutOfBoxCentreLeft: 'Propre Terrain Hors Surface Centre Gauche',
      ownFieldOutOfBoxCentre: 'Propre Terrain Hors Surface Centrale',
      ownFieldOutOfBoxCentreRight: 'Propre Terrain Hors Surface Centre Droite',
      ownFieldOutOfBoxRight: 'Propre Terrain Hors Surface Droite',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Succès',
      fail: 'Échec',
      possessionWon: 'Possession Gagnée',
      possessionNotWon: 'Possession Non Gagnée',
      received: 'Reçu',
      provoked: 'Provoqué'
    },
    homePlayerHighlights: 'Faits saillants des joueurs locaux',
    awayPlayerHighlights: 'Faits saillants des joueurs extérieurs'
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: 'Reçu',
    fromMe: 'Envoyé',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: 'Partagés',
    subtitle: 'Aperçu des éléments dans votre liste de partage',
    selectUser: 'Sélectionner l\'utilisateur',
    expired: 'Expiré',
    limitReached: 'Le lien a atteint la limite d\'utilisation'
  },
  homeStats: {
    data: 'Données disponibles',
    players: 'joueurs',
    totalPlayers: 'nombre total de joueurs',
    teams: 'équipes',
    totalTeams: 'total des équipes',
    leagues: 'ligues',
    totalLeagues: 'total des ligues',
    seasons: 'saisons',
    totalSeasons: 'total des saisons',
    games: 'jeux',
    totalGames: 'total des matchs'
  },
  scoutingCalendar: {
    subtitle: 'Créez et organisez vos tâches de scouting',
    myCalendars: 'Calendrier privé',
    publicCalendars: 'Calendriers publics',
    otherCalendars: 'Autres calendriers',
    calendarSettings: 'Paramètres du calendrier',
    moreInfo: 'Plus d\'infos',
    individualScouting: 'Scouting Individuel',
    matchScouting: 'Scouting de Match',
    calendarView: {
      type: 'Type de calendrier',
      month: 'Mois',
      week: 'Semaine',
      day: 'Jour'
    },
    weekView: {
      type: 'Type de semaine',
      monSun: 'Lundi - Dimanche',
      sunSat: 'Dimanche - Samedi',
      monFri: 'Lundi - Vendredi'
    },
    tasks: {
      addNew: 'Ajouter une nouvelle tâche',
      myTasks: 'Mes tâches',
      filterTasks: 'Filtrer les tâches',
      sharedWithMe: 'Partagé avec moi',
      createTask: 'Créer une tâche',
      newTask: 'Nouvelle tâche',
      taskName: 'Nom de la tâche',
      allDay: 'Toute la journée',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      startHour: 'Heure de début',
      endHour: 'Heure de fin',
      assignedTo: 'Assigné à',
      assignedToMe: 'Assigné à moi',
      color: 'Couleur',
      scoutingType: 'Type de scouting',
      taskLocation: 'Emplacement de la tâche',
      selectLeague: 'Sélectionner une ligue',
      selectMatch: 'Sélectionner un match',
      useMatchdate: 'Utiliser la date du match comme date',
      stadium: 'Stade',
      travel: 'Voyage',
      hotel: 'Hôtel',
      tickets: 'Billets',
      taskNotes: 'Saisir des notes descriptives ou des commentaires liés à la tâche',
      states: {
        toDo: 'À faire',
        inProgress: 'En cours',
        done: 'Terminé'
      },
      type: {
        player: 'Évaluation du joueur',
        team: 'Évaluation de l\'équipe',
        other: 'Autre'
      },
      location: {
        stadium: 'Au stade',
        video: 'Vidéo'
      },
      accommodation: {
        accommodationDetails: 'Détails de l\'hébergement',
        ownArrangement: 'Arrangement personnel',
        required: 'Requis',
        notRequired: 'Non requis',
        booked: 'Réservé'
      },
      assignToMe: 'M\'assigner',
      addOther: 'Ajouter un autre',
      deleteTask: 'Supprimer la tâche',
      deleteTaskMessage: 'La tâche sera supprimée, êtes-vous sûr ?',
      cancelUpdate: 'Annuler la mise à jour',
      cancelUpdateMessage: 'Les modifications ne seront pas enregistrées, êtes-vous sûr ?',
      selectGame: 'Veuillez sélectionner un match pour ajouter des fichiers',
      noData: 'Pas de données. Commencez par ajouter des tâches !',
      widgetSubtitle: 'Consultez vos prochaines tâches',
      scoutingDetails: 'Détails du scouting',
      taskDetails: 'Détails de la tâche',
      playerDocuments: 'Documents du joueur',
      teamDocuments: 'Documents de l\'équipe',
      gameDocuments: 'Documents du match',
      taskDocuments: 'Documents de la tâche',
      task: 'Tâche'
    },
    nextGames: 'Prochains matchs'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Cette semaine',
      month: 'Ce mois',
      year: 'Cette année'
    },
    noTasks: 'Créez de nouvelles tâches ou glissez-en une ici!',
    goToBoard: 'Aller au board'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Personnalisez les détails de votre compte et de votre abonnement'
  },
  hub: {
    onlyHub: 'Disponible uniquement dans le Driblab Hub',
    blue: 'bleu',
    purple: 'violet',
    orange: 'orange',
    grey: 'gris',
    indigo: 'indigo',
    teal: 'sarcelle',
    lightBlue: 'bleu clair',
    brown: 'brun'
  },
  uploadedGames: {
    subtitle: 'All uploaded games',
    timeRequested: 'Time it was requested',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: 'Aller aux Matchs Téléchargés',
    sla: 'Accord de Niveau de Service',
    matchDate: 'Date du match',
    rejectedGame: 'Rejeté',
    reviewed: 'Révisé',
    requested: 'Demandé',
    koraStatus: 'Statut Kora',
    aws: 'AWS',
    fullVideo: 'Vidéo complète',
    offset: 'Décalage',
    updateFullVideo: 'Mettre à jour la vidéo complète ?'
  },
  gameMap: {
    title: 'Carte des Matchs',
    subtitle: 'Explorez les rencontres des prochains jours',
    warning: 'L\'heure et le lieu peuvent ne pas être corrects. Veuillez confirmer ces informations.',
    taskAdded: 'Tâche créée avec succès. Consultez le Scouting Calendar.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Notification envoyée avec succès',
    notPermissions: 'Vous n\'avez pas la permission de voir',
    notPermissionsLeague: 'Vous n\'avez pas la permission de voir cette ligue',
    notPermissionsGame: 'Vous n\'avez pas la permission de voir ce match',
    requestAccessTo: 'Demander l\'accès à',
    sendRequest: 'Envoyer la demande'
  },
  videoTeams: {
    subtitle: 'Trouvez les derniers matchs étiquetés par équipe',
    noGamesUploaded: 'Aucun match téléchargé pour le moment'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scouting Analyse',
    scoutingAnalyses: 'Scouting Analyses',
    playerScoutingAnalyses: 'Scouting Analyse Joueur',
    gameScoutingAnalyses: 'Scouting Analyse Match',
    analyses: 'Analyses',
    addReport: 'Ajouter une analyse',
    technical: 'Technique',
    tactical: 'Tactique',
    physical: 'Physique',
    mental: 'Psychologique',
    technicalNotes: 'Notes techniques',
    tacticalNotes: 'Notes tactiques',
    physicalNotes: 'Notes physiques',
    mentalNotes: 'Notes sur le profil psychologique',
    conclusion: 'Conclusion',
    charactersMax: 'Maximum 1000 caractères',
    globalRating: 'Évaluation globale',
    noData: 'Aucune donnée. Commencez par ajouter des analyses de scouting!',
    deleteAnalysis: 'Supprimer l\'analyse de scouting',
    deleteAnalysisMessage: 'L\'analyse sera supprimée définitivement. Êtes-vous sûr?',
    avgTooltip: 'Moyenne basée sur les évaluations finales des analyses visibles pour vous',
    avgOverallScoreTooltip: 'Moyenne basée sur les scores globaux du joueur visibles pour vous',
    scouter: 'Scouter',
    lastEdited: 'Dernière édition',
    analysisFilters: 'Filtres d\'Analyse',
    generalFilters: 'Filtres Généraux',
    widgetSubtitle: 'Dernières analyses ajoutées',
    addPlayerReport: 'Ajouter une analyse de scouting du joueur',
    seeReports: 'Voir les rapports',
    addGameReport: 'Ajouter une analyse de match',
    keyPlayers: 'Joueurs clés',
    formation: 'Formation',
    inPossession: 'En possession',
    notesIP: 'Notes en possession',
    outOfPossession: 'Sans possession',
    notesOP: 'Notes sans possession',
    transitions: 'Transitions',
    notesTransitions: 'Notes sur les transitions',
    notesSP: 'Notes sur les coups de pied arrêtés',
    finalRating: 'Note finale',
    gameNotesPlaceholder: 'Tapez des notes descriptives ou des commentaires sur le match',
    avgPotentialTooltip: 'Moyenne basée sur le potentiel d\'analyses visible pour vous',
    potential: 'Potentiel',
    tags: 'Balises',
    tagsPlaceholder: 'Ajoutez quelques balises',
    tagsHint: 'Tapez et appuyez sur Entrée pour ajouter une balise',
    exampleTags: {
      leadership: 'Direction',
      resilience: 'Résilience',
      competitiveMindset: 'Esprit compétitif',
      calmUnderPressure: 'Calme sous pression',
      focus: 'Se concentrer',
      discipline: 'Discipline',
      coachability: 'Coachabilité',
      poorBodyLanguage: 'Mauvais langage corporel',
      lowConfidence: 'Faible confiance',
      easilyFrustrated: 'Facilement frustré'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Créer une équipe sans ligue peut avoir un effet négatif sur son indexation et sa recherche ultérieure dans l\'application.'
  },
  expenses: {
    expense: 'Dépense',
    expenses: 'Dépenses',
    addExpense: 'Ajouter dépense',
    transportation: 'Transport',
    accommodation: 'Hébergement',
    dietary: 'Régime alimentaire',
    eventTicket: 'Billet d\'événement',
    expenseType: 'Type de dépense',
    amount: 'Montant',
    expenseDate: 'Date de dépense',
    expenseFilters: 'Filtres de dépenses',
    noData: 'Aucune donnée. Commencez par ajouter des dépenses!',
    deleteExpense: 'Supprimer la dépense',
    deleteExpenseMessage: 'La dépense sera supprimée définitivement. Êtes-vous sûr?'
  },
  disabledTooltips: {
    general: 'Cette fonctionnalité est actuellement désactivée',
    youth: 'Il doit être junior pour définir un âge',
    unit: 'La statistique doit être Runs, HSR ou SPR',
    seasonsWithout60MinsGames: 'Le joueur n\'a pas joué plus de 60 minutes dans un seul match lors de la/les saison(s) sélectionnée(s)',
    notEditable: 'Ceci ne peut pas être modifié',
    noMatchdate: 'Date de match non disponible',
    selectGame: 'Sélectionnez un match d\'abord',
    selectPlayer: 'Sélectionnez un joueur d\'abord',
    selectTeam: 'Sélectionnez une équipe d\'abord',
    selectBoxes: 'La visualisation des cases doit être sélectionnée',
    selectYear: 'Sélectionnez une année d\'abord',
    pdScoreNotAvailable: 'Score indisponible pour les joueurs n\'ayant pas disputé 60 minutes dans un match',
    pdSeasonNotAvailable: 'Données physiques non disponibles pour cette saison',
    pdGameNotAvailable: 'Données physiques non disponibles pour ce match'
  },
  leagueTypes: {
    regular: 'Régulier',
    continental: 'Continental',
    nationalTeam: 'Équipe Nationale',
    countryCup: 'Coupe Nationale',
    qualifier: 'Qualificatif',
    playOff: 'Play-Off',
    regionalLeague: 'Ligue Régionale',
    friendly: 'Amical',
    nationalFriendly: 'Amical National',
    nationaQualifier: 'Qualificatif National'
  },
  playerSides: {
    'Left/Right': 'Gauche/Droite',
    'Left/Centre/Right': 'Gauche/Centre/Droite',
    Right: 'Droite',
    Centre: 'Centre',
    'Centre/Right': 'Centre/Droite',
    Left: 'Gauche',
    'Left/Centre': 'Gauche/Centre'
  },
  areaSelector: {
    selectAreas: 'Sélectionner des zones',
    filterAreas: 'Filtrer les zones'
  },
  spatialCoverage: {
    lastDefenderDist: 'Distance du dernier défenseur',
    defensiveLineDist: 'Distance de la ligne défensive',
    fullBackAvgDist: 'Distance latérale moyenne',
    offensiveLineDist: 'Distance de la ligne offensive',
    distanceToGoal: 'Distance jusqu\'au but',
    avgLineWidth: 'Larg. moy. ligne',
    leagueAvgDistanceToGoal: 'Dist. moy. ligue au but',
    leagueAvgLineWidth: 'Larg. moy. ligne ligue',
    avgShort: 'Moy.',
    meters: 'mètres',
    leagueAvgDist: 'Distance moyenne de la ligue',
    distance: 'Distance',
    avgPositionYAxis: 'Dist. moy. sur le terrain (Y)',
    leagueAvgPositionYAxis: 'Dist. moy. ligue sur le terrain (Y)',
    lbRbDistanceSeparation: 'Distance LB–RB',
    leagueAvgLbRbDistanceSeparation: 'Dist. moy. ligue LB–RB',
    legendTeam: 'Équipe',
    legendLeagueAvg: 'Moy. Ligue',
    maxLength: 'Longueur maximale',
    maxWidth: 'Largeur maximale',
    avgBlockDistance: 'Moy. distance de bloc'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Données intelligentes',
    passesUnderPressureSubtitle: 'Analyser le taux de réussite des passes effectuées sous pression défensive',
    onBallPressureSubtitle: 'Analysez les événements de pression défensive et leur taux de succès par zones de terrain',
    ballReceiptsInSpaceSubtitle: 'Analyser les passes reçues dans l\'espace par zone de terrain',
    ballReceipts: 'recettes',
    totalBallReceipts: 'Total Réceptions en Espace',
    totalBallReceiptsCompleted: 'Total Réceptions en Espace Complétées',
    completed: 'Complétées',
    lineBreakingPassesSubtitle: 'Analysez les passes qui cassent les lignes et créent des avantages',
    bypassed: 'Contourné',
    oppsBypassed: 'Les adversaires ont été surclassés',
    passer: 'Passeur',
    passedTo: 'Passer à',
    receivedFrom: 'Reçu de',
    distanceToNearestDefender: 'Distance au défenseur le plus proche',
    lineBreaking: 'Saut de ligne {0}',
    keyPass: 'KeyPass',
    receiver: 'Récepteur',
    dynamicTracking: 'Suivi dynamique',
    eventLockTooltip: 'Certains joueurs ne sont pas visibles dans la partie',
    bypassedPlayers: '{0} joueurs dépassés',
    playersCount: '{0} joueurs',
    bothTeams: 'Les deux équipes',
    matchesCount: '{0} matchs',
    lbpType: {
      F: 'Ligne offensive',
      M: 'Ligne médiane',
      B: 'Ligne défensive',
      MF: 'Lignes médiane et offensive',
      BM: 'Lignes défensive et médiane',
      BF: 'Lignes défensive et offensive',
      BMF: 'Lignes défensive, médiane et offensive'
    },
    lbpCategory: {
      'G-IN-T': 'Au sol intérieur (brise la ligne défensive)',
      'G-IN-NT': 'Au sol intérieur (ne brise pas la ligne défensive)',
      'G-OUT-T': 'Au sol extérieur (brise la ligne défensive)',
      'G-OUT-NT': 'Au sol extérieur (ne brise pas la ligne défensive)',
      'O-IN-T': 'En l\'air intérieur (brise la ligne défensive)',
      'O-IN-NT': 'En l\'air intérieur (ne brise pas la ligne défensive)',
      'O-OUT-T': 'En l\'air extérieur (brise la ligne défensive)',
      'O-OUT-NT': 'En l\'air extérieur (ne brise pas la ligne défensive)',
      ground: 'Au sol',
      over: 'Par-dessus',
      inside: 'Intérieur',
      outside: 'Extérieur',
      through: 'Brise la ligne défensive',
      notThrough: 'Ne brise pas la ligne défensive',
      throughAbbr: 'Briser la déf. doubler',
      notThroughAbbr: 'Je ne casse pas la définition. doubler'
    },
    lbpCategorySplit: {
      G: 'Au sol : La passe était au sol',
      O: 'En l\'air : La passe était en l\'air',
      OUT: 'À l\'extérieur : La passe est passée à l\'extérieur',
      IN: 'À l\'intérieur : La passe est passée à l\'intérieur',
      T: 'Brise la ligne défensive : la passe brise la ligne défensive par l\'intérieur',
      NT: 'Ne brise pas la ligne défensive : la passe ne brise pas la ligne par l\'intérieur ; elle la contourne par l\'extérieur'
    },
    obrType: {
      OL: 'Chevauchement',
      UL: 'Sous-couche',
      RA: 'Courir devant',
      RB: 'Courir derrière',
      CR: 'Réception transversale',
      SP: 'Soutien',
      CS: 'À court'
    },
    visualization: 'Visualisation',
    points: 'Cercles',
    zones: 'Carte de Chaleur',
    pressureIntensity: 'Intensité de la pression',
    pressureOutcome: 'Résultat de la pression',
    passesOutcome: 'Résultat des Passes',
    strong: 'Fort',
    light: 'Léger',
    normal: 'Normal',
    successful: 'Réussi',
    unsuccessful: 'Non réussi',
    presses: 'Pressions',
    passes: 'Laissez-passer',
    passUnder: 'Passer Sous',
    successRate: 'Taux de réussite',
    pressureOn: 'Pression sur',
    pressureOf: 'Pression de',
    pressure: 'Pression',
    totalLabel: 'total',
    totalPasses: 'Total des Laissez-passer',
    unknown: 'inconnu',
    selectGameToViewMap: 'Sélectionnez un match pour voir la carte de pression',
    noEventsFoundForGame: 'Aucun événement de pression trouvé pour ce match',
    noEventsFoundForTeamAndSeason: 'Aucun événement de pression trouvé pour cette équipe et cette saison',
    noEventsFoundForPlayerAndSeason: 'Aucun événement de pression trouvé pour ce joueur et cette saison',
    noEventsMatchFilters: 'Aucun événement ne correspond aux filtres actuels',
    totalEventsAvailable: 'total des événements disponibles',
    passType: {
      P: 'Passer',
      A: 'Assister',
      KP: 'Passe-clé',
      PiOB: 'Passer en Opp. Boîte',
      PiFT: 'Passer dans le dernier tiers',
      SoPP: 'Changement de Play Pass'
    },
    minFrom: 'À partir de',
    minTo: 'Min à',
    secondFrom: 'Séparer de',
    secondTo: 'Segmenter vers',
    positionPlayed: 'Position jouée',
    highlight: 'Souligner',
    passTypeLabel: 'Type de laissez-passer',
    offBallRunSubtitle: 'Analyser les courses hors-ballon',
    insights: 'Connaissances',
    insightsSubtitle: 'Classer les meilleurs avec Advanced Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Comment puis-je vous aider aujourd\'hui ?',
    chatSubtext: 'Demandez n\'importe quoi sur les données du football !',
    thinking: 'Pensée...',
    giveFeedback: 'Donner votre avis',
    disclaimer: 'DriblabAI peut faire des erreurs. Veuillez vous assurer de vérifier les informations.',
    recent: 'Récent',
    noConversations: 'Ici, vous verrez vos conversations récentes !',
    rename: 'Rebaptiser',
    deleteConversation: 'Supprimer la conversation',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette conversation ?',
    feedback: 'Retour',
    feedbackQuestion: 'Cette réponse a-t-elle été utile ?',
    feedbackComments: 'Commentaires supplémentaires',
    feedbackPlaceholder: 'Dites-nous ce qui a été utile ou ce qui pourrait être amélioré...',
    errorMessage: 'Le message n\'a pas pu être traité. Veuillez réessayer.',
    newConversation: 'Nouvelle discussion',
    write: 'Écrire un message...'
  },
  periodId: {
    1: 'Première mi-temps',
    2: 'Deuxième mi-temps',
    3: 'Temps supplémentaire - 1º',
    4: 'Temps supplémentaire - 2º',
    5: 'Tirs au but',
    6: 'À temps plein',
    7: 'Avant-match',
    8: 'Abandonné',
    9: 'En direct',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Autre'
  }
};
